import React, { useContext, useState, useCallback, useEffect, useRef, useReducer, useMemo } from 'react';
import PropTypes, { string } from 'prop-types';
import Box from '@material-ui/core/Box';
import LoadingIndicator from '@scoir/components-core/dist/components/LoadingIndicator';
import get from 'lodash/get';
import noop from 'lodash/noop';
import AppBar from '@material-ui/core/AppBar';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import { PageTitle, Title as Title$2, SectionTitle } from '@scoir/headers';
import { useTheme, makeStyles } from '@material-ui/core/styles';
import { Metadata, TrackedImpression, useMetadata } from '@scoir/tracking';
import { ErrorBoundary } from '@scoir/error-reporter';
import size from 'lodash/size';
import pick from 'lodash/pick';
import isArray from 'lodash/isArray';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import produce from 'immer';
import debounce from 'lodash/debounce';
import CollegeCrest from '@scoir/college-crest';
import AvatarWithTitle, { Title as Title$1 } from '@scoir/avatar-with-title';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import { Link, Switch, Redirect, Route } from 'react-router-dom';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import cn from 'classnames';
import isObject from 'lodash/isObject';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBadgeCheck, faPlus, faFolderOpen, faUserEdit, faTools, faUniversity, faPlaceOfWorship, faBadge, faFileCertificate, faAward, faDiploma, faArrowUpRightFromSquare, faMapMarkerAlt, faPlane, faTrain, faBus, faCity, faCarBuilding, faHouse, faTree, faChevronUp, faChevronDown, faUserClock, faRandom, faCheck as faCheck$1, faTimes, faChevronRight, faAsterisk, faHandHoldingUsd, faMoneyCheckAlt, faPiggyBank, faRedo, faBuilding, faChild, faBaseball, faBasketballHoop, faVolleyballBall, faBowlingPins, faMegaphone, faCricket, faRunning, faGamepadAlt, faHorseSaddle, faSwords, faFieldHockey, faFootballBall, faGolfClub, faHockeySticks, faCircle, faWater, faBullseye, faSkullCow, faSkiing, faFutbol, faRacquet, faHandsHelping, faSwimmer, faMedal } from '@fortawesome/pro-solid-svg-icons';
import { Tooltip, Info } from '@scoir/tooltips';
import ReactDOMServer from 'react-dom/server';
import scriptjs from 'scriptjs';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import IconButton from '@material-ui/core/IconButton';
import { faLink, faVoteYea, faTachometerFastest, faTachometerFast, faTachometerAverage, faTachometerSlow, faTachometerSlowest, faStars, faMoonStars, faBullseyeArrow, faSmile, faSmileWink } from '@fortawesome/pro-regular-svg-icons';
import isString from 'lodash/isString';
import SvgIcon from '@material-ui/core/SvgIcon';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import { alpha } from '@material-ui/core/styles/colorManipulator';
import Collapse from '@material-ui/core/Collapse';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import orderBy from 'lodash/orderBy';
import isFunction from 'lodash/isFunction';
import isUndefined from 'lodash/isUndefined';
import constant from 'lodash/constant';
import { ComplexCard, LinkIcon, ExpandableContent } from '@scoir/card';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import AvatarWithFallback, { ICON_COLOR } from '@scoir/avatar';
import { imageAsFullImageSrc } from '@scoir/avatar-image-url';
import Lottie from 'react-lottie-player';
import reject from 'lodash/reject';
import { faCheck, faTimes as faTimes$1 } from '@fortawesome/pro-light-svg-icons';
import { Pill } from '@scoir/pills';
import set from 'lodash/set';
import concat from 'lodash/concat';
import isNumber from 'lodash/isNumber';
import isBoolean from 'lodash/isBoolean';
import forEach from 'lodash/forEach';
import { preferenceDisplayHelper } from '@scoir/college-search';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import { DataPoint, DATA_POINT_BLUE, DATA_POINT_WHITE } from '@scoir/data-point';
import sortBy from 'lodash/sortBy';
import includes from 'lodash/includes';
import isEqual from 'lodash/isEqual';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { GridAlignedCarousel } from '@scoir/carousels';
import useTheme$1 from '@material-ui/core/styles/useTheme';
import ToggleBox from '@scoir/components-core/dist/components/ToggleBox';
import CollegeHeading from '@scoir/college-heading';
import { ContentItemCard, getContentImageUrl, Event, CONTENT_TYPES, ContentItemModal } from '@scoir/college-content';
import Masonry from 'react-masonry-component';
import without from 'lodash/without';
import keyBy from 'lodash/keyBy';
import identity from 'lodash/identity';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox';
import slice from 'lodash/slice';
import take from 'lodash/take';
import round from 'lodash/round';
import TreeView from '@material-ui/lab/TreeView';
import keys from 'lodash/keys';
import some from 'lodash/some';
import TreeItem from '@material-ui/lab/TreeItem';
import isNull from 'lodash/isNull';
import Dialog from '@material-ui/core/Dialog';
import Toolbar from '@material-ui/core/Toolbar';
import Slide from '@material-ui/core/Slide';
import { format } from 'date-fns';
import Link$1 from '@material-ui/core/Link';
import AvatarGroup from '@material-ui/lab/AvatarGroup';
import replace from 'lodash/replace';
import { DismissibleDialog } from '@scoir/modals';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';

var Context$2 = /*#__PURE__*/React.createContext(null);

const useLocalContext = () => {
  const ctx = useContext(Context$2);
  if (ctx == null) {
    throw new Error('missing CollegeProfileContextWrapper');
  }
  return ctx;
};
const useScid = () => {
  const ctx = useLocalContext();
  return ctx.scid;
};
const useCurrentAppCycle = () => {
  const ctx = useLocalContext();
  return ctx.currentAppCycle;
};
const useTopNavigationHeightTrackerId = () => {
  const ctx = useLocalContext();
  return ctx.topNavigationHeightTrackerId;
};
const useLoading = () => {
  const ctx = useLocalContext();
  return get(ctx, 'loading', false);
};
const useHasCollege = () => {
  const ctx = useLocalContext();
  return get(ctx, 'hasCollege', false);
};
const useEventTracking = () => {
  const ctx = useLocalContext();
  return get(ctx, 'eventTracking', {});
};
const useOnContentPlayVideo = () => {
  const ctx = useLocalContext();
  return get(ctx, 'onContentPlayVideo');
};
const useGetEventsPath = () => {
  const ctx = useLocalContext();
  return get(ctx, 'getEventsPath', noop);
};
const useGetCollegesPath = () => {
  const ctx = useLocalContext();
  return get(ctx, 'getCollegesPath', noop);
};
const useIsUnauthed = () => {
  const ctx = useLocalContext();
  return get(ctx, 'isUnauthed', false);
};
const useOnCopyPageLink = () => {
  const ctx = useLocalContext();
  return get(ctx, 'onCopyPageLink', noop);
};

const LoadingState = _ref => {
  let {
    children
  } = _ref;
  const loading = useLoading();
  return !loading ? children : /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    height: "20vh",
    width: "100%",
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(LoadingIndicator, {
    size: "md",
    enabled: true
  }));
};
LoadingState.propTypes = {
  loading: PropTypes.bool,
  children: PropTypes.node
};

var window$1 = window;

const PROFILE_HEADER_HEIGHT_TRACKER_ID = 'college-profile-header';
const HEIGHT_OF_STICKY = 120;

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

const getDisplayName = WrappedComponent => WrappedComponent.displayName || WrappedComponent.name || 'Component';
const withContext = (WrappedComponent, Context, fields) => {
  const WrappedComponentWithContext = props => {
    const ctx = useContext(Context);
    const additionalProps = size(fields) ? pick(ctx, fields) : ctx;
    return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, additionalProps, props));
  };
  WrappedComponentWithContext.displayName = `WithContext(${getDisplayName(WrappedComponent)})`;
  return WrappedComponentWithContext;
};

const useBreakpoint = function () {
  let breakpoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'sm';
  let helper = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'only';
  // https://v4.mui.com/customization/breakpoints/#css-media-queries
  const theme = useTheme();
  const fn = theme.breakpoints[helper];
  let bp;
  if (helper === 'between' && isArray(breakpoint)) {
    bp = fn(...breakpoint);
  } else {
    bp = fn(breakpoint);
  }
  return useMediaQuery(bp);
};

var Context$1 = /*#__PURE__*/React.createContext(null);

const HeightTrackerContextWrapper = _ref => {
  let {
    children
  } = _ref;
  const [trackedHeights, setTrackedHeights] = useState({});
  const updateTrackedHeight = useCallback((id, height) => {
    if (trackedHeights[id] !== height) {
      const updatedTrackedHeights = produce(trackedHeights, draft => {
        draft[id] = height;
      });
      setTrackedHeights(updatedTrackedHeights);
    }
  }, [trackedHeights]);
  return /*#__PURE__*/React.createElement(Context$1.Provider, {
    value: {
      trackedHeights,
      updateTrackedHeight
    }
  }, children);
};
HeightTrackerContextWrapper.propTypes = {
  children: PropTypes.node
};

const useWindowEventListener = (eventType, fn) => {
  useEffect(() => {
    window.addEventListener(eventType, fn);
    return () => {
      window.removeEventListener(eventType, fn);
    };
  });
};

const useRefHeightOnLoad = (ref, callback) => {
  const fn = debounce(() => {
    if (ref.current !== null) {
      callback(ref.current.scrollHeight);
    }
  }, 500);
  useWindowEventListener('resize', fn);
  useEffect(fn, [ref, callback]);
};

const HeightTracker = _ref => {
  let {
    id,
    children,
    trackedHeights,
    updateTrackedHeight
  } = _ref;
  const trackerRef = useRef();
  useRefHeightOnLoad(trackerRef, height => {
    if (get(trackedHeights, id) !== height) {
      updateTrackedHeight(id, height);
    }
  });
  return /*#__PURE__*/React.createElement("div", {
    ref: trackerRef
  }, children);
};
HeightTracker.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node,
  updateTrackedHeight: PropTypes.func.isRequired,
  trackedHeights: PropTypes.object
};
var HeightTracker$1 = withContext(HeightTracker, Context$1);

const useHeightTrackerValue = id => {
  const {
    trackedHeights
  } = useContext(Context$1);
  return trackedHeights[id];
};

const CollegeAvatarWithTitle = _ref => {
  let {
    scid,
    title,
    children,
    avatarProps = {},
    titleComponent: TitleComponent = Title$1,
    titleComponentProps = {},
    additionalBodyProps,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(AvatarWithTitle, _extends({
    avatar: /*#__PURE__*/React.createElement(CollegeCrest, _extends({}, avatarProps, {
      "aria-label": title,
      scid: scid
    })),
    title: /*#__PURE__*/React.createElement(TitleComponent, titleComponentProps, title),
    additionalBodyProps: additionalBodyProps,
    ml: 2
  }, rest), children);
};
CollegeAvatarWithTitle.propTypes = {
  scid: PropTypes.number,
  title: PropTypes.string,
  children: PropTypes.any,
  titleComponent: PropTypes.any,
  titleComponentProps: PropTypes.object,
  avatarProps: PropTypes.object,
  additionalBodyProps: PropTypes.object
};

const ContentImpression = _ref => {
  let {
    contentId,
    ...rest
  } = _ref;
  const eventTracking = useEventTracking();
  const impressionType = get(eventTracking, 'domainTypeCollegeContent');
  return /*#__PURE__*/React.createElement(Metadata, {
    value: {
      ...get(eventTracking, 'content', {}),
      ...get(eventTracking, 'getContentId', noop)(contentId)
    }
  }, /*#__PURE__*/React.createElement(TrackedImpression, _extends({}, rest, {
    correlate: true,
    type: impressionType
  })));
};
ContentImpression.propTypes = {
  contentId: PropTypes.string.isRequired
};

const getIsProspectOnly = college => get(college, 'ProspectOnly', false);
const BREAKPOINT_ARGS = [['xs', 'sm'], 'between'];
const DefaultContentImpression = _ref => {
  let {
    children
  } = _ref;
  return children;
};
const CollegeProfileContextWrapper = _ref2 => {
  let {
    children,
    college,
    loaded,
    shouldTrackContentImpression,
    ...rest
  } = _ref2;
  const hasCollege = !isEmpty(college) || !loaded;
  const isProspectOnly = hasCollege && getIsProspectOnly(college);
  const [bullets, setBullets] = useState([]);
  return /*#__PURE__*/React.createElement(Context$2.Provider, {
    value: {
      college,
      hasCollege,
      isProspectOnly,
      responsiveBreakpointArgs: BREAKPOINT_ARGS,
      loaded,
      bullets,
      onLoadBullets: bullets => setBullets(bullets),
      contentImpressionComponent: shouldTrackContentImpression ? ContentImpression : DefaultContentImpression,
      ...rest
    }
  }, children);
};
CollegeProfileContextWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  sectionsConfiguration: PropTypes.object.isRequired,
  url: PropTypes.string.isRequired,
  section: PropTypes.string.isRequired,
  scid: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  loaded: PropTypes.bool.isRequired,
  isProspectOnly: PropTypes.bool.isRequired,
  college: PropTypes.object.isRequired,
  topNavigationHeightTrackerId: PropTypes.string.isRequired,
  getCollegesPath: PropTypes.func.isRequired,
  hostedRootPath: PropTypes.string.isRequired,
  getCollege: PropTypes.func.isRequired,
  getSessions: PropTypes.func.isRequired,
  getCollegeContent: PropTypes.func.isRequired,
  collegeCardProps: PropTypes.object,
  // this is to populate college cards for AffiliateColleges on overview page
  getSimilarColleges: PropTypes.func.isRequired,
  // used to get SimilarColleges on overview page
  getCollegeListAction: PropTypes.func,
  // used in SimilarCollege list
  getPrograms: PropTypes.func,
  // use in College Programs on overview Page
  shouldTrackContentImpression: PropTypes.bool,
  hasStartedApplying: PropTypes.bool.isRequired,
  onStartApplying: PropTypes.func,
  isInnerModalOpen: PropTypes.bool.isRequired,
  hideLocationMap: PropTypes.bool.isRequired,
  currentAppCycle: PropTypes.number.isRequired,
  onCopyPageLink: PropTypes.func,
  costAidHeader: PropTypes.element,
  // display a custom header element on cdp cost breakdown
  preferenceMatchContent: PropTypes.node // display optional content on preference match section
};

CollegeProfileContextWrapper.defaultProps = {
  loading: false,
  loaded: false,
  isProspectOnly: false,
  hasStartedApplying: false,
  isInnerModalOpen: false,
  hideLocationMap: false
};

const useStyles$J = makeStyles({
  clear: {
    color: 'inherit',
    textDecoration: 'inherit',
    outline: 'inherit',
    fontSize: 'inherit',
    fontWeight: 'inherit',
    lineHeight: 'inherit',
    margin: 'inherit',
    padding: 'inherit'
  },
  tab: {
    '&[aria-selected="true"]:hover': {
      outline: 'none'
    },
    '&[aria-selected="true"]:focus': {
      outline: 'none'
    },
    '&:hover': {
      textDecoration: 'none',
      outline: 'none'
    },
    '&:focus': {
      outline: 'none',
      textDecoration: 'none'
    }
  }
});
const Navigation = _ref => {
  let {
    section,
    sectionsConfiguration,
    collegesPath
  } = _ref;
  const {
    INDEX_BY_ENDPOINT,
    LABELS,
    SECTIONS
  } = sectionsConfiguration;
  const selectedIndex = INDEX_BY_ENDPOINT[section];
  const classes = useStyles$J();
  return /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(Tabs, {
    "aria-label": "College Profile Navigation",
    value: selectedIndex,
    indicatorColor: "primary",
    textColor: "primary",
    variant: "scrollable",
    id: "college-profile-nav",
    scrollButtons: "on"
  }, map(LABELS, (label, idx) => {
    const section = SECTIONS[idx].endpoint;
    return /*#__PURE__*/React.createElement(Tab, {
      key: label,
      to: `${collegesPath}/${section}`,
      label: /*#__PURE__*/React.createElement("h2", {
        className: classes.clear
      }, label),
      component: Link,
      tabIndex: 0,
      className: classes.tab,
      id: `college-profile-nav-tab-${idx}`,
      "aria-label": `Click to view ${label}`,
      "aria-controls": `college-profile-nav`
    });
  })));
};
Navigation.propTypes = {
  collegesPath: PropTypes.string,
  section: PropTypes.string,
  sectionsConfiguration: PropTypes.object
};

const GeographicLocation = _ref => {
  let {
    city,
    state,
    country,
    component: Component = 'div',
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(Component, rest, city, !isEmpty(city) && (!isEmpty(state) || !isEmpty(country)) && ', ', !isEmpty(state) ? state : country);
};
GeographicLocation.propTypes = {
  city: PropTypes.string,
  state: PropTypes.string,
  country: PropTypes.string,
  component: PropTypes.string
};

const Location$2 = _ref => {
  let {
    city,
    state,
    country
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    display: "block",
    component: "span",
    textAlign: "left",
    pl: 2
  }, /*#__PURE__*/React.createElement(GeographicLocation, {
    city: city,
    state: state,
    country: country,
    component: "span"
  }));
};
Location$2.propTypes = {
  city: PropTypes.string,
  state: PropTypes.string,
  country: PropTypes.string
};

const useStyles$I = makeStyles(() => ({
  root: {
    display: 'block',
    width: width => width,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
  }
}));
const getWidth = cur => isObject(cur) ? `${cur.offsetWidth}px` : 'auto';
const TruncateText = _ref => {
  let {
    className,
    ...rest
  } = _ref;
  const ref = useRef();
  const width = getWidth(ref.current);
  const classes = useStyles$I({
    width
  });
  return /*#__PURE__*/React.createElement("span", _extends({}, rest, {
    className: cn(className, classes.root),
    ref: ref
  }));
};
TruncateText.propTypes = {
  className: PropTypes.string
};

const useStyles$H = makeStyles(theme => {
  return {
    icon: {
      height: '16px',
      maxWidth: '0.5em',
      color: theme.palette.success.light,
      display: 'block',
      marginLeft: theme.spacing(1)
    },
    largeIcon: {
      height: '28px'
    },
    wrapper: {
      position: 'absolute',
      marginTop: theme.spacing(-1),
      bottom: '0.45em'
    },
    noMaxWidth: {
      maxWidth: 'none'
    },
    [theme.breakpoints.down('sm')]: {
      icon: {
        marginLeft: 0
      }
    }
  };
});
const Verified = _ref => {
  let {
    isLarge
  } = _ref;
  const classes = useStyles$H();
  return /*#__PURE__*/React.createElement(Tooltip, {
    placement: "top",
    title: "This profile information has been verified by the college.",
    classes: {
      tooltip: classes.noMaxWidth
    }
  }, /*#__PURE__*/React.createElement(Box, {
    component: "span",
    display: "inline-block",
    className: classes.wrapper
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    size: "lg",
    icon: faBadgeCheck,
    className: cn(classes.icon, {
      [classes.largeIcon]: isLarge
    })
  })));
};
Verified.propTypes = {
  isLarge: PropTypes.bool
};

const Title = _ref => {
  let {
    name,
    isVerified,
    shouldTruncate,
    verifiedLarge,
    className,
    section,
    component = 'h1'
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    className: className,
    display: "block",
    component: component,
    maxWidth: "720px",
    textAlign: "left",
    position: "relative",
    pl: 2,
    width: shouldTruncate ? 'calc(100vw - 210px)' : 'auto'
  }, shouldTruncate ? /*#__PURE__*/React.createElement(TruncateText, null, name) : name, /*#__PURE__*/React.createElement(Box, {
    component: "span",
    position: "absolute",
    pointerEvents: "none",
    height: '0px',
    width: '0px',
    display: "inline-block",
    overflow: "hidden"
  }, section), isVerified && /*#__PURE__*/React.createElement(Verified, {
    isLarge: verifiedLarge
  }));
};
Title.propTypes = {
  name: PropTypes.string,
  section: PropTypes.string,
  isVerified: PropTypes.bool,
  verifiedLarge: PropTypes.bool,
  shouldTruncate: PropTypes.bool,
  className: PropTypes.string,
  component: PropTypes.string
};

const useCallbackOnMount = (callback, dependencies) => {
  useEffect(callback, dependencies);
};

const YouVisitLink = _ref => {
  let {
    iped
  } = _ref;
  return /*#__PURE__*/React.createElement("a", {
    href: "http://www.youvisit.com",
    className: "virtualtour_embed",
    title: "Virtual Reality, Virtual Tour",
    "data-remove-prompts": "1",
    "data-remove-registration": "1",
    "data-link-type": "immersive",
    "data-iped": iped,
    "data-image-width": "100%",
    "data-image-height": "100%",
    "data-platform": "scoir"
  }, "Virtual Tour");
};
YouVisitLink.propTypes = {
  iped: PropTypes.string.isRequired
};

const loadScript = fn => scriptjs('https://www.youvisit.com/tour/Embed/js2.js', () => {
  const yvObj = window.YVScript;
  yvObj && fn(yvObj);
});
const YouVisitTour = _ref => {
  let {
    iped
  } = _ref;
  const scan = useCallback(() => {
    loadScript(yv => yv.scanEmbeds ? yv.scanEmbeds() : undefined);
  }, []);
  const closeHover = useCallback(() => {
    loadScript(yv => yv.closeHover ? yv.closeHover() : undefined);
  }, []);
  useCallbackOnMount(() => {
    scan();
    return closeHover;
  }, [iped]);
  return iped ? /*#__PURE__*/React.createElement("div", {
    style: {
      height: '100%'
    },
    dangerouslySetInnerHTML: {
      __html: ReactDOMServer.renderToStaticMarkup( /*#__PURE__*/React.createElement(YouVisitLink, {
        iped: iped
      }))
    }
  }) : null;
};
YouVisitTour.propTypes = {
  iped: PropTypes.string
};

const useLoaded = _ref => {
  let {
    src
  } = _ref;
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    if (!src) {
      return undefined;
    }
    setLoaded(false);
    let active = true;
    const image = new Image();
    image.src = src;
    image.onload = () => {
      if (!active) {
        return;
      }
      setLoaded('loaded');
    };
    image.onerror = () => {
      if (!active) {
        return;
      }
      setLoaded('error');
    };
    return () => {
      active = false;
    };
  }, [src]);
  return loaded;
};
const useStyles$G = makeStyles({
  root: {
    zIndex: 0,
    width: '100%',
    height: '100%',
    position: 'absolute'
  },
  inner: {
    background: _ref2 => {
      let {
        url
      } = _ref2;
      return `url(${url}) center center / cover no-repeat`;
    },
    height: '100%',
    width: '100%',
    maxWidth: '100%',
    maxHeight: '100%',
    position: 'relative',
    zIndex: 2
  }
});
const heroResolver = scid => {
  if (scid === undefined) {
    return undefined;
  }
  // @ts-expect-error COLLEGE_IMAGE_ENDPOINT is defined by consumers on window :vomit:
  const root = window.COLLEGE_IMAGE_ENDPOINT || 'https://s3.amazonaws.com/scoir_static/assets/colleges/images';
  return `${root}/${scid}-hero.png`;
};
const HeroImage = _ref3 => {
  let {
    scid,
    alt = 'College Hero Image'
  } = _ref3;
  const src = heroResolver(scid);
  const loaded = useLoaded({
    src
  });
  let resolvedSrc = src;
  if (src === undefined || loaded === 'error') {
    resolvedSrc = heroResolver('college');
  }
  const classes = useStyles$G({
    url: resolvedSrc
  });
  if (loaded === false) {
    return null;
  }
  return jsx("div", {
    className: classes.root,
    children: jsx("div", {
      className: classes.inner
    })
  });
};

const useStyles$F = makeStyles({
  root: {
    height: props => get(props, 'height', '300px'),
    backgroundColor: '#f3f3f3',
    zIndex: 8,
    position: 'relative'
  }
});
const HeroImageOrTour = _ref => {
  let {
    height,
    scid,
    college = {},
    hasCollege
  } = _ref;
  const classes = useStyles$F({
    height
  });
  return !hasCollege ? null : /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(HeroImage, {
    scid: scid
  }), /*#__PURE__*/React.createElement(YouVisitTour, {
    iped: college.Iped
  }));
};
HeroImageOrTour.propTypes = {
  college: PropTypes.object,
  hasCollege: PropTypes.bool,
  height: PropTypes.string,
  scid: PropTypes.number.isRequired
};
var HeroImageOrTour$1 = withContext(HeroImageOrTour, Context$2);

/**
 *
 * @param {number} milliseconds
 * @returns { onOpen: () => void, open: boolean }
 */
const useOpenTimer = function () {
  let milliseconds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 250;
  const [open, setOpen] = useState(false);
  let timer = useRef();
  const onOpen = useCallback(() => {
    if (timer.current) {
      clearTimeout(timer.current);
    }
    setOpen(true);
    timer.current = setTimeout(() => {
      setOpen(false);
    }, milliseconds);
  }, [milliseconds]);
  return {
    onOpen,
    open
  };
};

const DEFAULT_TOOLTIP_HOVERED = 'Copy link to school';
const DEFAULT_TOOLTIP_CLICKED = 'Link copied to clipboard';
const DEFAULT_TOOLTIP_DELAY = 2000;

/**
 *
 * @param {string} title
 * @returns CopyCurrentUrl button with tooltip
 */
const CopyCurrentUrl = _ref => {
  let {
    title,
    ...rest
  } = _ref;
  const {
    open,
    onOpen
  } = useOpenTimer(DEFAULT_TOOLTIP_DELAY);
  const [hovering, setHovering] = useState(false);
  const tooltip = open ? DEFAULT_TOOLTIP_CLICKED : DEFAULT_TOOLTIP_HOVERED;
  const onCopyPageLink = useOnCopyPageLink();
  const [getMetadata] = useMetadata();
  return /*#__PURE__*/React.createElement(Box, {
    title: title,
    "aria-label": title,
    display: "inline-block"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    open: open || hovering,
    title: tooltip
  }, /*#__PURE__*/React.createElement(IconButton, _extends({
    color: "primary",
    size: "small"
  }, rest, {
    onClick: () => {
      onOpen();
      const href = window$1.location.href;
      if (onCopyPageLink) onCopyPageLink(href, getMetadata());
      if (!window$1.isSecureContext) {
        console.warn('Copy to clipboard is not supported in http context... use https instead.'); // eslint-disable-line no-console
        return;
      }
      window$1.navigator.clipboard.writeText(href);
    },
    onMouseEnter: () => setHovering(true),
    onMouseLeave: () => setHovering(false)
  }), /*#__PURE__*/React.createElement(Box, {
    p: 1,
    height: "36px",
    width: "36px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faLink
  })))));
};
CopyCurrentUrl.propTypes = {
  title: PropTypes.string
};

const PRIVATE_NOTFORPROFIT = 'Private, Not For-Profit';
const PRIVATE_NOTFORPROFIT_DESC = 'A private, not for-profit college is funded from a variety of sources such as government, tuition, fees, and donations. These institutions channel funds back into educational programs in order to fulfill an education mission.';
const PRIVATE_PROPRIETARY = 'Private, Proprietary';
const PRIVATE_PROPRIETARY_DESC = 'Private Proprietary colleges are profit-seeking and independently funded.';
const PRIVATE_FORPROFIT = 'Private, For-Profit';
const PRIVATE_FORPROFIT_DESC = 'A private, for-profit college is owned and funded by a private company or business. These institutions seek to generate profit for a non-educational use. Usually, they do not receive state or federal aid, and offer career-based or occupational programs.';
const PUBLIC = 'Public';
const PUBLIC_DESC = 'Public colleges are funded by the state and federal government. Generally, public colleges have lower cost of attendance (depending on your home residence), more academic majors, and more research opportunities, while having less money available for grants and scholarships.';
const getSchoolType = college => {
  const oldAlternatePrivateNotForProfit = 'Private (nonprofit)';
  const alternatePrivateNotForProfit = 'Private - Not For-profit';
  const realPrivateNotForProfit = 'Private Not For-Profit';
  const rawSchoolType = get(college, 'GeneralInfo.PublicPrivate', '');
  const type = rawSchoolType.replace(alternatePrivateNotForProfit, realPrivateNotForProfit).replace(oldAlternatePrivateNotForProfit, realPrivateNotForProfit);
  var hasSchoolType = !isEmpty(rawSchoolType) && rawSchoolType != 'Not applicable';
  var schoolTypeDescription = '';
  var schoolType = '';
  if (hasSchoolType) {
    if (type == realPrivateNotForProfit) {
      schoolType = PRIVATE_NOTFORPROFIT;
      schoolTypeDescription = PRIVATE_NOTFORPROFIT_DESC;
    } else if (type == 'Private (proprietary)') {
      schoolType = PRIVATE_PROPRIETARY;
      schoolTypeDescription = PRIVATE_PROPRIETARY_DESC;
    } else if (type == 'Private - For-profit') {
      schoolType = PRIVATE_FORPROFIT;
      schoolTypeDescription = PRIVATE_FORPROFIT_DESC;
    } else if (type == 'Public') {
      schoolType = PUBLIC;
      schoolTypeDescription = PUBLIC_DESC;
    }
  }
  if (isEmpty(schoolTypeDescription)) {
    hasSchoolType = false;
  }
  return {
    schoolType,
    rawSchoolType,
    schoolTypeDescription,
    hasSchoolType
  };
};

const useStyles$E = makeStyles(() => {
  return {
    root: {
      fontSize: '1em'
    }
  };
});
const ScoirApplyIcon = () => {
  const classes = useStyles$E();
  return /*#__PURE__*/React.createElement(SvgIcon, {
    classes: {
      root: classes.root
    },
    height: "1em",
    width: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
    fill: "#C3E369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2422 13.0859L10.2656 18.3125C10.1016 18.4531 9.91406 18.5 9.75 18.5C9.58594 18.5 9.42188 18.4531 9.30469 18.3594C9.02344 18.1719 8.90625 17.7969 9.04688 17.4688L10.8516 13.25H8.25C7.92188 13.25 7.64062 13.0625 7.54688 12.7812C7.42969 12.4766 7.5 12.1484 7.73438 11.9375L13.7344 6.71094C13.9922 6.47656 14.3672 6.47656 14.6484 6.6875C14.9531 6.875 15.0469 7.25 14.9062 7.57812L13.1016 11.7734H15.7266C16.0312 11.7734 16.3125 11.9844 16.4297 12.2656C16.5469 12.5469 16.4766 12.875 16.2422 13.0859Z",
    fill: "white"
  }));
};

var img$4 = "data:image/png;base64,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";

const useStyles$D = makeStyles(() => {
  return {
    icon: {
      width: '18px',
      height: '18px'
    }
  };
});
const CoalitionAppIcon = () => {
  const classes = useStyles$D();
  return /*#__PURE__*/React.createElement(Avatar, {
    className: classes.icon,
    src: img$4
  });
};

const useStyles$C = makeStyles(theme => {
  const info = get(theme, 'palette.info', {});
  const infoDark = info.dark;
  const infoMain = info.main;
  const secondary = get(theme, 'palette.secondary', {});
  const secondaryDark = secondary.dark;
  const secondaryMain = secondary.main;
  return {
    tagButton: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    },
    tagButtonInfo: {
      color: infoDark,
      background: alpha(infoMain, 0.08),
      '&:hover': {
        color: infoDark,
        background: alpha(infoMain, 0.2)
      }
    },
    tagButtonSecondary: {
      background: alpha(secondaryMain, 0.08),
      color: secondaryDark,
      '&:hover': {
        color: secondaryDark,
        background: alpha(secondaryMain, 0.16)
      }
    },
    iconSizeLarge: {
      height: '0.8em',
      width: '0.8em',
      '& *:first-child': {
        fontSize: '18px'
      }
    }
  };
});
const TagButton = _ref => {
  let {
    icon,
    faIcon,
    className,
    colorStyle = 'info',
    to,
    children
  } = _ref;
  const classes = useStyles$C();
  const wrappedFaIcon = faIcon ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faIcon
  }) : undefined;
  const startIcon = icon || wrappedFaIcon;
  return /*#__PURE__*/React.createElement(Box, {
    m: 0.5,
    display: "inline-block"
  }, /*#__PURE__*/React.createElement(Button, {
    startIcon: startIcon,
    component: Link,
    to: to,
    size: "large",
    classes: {
      iconSizeLarge: classes.iconSizeLarge
    },
    className: cn(className, classes.tagButton, {
      [classes.tagButtonSecondary]: colorStyle === 'secondary',
      [classes.tagButtonInfo]: colorStyle === 'info'
    })
  }, children));
};
TagButton.propTypes = {
  icon: PropTypes.any,
  faIcon: PropTypes.any,
  className: PropTypes.string,
  colorStyle: PropTypes.oneOf(['secondary', 'info']),
  to: PropTypes.string,
  children: PropTypes.node
};

const getSelectivityLabel = (selectivity, selectivityLabels) => {
  if (selectivity < 1) {
    return '';
  }
  switch (selectivity) {
    case 1:
      return get(selectivityLabels, 'Open', 'Open Admission');
    case 2:
      return get(selectivityLabels, 'Somewhat', 'Somewhat Selective');
    case 3:
      return get(selectivityLabels, 'Selective', 'Selective');
    case 4:
      return get(selectivityLabels, 'Very', 'Very Selective');
    case 5:
      return get(selectivityLabels, 'Highly', 'Highly Selective');
    case 6:
      return get(selectivityLabels, 'Most', 'Most Selective');
    default:
      return '';
  }
};
const getCollegeMatchLevel = (collegeMatchLevel, collegeSelectivity) => {
  const matchLevel = collegeMatchLevel - collegeSelectivity;
  if (matchLevel >= 2) {
    return 1;
  } else if (matchLevel === 1) {
    return 2;
  } else if (matchLevel === 0) {
    return 3;
  } else if (matchLevel === -1) {
    return 4;
  } else if (matchLevel <= -2) {
    return 5;
  }
  return 0;
};
const getCollegeMatchLabel = (collegeMatchLevel, collegeSelectivity, acceptanceLikelihoodLabels) => {
  if (collegeMatchLevel === 0) {
    return '';
  }
  const matchLevel = getCollegeMatchLevel(collegeMatchLevel, collegeSelectivity);
  const labels = {
    0: '',
    1: get(acceptanceLikelihoodLabels, 'VeryLikely', 'Very Likely'),
    2: get(acceptanceLikelihoodLabels, 'Likely', 'Likely'),
    3: get(acceptanceLikelihoodLabels, 'Level', 'Level'),
    4: get(acceptanceLikelihoodLabels, 'Reach', 'Reach'),
    5: get(acceptanceLikelihoodLabels, 'FarReach', 'Far Reach')
  };
  return labels[matchLevel];
};
const selectivityIcons = {
  1: faVoteYea,
  2: faTachometerFastest,
  3: faTachometerFast,
  4: faTachometerAverage,
  5: faTachometerSlow,
  6: faTachometerSlowest
};
const acceptanceLikelihoodIcons = {
  5: faStars,
  4: faMoonStars,
  3: faBullseyeArrow,
  2: faSmile,
  1: faSmileWink
};
const getSelectivityIcon = selectivity => {
  return selectivityIcons[selectivity];
};
const getAcceptanceLikelihoodIcon = (collegeMatchLevel, selectivity) => {
  const level = getCollegeMatchLevel(collegeMatchLevel, selectivity);
  return acceptanceLikelihoodIcons[level];
};
const getUnivType$1 = function (college) {
  let isTnTSearchFilterEnabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const UNIV_TYPES = {
    '2 year': {
      label: '2-Year',
      filter: 'TWO_YEAR_US'
    },
    '4 year': {
      label: '4-Year',
      filter: 'FOUR_YEAR_US'
    }
  };
  const univTypeValue = get(college, 'GeneralInfo.UnivType');
  const univType = get(UNIV_TYPES, univTypeValue, {});
  return {
    univTypeLabel: univType.label,
    univTypeFilter: univType.filter,
    hasUnivType: univType.label && univType.filter && isTnTSearchFilterEnabled
  };
};

const useStyles$B = makeStyles(() => {
  return {
    pillBox: {
      '&:empty': {
        padding: 0
      }
    }
  };
});
const HeaderPills = _ref => {
  let {
    selectivity = 0,
    collegeMatchLevel = 0,
    acceptanceLikelihoodLabels,
    selectivityLabels,
    college,
    hostedRootPath,
    searchPath,
    isTnTSearchFilterEnabled = false
  } = _ref;
  const classes = useStyles$B();
  const scoirApplyEnabled = get(college, 'DisplayAsScoirApply', false);
  const coalitionMember = get(college, 'CoalitionMember', false);
  const {
    schoolType,
    rawSchoolType,
    hasSchoolType
  } = getSchoolType(college);
  const setting = get(college, 'Setting');
  const hasSetting = isString(setting) && !isEmpty(setting) && setting.toLowerCase() !== 'not available';
  const religious = get(college, 'GeneralInfo.OthRelig');
  const hasReligious = !isEmpty(religious) && religious !== 'Not applicable';
  const hbcu = get(college, 'GeneralInfo.HBCU');
  const hasHbcu = hbcu === true;
  const hasSelectivity = selectivity > 0;
  const hasCollegeMatchLevel = collegeMatchLevel > 0;
  const {
    univTypeLabel,
    univTypeFilter,
    hasUnivType
  } = getUnivType$1(college, isTnTSearchFilterEnabled);
  const hasCareerAndTrade = get(college, 'GeneralInfo.SchoolClassifier') === 'CareerAndTrade';
  const showCareerAndTrade = hasCareerAndTrade && isTnTSearchFilterEnabled;
  const hasPills = hasSelectivity || hasCollegeMatchLevel || scoirApplyEnabled || coalitionMember || hasUnivType || showCareerAndTrade || hasSchoolType || hasSetting || hasReligious || hasHbcu;
  const selectivityIcon = hasSelectivity && getSelectivityIcon(selectivity);
  const acceptanceLikelihoodIcon = hasCollegeMatchLevel && getAcceptanceLikelihoodIcon(collegeMatchLevel, selectivity);
  const acceptanceLikelihood = getCollegeMatchLevel(collegeMatchLevel, selectivity);
  return !hasPills ? null : /*#__PURE__*/React.createElement(Box, {
    mt: 3,
    className: classes.pillBox
  }, !hasSelectivity || hasCollegeMatchLevel ? null : /*#__PURE__*/React.createElement(TagButton, {
    faIcon: selectivityIcon,
    to: `${hostedRootPath}${searchPath}?selectivityLevel=${selectivity}`
  }, getSelectivityLabel(selectivity, selectivityLabels)), !hasCollegeMatchLevel ? null : /*#__PURE__*/React.createElement(TagButton, {
    faIcon: acceptanceLikelihoodIcon,
    to: `${hostedRootPath}${searchPath}?acceptanceLikelihood=${acceptanceLikelihood}`,
    colorStyle: 'secondary'
  }, getCollegeMatchLabel(collegeMatchLevel, selectivity, acceptanceLikelihoodLabels)), !scoirApplyEnabled ? null : /*#__PURE__*/React.createElement(TagButton, {
    icon: /*#__PURE__*/React.createElement(ScoirApplyIcon, null),
    to: `${hostedRootPath}${searchPath}?predefinedFilters=APPLY_WITH_SCOIR`
  }, "Apply with Scoir"), !coalitionMember ? null : /*#__PURE__*/React.createElement(TagButton, {
    icon: /*#__PURE__*/React.createElement(CoalitionAppIcon, null),
    to: `${hostedRootPath}${searchPath}?predefinedFilters=COALITION_MEMBER`
  }, "Coalition for College"), !hasUnivType ? null : /*#__PURE__*/React.createElement(TagButton, {
    to: `${hostedRootPath}${searchPath}?predefinedFilters=${univTypeFilter}`
  }, univTypeLabel), !showCareerAndTrade ? null : /*#__PURE__*/React.createElement(TagButton, {
    to: `${hostedRootPath}${searchPath}?predefinedFilters=CAREER_AND_TRADE`
  }, "Career & Trade"), !hasSchoolType ? null : /*#__PURE__*/React.createElement(TagButton, {
    to: `${hostedRootPath}${searchPath}?publicPrivate=${rawSchoolType}`
  }, schoolType), !hasSetting ? null : /*#__PURE__*/React.createElement(TagButton, {
    to: `${hostedRootPath}${searchPath}?setting=${setting}`
  }, setting), !hasReligious ? null : /*#__PURE__*/React.createElement(TagButton, {
    to: `${hostedRootPath}${searchPath}?religious=${religious}`
  }, religious), !hasHbcu ? null : /*#__PURE__*/React.createElement(TagButton, {
    to: `${hostedRootPath}${searchPath}?minorityServingInst=HBCU`
  }, "HBCU"));
};
HeaderPills.propTypes = {
  selectivity: PropTypes.number,
  collegeMatchLevel: PropTypes.number,
  acceptanceLikelihoodLabels: PropTypes.object,
  selectivityLabels: PropTypes.object,
  college: PropTypes.object,
  hostedRootPath: PropTypes.string.isRequired,
  searchPath: PropTypes.string.isRequired,
  isTnTSearchFilterEnabled: PropTypes.bool
};
HeaderPills.defaultProps = {
  selectivity: 0,
  collegeMatchLevel: 0
};
var HeaderPills$1 = withContext(HeaderPills, Context$2);

const getHeroHeight = (isXs, isResponsiveSize) => isXs ? '100px' : isResponsiveSize ? '150px' : '300px';
const useStyles$A = makeStyles(theme => ({
  container: {
    zIndex: 0,
    position: 'relative',
    overflow: 'hidden'
  },
  actionsWrapper: {
    display: 'flex',
    flexDirection: 'row',
    textAlign: 'left',
    justifyContent: 'flex-end',
    marginLeft: `${theme.spacing(3)}px`,
    '& > button': {
      marginRight: `${theme.spacing(2)}px`
    },
    '& > div': {
      marginRight: 0
    }
  },
  profileHeaderTitle: {
    wordBreak: 'normal'
  },
  [theme.breakpoints.down('sm')]: {
    actionsWrapper: {
      marginLeft: '-80px',
      display: 'flex',
      flexWrap: 'wrap',
      flexDirection: 'row-reverse',
      width: 'calc(100vw - 32px)',
      lineHeight: '3.5em',
      '& > button': {
        marginRight: 0
      },
      '& > div': {
        marginRight: `${theme.spacing(2)}px`
      }
    },
    profileHeaderTitle: {
      fontSize: '34px',
      wordBreak: 'break-word'
    }
  }
}));
const ProfileHeader = _ref => {
  let {
    section,
    scid,
    selectivity,
    collegeMatchLevel,
    acceptanceLikelihoodLabels,
    selectivityLabels,
    college,
    eventTracking,
    hasCollege,
    responsiveBreakpointArgs,
    sectionsConfiguration,
    isProspectOnly,
    actions,
    getCollegesPath,
    hostedRootPath,
    searchPath,
    contentBelowTitle,
    isTnTSearchFilterEnabled = false
  } = _ref;
  const classes = useStyles$A();
  const isNotProspectOnly = !isProspectOnly && hasCollege;
  const isResponsiveSize = useBreakpoint(...responsiveBreakpointArgs);
  const isXs = useBreakpoint('xs');
  const heroHeight = getHeroHeight(isXs, isResponsiveSize);
  const city = get(college, 'City');
  const state = get(college, 'State');
  const country = get(college, 'Country');
  const name = get(college, 'Name');
  const isVerified = get(college, 'VerifiedByDataOwner', false);
  const greaterThan = useHeightTrackerValue(PROFILE_HEADER_HEIGHT_TRACKER_ID) - HEIGHT_OF_STICKY;
  return /*#__PURE__*/React.createElement(HeightTracker$1, {
    id: PROFILE_HEADER_HEIGHT_TRACKER_ID
  }, /*#__PURE__*/React.createElement(AppBar, {
    position: "static",
    color: "default",
    "aria-hidden": window$1.scrollY > greaterThan
  }, /*#__PURE__*/React.createElement(Metadata, {
    value: get(eventTracking, 'locationHeader')
  }, /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement(Container, {
    maxWidth: "lg",
    className: classes.container
  }, /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    pt: 3,
    pb: !isResponsiveSize ? 3 : 0,
    m: 0
  }, isNotProspectOnly && isResponsiveSize && /*#__PURE__*/React.createElement(Box, {
    mb: 2
  }, /*#__PURE__*/React.createElement(HeroImageOrTour$1, {
    height: heroHeight
  })), /*#__PURE__*/React.createElement(CollegeAvatarWithTitle, {
    width: "100%",
    alignItems: "flex-start",
    flexDirection: "row",
    mt: 2,
    scid: scid,
    avatarProps: {
      size: 'lg',
      alt: `${name} logo`
    },
    additionalBodyProps: {
      flexGrow: 1,
      marginTop: 0,
      maxWidth: `calc(100% - 113px)`
    },
    titleComponent: PageTitle,
    titleComponentProps: {
      ml: 2,
      pt: 0,
      pb: 0,
      sideBySideProps: {
        flexWrap: 'nowrap',
        alignItems: 'flex-start',
        flexDirection: isResponsiveSize ? 'column' : 'row'
      },
      title: /*#__PURE__*/React.createElement(Title, {
        name: name,
        isVerified: isVerified,
        verifiedLarge: true,
        section: section,
        className: classes.profileHeaderTitle,
        component: null
      }),
      subTitle: /*#__PURE__*/React.createElement(Location$2, {
        city: city,
        state: state,
        country: country
      }),
      actions: /*#__PURE__*/React.createElement("div", {
        className: classes.actionsWrapper
      }, isResponsiveSize ? null : /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(Box, {
        mt: "-3px",
        mb: "-10px",
        pr: 2
      }, /*#__PURE__*/React.createElement(CopyCurrentUrl, null))), actions)
    }
  })), contentBelowTitle && /*#__PURE__*/React.createElement(Box, null, contentBelowTitle), isNotProspectOnly && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    mb: 3
  }, !isResponsiveSize && /*#__PURE__*/React.createElement(HeroImageOrTour$1, {
    height: heroHeight
  }), /*#__PURE__*/React.createElement(HeaderPills$1, {
    selectivity: selectivity,
    collegeMatchLevel: collegeMatchLevel,
    acceptanceLikelihoodLabels: acceptanceLikelihoodLabels,
    selectivityLabels: selectivityLabels,
    college: college,
    hostedRootPath: hostedRootPath,
    searchPath: searchPath,
    isTnTSearchFilterEnabled: isTnTSearchFilterEnabled
  })), /*#__PURE__*/React.createElement(Navigation, {
    section: section,
    collegesPath: getCollegesPath(scid),
    sectionsConfiguration: sectionsConfiguration
  })))))));
};
ProfileHeader.propTypes = {
  scid: PropTypes.number.isRequired,
  section: PropTypes.string.isRequired,
  selectivity: PropTypes.number,
  collegeMatchLevel: PropTypes.number,
  acceptanceLikelihoodLabels: PropTypes.object,
  selectivityLabels: PropTypes.object,
  college: PropTypes.object,
  hasCollege: PropTypes.bool,
  isProspectOnly: PropTypes.bool.isRequired,
  responsiveBreakpointArgs: PropTypes.array,
  sectionsConfiguration: PropTypes.object,
  eventTracking: PropTypes.object,
  actions: PropTypes.node,
  getCollegesPath: PropTypes.func.isRequired,
  hostedRootPath: PropTypes.string.isRequired,
  searchPath: PropTypes.string.isRequired,
  contentBelowTitle: PropTypes.node,
  isTnTSearchFilterEnabled: PropTypes.bool
};
var PageHeader = withContext(ProfileHeader, Context$2);

const getCurrentScrollPoint = axis => get(window, `scroll${axis}`, 0);
const getIsGreaterThan = (axis, pixels) => pixels > -1 && getCurrentScrollPoint(axis) > pixels;
const getIsLessThan = (axis, pixels) => pixels > -1 && getCurrentScrollPoint(axis) < pixels;
const useScrollPointTrigger = args => {
  const config = {
    axis: 'y',
    greaterThan: -1,
    lessThan: -1,
    show: noop,
    hide: noop,
    ...args
  };
  const axis = config.axis.toUpperCase();
  const greaterThan = config.greaterThan;
  const lessThan = config.lessThan;
  const initialState = getIsGreaterThan(axis, greaterThan) || getIsLessThan(axis, lessThan);
  const [showing, setShowing] = useState(initialState);
  const fn = useCallback(() => {
    const isGreaterThan = getIsGreaterThan(axis, greaterThan);
    const isLessThan = getIsLessThan(axis, lessThan);
    const shouldShow = isGreaterThan || isLessThan;
    const shouldHide = !isGreaterThan && !isLessThan;
    if (!showing && shouldShow) {
      setShowing(true);
      config.show();
    }
    if (showing && shouldHide) {
      setShowing(false);
      config.hide();
    }
  }, [axis, config, greaterThan, lessThan, showing]);
  useWindowEventListener('scroll', debounce(fn));
};

const useStyles$z = makeStyles(() => ({
  root: {
    zIndex: 3,
    overflow: 'hidden'
  }
}));
const AppBarBelowNav = _ref => {
  let {
    children,
    open,
    verticalNavOffset,
    className,
    ...rest
  } = _ref;
  const topNavigationHeightTrackerId = useTopNavigationHeightTrackerId();
  const classes = useStyles$z();
  const marginTop = useHeightTrackerValue(topNavigationHeightTrackerId);
  return /*#__PURE__*/React.createElement(AppBar, _extends({
    key: verticalNavOffset,
    className: cn(classes.root, className),
    style: {
      top: `${marginTop}px`
    },
    "aria-hidden": !open
  }, rest), /*#__PURE__*/React.createElement(Collapse, {
    in: open
  }, /*#__PURE__*/React.createElement(Box, {
    paddingLeft: verticalNavOffset ? `${verticalNavOffset}px` : undefined
  }, children)));
};
AppBarBelowNav.propTypes = {
  trackedHeights: PropTypes.object,
  children: PropTypes.node,
  open: PropTypes.bool,
  verticalNavOffset: PropTypes.number,
  className: PropTypes.string
};

const AppBarOpenWithScroll = _ref => {
  let {
    ...rest
  } = _ref;
  const [open, setOpen] = useState(false);
  const greaterThan = useHeightTrackerValue(PROFILE_HEADER_HEIGHT_TRACKER_ID) - HEIGHT_OF_STICKY;
  useScrollPointTrigger({
    greaterThan,
    show: () => setOpen(true),
    hide: () => setOpen(false)
  });
  return /*#__PURE__*/React.createElement(AppBarBelowNav, _extends({
    open: open,
    color: "default"
  }, rest));
};
AppBarOpenWithScroll.propTypes = {
  children: PropTypes.node
};

const useStyles$y = makeStyles(theme => ({
  profileHeaderTitle: {
    fontFamily: 'Roboto',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px'
  },
  paper: {
    overflow: 'hidden'
  },
  actionsWrapper: {
    display: 'flex',
    '& > button': {
      marginRight: `${theme.spacing(2)}px`
    }
  },
  [theme.breakpoints.down('md')]: {
    actionsWrapper: {
      top: `${theme.spacing(2) + 6}px`,
      position: 'absolute',
      right: `${theme.spacing(3)}px`
    }
  },
  [theme.breakpoints.down('sm')]: {
    actionsWrapper: {
      '& > button': {
        marginRight: 0
      }
    }
  }
}));
const StickyHeader = _ref => {
  let {
    section,
    scid,
    college,
    hasCollege,
    sectionsConfiguration,
    actions,
    getCollegesPath,
    verticalNavOffset
  } = _ref;
  const classes = useStyles$y();
  const isProspectOnly = get(college, 'ProspectOnly', false);
  const isNotProspectOnly = !isProspectOnly && hasCollege;
  const isResponsiveSize = useBreakpoint(...BREAKPOINT_ARGS);
  const name = get(college, 'Name');
  return /*#__PURE__*/React.createElement(AppBarOpenWithScroll, {
    verticalNavOffset: verticalNavOffset
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper
  }, /*#__PURE__*/React.createElement(Container, {
    maxWidth: "lg",
    disableGutters: true
  }, /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    m: 0
  }, /*#__PURE__*/React.createElement(CollegeAvatarWithTitle, {
    scid: scid,
    avatarProps: {
      size: 'sm',
      alt: `${name} logo`
    },
    titleComponent: Title$2,
    width: "100%",
    mt: 0,
    pt: 2,
    px: 3,
    additionalBodyProps: {
      flexGrow: 1,
      marginTop: 0,
      maxWidth: `calc(100% - 60px)`
    },
    titleComponentProps: {
      pt: 0,
      pb: 0,
      sideBySideProps: {
        flexWrap: 'nowrap'
      },
      subTitleProps: {
        pt: 0.25,
        pb: 0
      },
      title: /*#__PURE__*/React.createElement(Title, {
        name: name,
        shouldTruncate: true,
        className: classes.profileHeaderTitle,
        component: "span"
      }),
      actions: /*#__PURE__*/React.createElement("div", {
        className: classes.actionsWrapper
      }, isResponsiveSize ? null : /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(Box, {
        mt: "-3px",
        mb: "-10px",
        pr: 2
      }, /*#__PURE__*/React.createElement(CopyCurrentUrl, null))), actions)
    }
  })), isNotProspectOnly && /*#__PURE__*/React.createElement(Navigation, {
    section: section,
    sectionsConfiguration: sectionsConfiguration,
    collegesPath: getCollegesPath(scid)
  }))));
};
StickyHeader.propTypes = {
  scid: PropTypes.number.isRequired,
  section: PropTypes.string.isRequired,
  college: PropTypes.object,
  hasCollege: PropTypes.bool,
  actions: PropTypes.node,
  sectionsConfiguration: PropTypes.object,
  getCollegesPath: PropTypes.func.isRequired,
  verticalNavOffset: PropTypes.number
};
var StickyHeader$1 = withContext(StickyHeader, Context$2);

const ProfileHeaderContainer = _ref => {
  let {
    selectivity,
    collegeMatchLevel,
    pageHeaderActions,
    stickyHeaderActions,
    selectivityLabels,
    acceptanceLikelihoodLabels,
    contentBelowTitle,
    isTnTSearchFilterEnabled = false
  } = _ref;
  const hasCollege = useHasCollege();
  return !hasCollege ? null : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageHeader, {
    actions: pageHeaderActions,
    selectivity: selectivity,
    collegeMatchLevel: collegeMatchLevel,
    selectivityLabels: selectivityLabels,
    acceptanceLikelihoodLabels: acceptanceLikelihoodLabels,
    contentBelowTitle: contentBelowTitle,
    isTnTSearchFilterEnabled: isTnTSearchFilterEnabled
  }), /*#__PURE__*/React.createElement(StickyHeader$1, {
    actions: stickyHeaderActions
  }));
};
ProfileHeaderContainer.propTypes = {
  scid: PropTypes.number.isRequired,
  selectivity: PropTypes.number,
  collegeMatchLevel: PropTypes.number,
  searchParams: PropTypes.object,
  pageHeaderActions: PropTypes.node,
  stickyHeaderActions: PropTypes.node,
  onViewCollegeProfile: PropTypes.func,
  selectivityLabels: PropTypes.object,
  acceptanceLikelihoodLabels: PropTypes.object,
  contentBelowTitle: PropTypes.node,
  isTnTSearchFilterEnabled: PropTypes.bool
};

const useStyles$x = makeStyles(theme => ({
  root: {
    textAlign: 'center',
    padding: theme.spacing(2),
    background: get(theme, 'palette.pageBackground.light'),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(10)
    }
  }
}));
const Footer = _ref => {
  let {
    children
  } = _ref;
  const classes = useStyles$x();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, children);
};
Footer.propTypes = {
  children: PropTypes.node.isRequired
};

const getProfileSectionsConfiguration = SECTIONS => {
  const INDEXES = Object.keys(SECTIONS).map(str => parseInt(str));
  const INDEX_BY_ENDPOINT = {};
  const LABELS = [];
  for (var i = 0; i < INDEXES.length; i++) {
    const idx = INDEXES[i];
    const section = SECTIONS[idx];
    INDEX_BY_ENDPOINT[section.endpoint] = idx;
    LABELS.push(section.label);
  }
  return {
    SECTIONS,
    INDEXES,
    INDEX_BY_ENDPOINT,
    LABELS
  };
};

const ContentCarousel = _ref => {
  let {
    children,
    className,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cn('cd-content-carousel', className)
  }, rest), children);
};
ContentCarousel.propTypes = {
  children: PropTypes.any.isRequired,
  className: PropTypes.string
};
const BulletPoints = _ref2 => {
  let {
    points,
    className,
    ...rest
  } = _ref2;
  return /*#__PURE__*/React.createElement("ul", _extends({
    className: cn('cd-content-carousel-points', className)
  }, rest), map(points, (point, idx) => /*#__PURE__*/React.createElement("li", {
    key: idx
  }, point)));
};
BulletPoints.propTypes = {
  points: PropTypes.array,
  className: PropTypes.string
};
ContentCarousel.BulletPoints = BulletPoints;

const useStyles$w = makeStyles(() => ({
  box: {
    display: 'inline-flex',
    alignItems: 'center',
    verticalAlign: 'middle'
  }
}));
const DisplayScoirApplyIcon = _ref => {
  let {
    isScoirApplyEnabled,
    tooltipText,
    ...rest
  } = _ref;
  const classes = useStyles$w();
  return isScoirApplyEnabled ? /*#__PURE__*/React.createElement(Tooltip, {
    title: tooltipText
  }, /*#__PURE__*/React.createElement(Box, _extends({
    className: classes.box
  }, rest), /*#__PURE__*/React.createElement(ScoirApplyIcon, null))) : null;
};
DisplayScoirApplyIcon.defaultProps = {
  tooltipText: ''
};
DisplayScoirApplyIcon.propTypes = {
  isScoirApplyEnabled: PropTypes.bool.isRequired,
  tooltipText: PropTypes.string
};

const NO_PREFERENCES = 'no preferences';
const MATCHED = 'matched';
const NOT_MATCHED = 'not matched';
const preferenceMatchStateConstants = {
  NO_PREFERENCES,
  MATCHED,
  NOT_MATCHED
};

const useStyles$v = makeStyles(theme => ({
  wrapper: {
    display: 'flex',
    margin: 'auto',
    height: '60px',
    borderRadius: '50%',
    backgroundColor: '#F5F5F5',
    width: '60px',
    alignItems: 'center',
    justifyContent: 'center',
    color: get(theme, 'palette.action.disabled')
  }
}));
const LargeCircularIcon = _ref => {
  let {
    size = 'lg',
    className,
    icon = faPlus
  } = _ref;
  const classes = useStyles$v();
  return /*#__PURE__*/React.createElement(Box, {
    className: cn(classes.wrapper, className),
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: icon,
    size: size
  }));
};
LargeCircularIcon.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  icon: PropTypes.any
};

const EmptyStateWithIcon = _ref => {
  let {
    title,
    subTitle,
    children,
    icon
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    p: 5,
    display: "flex",
    alignItems: "center",
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(Box, {
    mb: 2
  }, /*#__PURE__*/React.createElement(LargeCircularIcon, {
    icon: icon
  })), /*#__PURE__*/React.createElement(Box, {
    pt: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, title), /*#__PURE__*/React.createElement(Box, {
    pt: 1
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "textSecondary"
  }, subTitle)))), !isEmpty(children) && /*#__PURE__*/React.createElement(Box, {
    py: 3,
    "data-testid": "children"
  }, children));
};
EmptyStateWithIcon.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  children: PropTypes.node,
  icon: PropTypes.any
};

const DEFAULT_STATE = {
  hasContent: false,
  reportCount: 0
};
const REDUCER_ACTION_TYPE = 'REPORT_SECTION_WITH_CONTENT';
const reducer$1 = (state, action) => {
  switch (action.type) {
    case REDUCER_ACTION_TYPE:
      {
        return produce(state, draft => {
          if (action.value) {
            draft.hasContent = true;
          }
          draft.reportCount += 1;
          return draft;
        });
      }
  }
};

/// This hook requires the component to be rendered at least once before it can be used. Since `hasContent` is initialized to `false`,
/// the best way to conditionally render is if `hasContent` is `true` OR `hasEnoughReports` is `false`.
const useReportHasContent = function () {
  let requiredNumberOfReports = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  const [{
    hasContent,
    reportCount
  }, dispatch] = useReducer(reducer$1, DEFAULT_STATE);
  const hasEnoughReports = reportCount >= requiredNumberOfReports;
  return {
    hasContent: hasEnoughReports && hasContent,
    hasEnoughReports,
    reportHasContent: value => {
      dispatch({
        type: REDUCER_ACTION_TYPE,
        value
      });
    }
  };
};

const SUBTITLES = {
  prospectOnly: "We don't have any information to show you about this college right now.",
  emptySection: "We don't have any information to show you right now."
};
const EmptyState = _ref => {
  let {
    isEmpty,
    loaded,
    isProspectOnly
  } = _ref;
  const subTitle = isProspectOnly ? SUBTITLES.prospectOnly : SUBTITLES.emptySection;
  const shouldShow = loaded && (isEmpty || isProspectOnly);
  return !shouldShow ? null : /*#__PURE__*/React.createElement(Box, {
    mx: 4,
    my: 8,
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Paper, {
    elevation: 0
  }, /*#__PURE__*/React.createElement(EmptyStateWithIcon, {
    title: "Nothing to see here",
    subTitle: subTitle,
    icon: faFolderOpen
  })));
};
EmptyState.propTypes = {
  loaded: PropTypes.bool.isRequired,
  isEmpty: PropTypes.bool.isRequired,
  isProspectOnly: PropTypes.bool.isRequired
};
var EmptyState$1 = withContext(EmptyState, Context$2);

const getInitialState$1 = constant({
  data: [],
  waiting: false,
  loading: true,
  loaded: false
});
const TYPES$1 = {
  waiting: 'waiting',
  loading: 'loading',
  loaded: 'loaded',
  done: 'done'
};
const reducer = (state, action) => {
  switch (action.type) {
    case TYPES$1.waiting:
      return produce(state, draft => {
        draft.waiting = true;
        draft.loading = false;
        draft.loaded = false;
        draft.data = [];
        return draft;
      });
    case TYPES$1.loading:
      return produce(state, draft => {
        draft.waiting = false;
        draft.loading = true;
        draft.loaded = false;
        draft.data = [];
        return draft;
      });
    case TYPES$1.loaded:
      {
        return produce(state, draft => {
          draft.data = action.data;
          return draft;
        });
      }
    case TYPES$1.done:
      {
        return produce(state, draft => {
          draft.waiting = false;
          draft.loading = false;
          draft.loaded = true;
          return draft;
        });
      }
  }
};

const useApiOnMount = function (call, dispatch) {
  let otherDeps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  useEffect(() => {
    dispatch({
      type: 'loading'
    });
    const promise = call();
    if (isUndefined(promise)) {
      dispatch({
        type: 'waiting'
      });
      return;
    }
    promise.then(data => {
      dispatch({
        type: 'loaded',
        data
      });
    }).finally(() => {
      dispatch({
        type: 'done'
      });
    });
  }, [dispatch, ...otherDeps]);
};

const usePreferenceMatches = (getPreferenceMatches, scid, studentId) => {
  const [{
    loading,
    loaded,
    data
  }, dispatch] = useReducer(reducer, getInitialState$1());
  const [refetchCount, setRefetchCount] = useState(0);
  useApiOnMount(() => {
    if (isUndefined(studentId)) {
      return;
    }
    return getPreferenceMatches(scid, studentId);
  }, dispatch, [scid, refetchCount, studentId]);
  return {
    loading,
    loaded,
    preferenceMatches: data,
    refetchStudentPreferences: () => {
      setRefetchCount(refetchCount + 1);
    }
  };
};

const useStyles$u = makeStyles({
  formControl: {
    width: '100%'
  },
  menuItem: {
    '&:nth-child(even)': {
      backgroundColor: 'rgba(0,0,0,0.04)'
    }
  }
});
const ID$1 = 'preference-match-card-student-selector';
const getName = student => {
  const first = get(student, 'FirstName');
  const middle = get(student, 'MiddleName', '');
  const last = get(student, 'LastName');
  const initial = middle ? `${middle.charAt(0)}. ` : '';
  const nickName = get(student, 'Nickname', '');
  const preferredName = nickName ? ` "${nickName}"` : '';
  return `${first}${preferredName} ${initial}${last}`;
};
const renderOption = student => {
  const classYear = get(student, 'Profile.GraduationYear');
  return /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement("strong", null, getName(student)), classYear && /*#__PURE__*/React.createElement("span", null, "Class of ", classYear));
};
const renderOptionLabel = student => {
  const classYear = get(student, 'Profile.GraduationYear');
  const name = getName(student);
  return classYear ? `${name} - Class of ${classYear}` : name;
};
const renderInput = params => /*#__PURE__*/React.createElement(TextField, _extends({}, params, {
  label: "Student",
  variant: "outlined",
  margin: "normal"
}));
const StudentSelector = _ref => {
  let {
    students = [],
    selectedIndex = [0],
    onSelect
  } = _ref;
  const classes = useStyles$u();
  return /*#__PURE__*/React.createElement(Box, {
    p: 2
  }, /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined",
    className: classes.formControl
  }, /*#__PURE__*/React.createElement(Autocomplete, {
    id: ID$1,
    style: {
      width: '100%'
    },
    options: students,
    defaultValue: students[0],
    value: students[selectedIndex],
    onChange: e => {
      onSelect(get(e, 'currentTarget.dataset.optionIndex', 0));
    },
    getOptionLabel: renderOptionLabel,
    renderInput: renderInput,
    renderOption: renderOption
  })));
};
StudentSelector.propTypes = {
  students: PropTypes.array,
  selectedIndex: PropTypes.number,
  onSelect: PropTypes.func
};

const LottieComponent = _ref => {
  let {
    show = true,
    animationData,
    durationMilliseconds = 0,
    ...rest
  } = _ref;
  const [isStopped, setIsStopped] = useState(false);
  if (show && !isStopped && durationMilliseconds > 0) {
    setTimeout(() => {
      setIsStopped(true);
    }, durationMilliseconds);
  }
  return !show ? null : /*#__PURE__*/React.createElement(Lottie, _extends({}, rest, {
    isStopped: isStopped,
    loop: !isStopped,
    animationData: animationData,
    play: true
  }));
};
LottieComponent.propTypes = {
  show: PropTypes.bool,
  animationData: PropTypes.object.isRequired,
  durationMilliseconds: PropTypes.number
};

const v="4.5.6";const fr=30;const ip=0;const op=90;const w=800;const h=800;const ddd=0;const assets=[];const layers=[{ddd:0,ind:0,ty:3,nm:"Master",ks:{o:{a:0,k:0},r:{a:0,k:0},p:{a:0,k:[400,461.6569999999999,0]},a:{a:0,k:[0,0,0]},s:{a:0,k:[100,100,100]}},ao:0,ip:0,op:600,st:0,bm:0,sr:1},{ddd:0,ind:1,ty:4,nm:"Star_03",parent:0,ks:{o:{a:1,k:[{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:64,s:[100],e:[0]},{t:84}]},r:{a:1,k:[{i:{x:[0.006],y:[1]},o:{x:[0.167],y:[0.167]},n:["0p006_1_0p167_0p167"],t:14,s:[-720],e:[-1149]},{t:90}]},p:{a:1,k:[{i:{x:0.833,y:0.833},o:{x:0.167,y:0.167},n:"0p833_0p833_0p167_0p167",t:14,s:[-72.808,4.062,0],e:[2.192,-72.938,0],to:[7.80815124511719,-75.0615844726562,0],ti:[0,0,0]},{t:84}]},a:{a:0,k:[231.37,449.226,0]},s:{a:1,k:[{i:{x:[0,0,0.667],y:[1,1,0.667]},o:{x:[0.167,0.167,0.167],y:[0.167,0.167,0.167]},n:["0_1_0p167_0p167","0_1_0p167_0p167","0p667_0p667_0p167_0p167"],t:14,s:[0,0,100],e:[100,100,100]},{t:54}]}},ao:0,shapes:[{ty:"gr",it:[{ind:0,ty:"sh",ks:{a:0,k:{i:[[0,0],[0,0],[0,0]],o:[[0,0],[0,0],[0,0]],v:[[-36.571,-9.612],[-27.799,-1.99],[-36.683,5.428]],c:false}},nm:"Path 2",mn:"ADBE Vector Shape - Group"},{ind:1,ty:"sh",ks:{a:0,k:{i:[[0,0],[0,0],[0,0]],o:[[0,0],[0,0],[0,0]],v:[[3.95,-9.308],[-4.935,-1.817],[3.838,5.731]],c:false}},nm:"Path 1",mn:"ADBE Vector Shape - Group"},{ty:"st",c:{a:0,k:[1,0.8823529411764706,0.32941176470588235,1]},o:{a:1,k:[{t:14,s:[100],h:1},{t:34,s:[0],h:1}]},w:{a:0,k:2.641},lc:2,lj:2,nm:"Stroke 1",mn:"ADBE Vector Graphic - Stroke"},{ty:"tr",p:{a:0,k:[247.846,433.746],ix:2},a:{a:0,k:[0,0],ix:1},s:{a:0,k:[100,100],ix:3},r:{a:0,k:0,ix:6},o:{a:0,k:100,ix:7},sk:{a:0,k:0,ix:4},sa:{a:0,k:0,ix:5},nm:"Transform"}],nm:"Eyes_Closed",np:3,mn:"ADBE Vector Group"},{ty:"gr",it:[{ind:0,ty:"sh",ks:{a:1,k:[{i:{x:0.667,y:1},o:{x:0.333,y:0},n:"0p667_1_0p333_0",t:34,s:[{i:[[0.013,-0.202],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.096,-0.1],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.733,-0.323]],c:true}],e:[{i:[[0.054,-2.972],[2.972,0.054],[-0.054,2.973],[-2.976,-0.054]],o:[[-0.054,2.976],[-2.972,-0.054],[0.054,-2.973],[2.971,0.054]],v:[[-18.385,0.097],[-23.869,5.385],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.667,y:1},o:{x:0.333,y:0},n:"0p667_1_0p333_0",t:44,s:[{i:[[0.054,-2.972],[2.972,0.054],[-0.054,2.973],[-2.976,-0.054]],o:[[-0.054,2.976],[-2.972,-0.054],[0.054,-2.973],[2.971,0.054]],v:[[-18.385,0.097],[-23.869,5.385],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.054,-2.972],[2.972,0.054],[-0.054,2.973],[-2.976,-0.054]],o:[[-0.054,2.976],[-2.972,-0.054],[0.054,-2.973],[2.971,0.054]],v:[[-18.385,0.097],[-23.869,5.385],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.667,y:1},o:{x:0.333,y:0},n:"0p667_1_0p333_0",t:54,s:[{i:[[0.054,-2.972],[2.972,0.054],[-0.054,2.973],[-2.976,-0.054]],o:[[-0.054,2.976],[-2.972,-0.054],[0.054,-2.973],[2.971,0.054]],v:[[-18.385,0.097],[-23.869,5.385],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:62,s:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.644,-0.884],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0},n:"0p667_1_0p167_0",t:68,s:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.644,-0.884],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:71,s:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.644,-0.884],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0},n:"0p667_1_0p167_0",t:74,s:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.644,-0.884],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:77,s:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.644,-0.884],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0},n:"0p667_1_0p167_0",t:80,s:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.644,-0.884],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:83,s:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.644,-0.884],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0},n:"0p667_1_0p167_0",t:86,s:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.644,-0.884],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:89,s:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.644,-0.884],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0},n:"0p667_1_0p167_0",t:92,s:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.644,-0.884],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:95,s:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.644,-0.884],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0},n:"0p667_1_0p167_0",t:98,s:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.644,-0.884],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:101,s:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.644,-0.884],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0},n:"0p667_1_0p167_0",t:104,s:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.644,-0.884],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:107,s:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.644,-0.884],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{t:110}]},nm:"Path 2",mn:"ADBE Vector Shape - Group"},{ind:1,ty:"sh",ks:{a:1,k:[{i:{x:0.667,y:1},o:{x:0.333,y:0},n:"0p667_1_0p333_0",t:34,s:[{i:[[0.023,-0.016],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[0.014,-0.036],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.014,-0.105]],c:true}],e:[{i:[[0.003,-2.973],[2.973,0.003],[-0.003,2.973],[-2.976,-0.003]],o:[[-0.003,2.976],[-2.974,-0.003],[0.003,-2.973],[2.971,0.003]],v:[[5.386,0.004],[-0.006,5.385],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.667,y:1},o:{x:0.333,y:0},n:"0p667_1_0p333_0",t:44,s:[{i:[[0.003,-2.973],[2.973,0.003],[-0.003,2.973],[-2.976,-0.003]],o:[[-0.003,2.976],[-2.974,-0.003],[0.003,-2.973],[2.971,0.003]],v:[[5.386,0.004],[-0.006,5.385],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.003,-2.973],[2.973,0.003],[-0.003,2.973],[-2.976,-0.003]],o:[[-0.003,2.976],[-2.974,-0.003],[0.003,-2.973],[2.971,0.003]],v:[[5.386,0.004],[-0.006,5.385],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.667,y:1},o:{x:0.333,y:0},n:"0p667_1_0p333_0",t:54,s:[{i:[[0.003,-2.973],[2.973,0.003],[-0.003,2.973],[-2.976,-0.003]],o:[[-0.003,2.976],[-2.974,-0.003],[0.003,-2.973],[2.971,0.003]],v:[[5.386,0.004],[-0.006,5.385],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:62,s:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.145,-0.852],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0},n:"0p667_1_0p167_0",t:68,s:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.145,-0.852],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:71,s:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.145,-0.852],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0},n:"0p667_1_0p167_0",t:74,s:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.145,-0.852],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:77,s:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.145,-0.852],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0},n:"0p667_1_0p167_0",t:80,s:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.145,-0.852],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:83,s:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.145,-0.852],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0},n:"0p667_1_0p167_0",t:86,s:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.145,-0.852],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:89,s:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.145,-0.852],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0},n:"0p667_1_0p167_0",t:92,s:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.145,-0.852],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:95,s:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.145,-0.852],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0},n:"0p667_1_0p167_0",t:98,s:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.145,-0.852],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:101,s:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.145,-0.852],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0},n:"0p667_1_0p167_0",t:104,s:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.145,-0.852],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:107,s:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.145,-0.852],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{t:110}]},nm:"Path 1",mn:"ADBE Vector Shape - Group"},{ty:"fl",c:{a:0,k:[1,0.8823529411764706,0.32941176470588235,1]},o:{a:1,k:[{t:14,s:[0],h:1},{t:34,s:[100],h:1}]},nm:"Fill 1",mn:"ADBE Vector Graphic - Fill"},{ty:"tr",p:{a:0,k:[242.997,431.73],ix:2},a:{a:0,k:[0,0],ix:1},s:{a:0,k:[100,100],ix:3},r:{a:0,k:0,ix:6},o:{a:0,k:100,ix:7},sk:{a:0,k:0,ix:4},sa:{a:0,k:0,ix:5},nm:"Transform"}],nm:"Eyes_Open",np:3,mn:"ADBE Vector Group"},{ty:"gr",it:[{ind:0,ty:"sh",ks:{a:1,k:[{i:{x:0.667,y:1},o:{x:0.333,y:0},n:"0p667_1_0p333_0",t:54,s:[{i:[[0,0],[0.109,-0.906],[13.65,0.572],[1.781,12.531],[0,0],[-24,-0.295]],o:[[0,0],[-1.541,12.793],[-13.007,-0.545],[-0.128,-0.903],[0,0],[22.624,0.278]],v:[[23.024,-8.94],[22.994,-8.863],[-2.946,14.608],[-28.522,-7.528],[-28.716,-8.86],[-2.671,14.6]],c:true}],e:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,14.608],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}]},{i:{x:0.833,y:0.833},o:{x:0.167,y:0},n:"0p833_0p833_0p167_0",t:62,s:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,14.608],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}],e:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,17.108],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0.167},n:"0p667_1_0p167_0p167",t:65,s:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,17.108],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}],e:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,17.295],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}]},{i:{x:0.833,y:0.833},o:{x:0.167,y:0},n:"0p833_0p833_0p167_0",t:68,s:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,17.295],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}],e:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,14.608],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0.167},n:"0p667_1_0p167_0p167",t:71,s:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,14.608],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}],e:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,17.295],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}]},{i:{x:0.833,y:0.833},o:{x:0.167,y:0},n:"0p833_0p833_0p167_0",t:74,s:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,17.295],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}],e:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,14.608],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0.167},n:"0p667_1_0p167_0p167",t:77,s:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,14.608],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}],e:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,17.295],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}]},{i:{x:0.833,y:0.833},o:{x:0.167,y:0},n:"0p833_0p833_0p167_0",t:80,s:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,17.295],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}],e:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,14.608],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0.167},n:"0p667_1_0p167_0p167",t:83,s:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,14.608],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}],e:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,17.295],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}]},{i:{x:0.833,y:0.833},o:{x:0.167,y:0},n:"0p833_0p833_0p167_0",t:86,s:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,17.295],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}],e:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,14.608],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0.167},n:"0p667_1_0p167_0p167",t:89,s:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,14.608],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}],e:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,17.295],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}]},{i:{x:0.833,y:0.833},o:{x:0.167,y:0},n:"0p833_0p833_0p167_0",t:92,s:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,17.295],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}],e:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,14.608],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0.167},n:"0p667_1_0p167_0p167",t:95,s:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,14.608],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}],e:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,17.295],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}]},{i:{x:0.833,y:0.833},o:{x:0.167,y:0},n:"0p833_0p833_0p167_0",t:98,s:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,17.295],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}],e:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,14.608],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0.167},n:"0p667_1_0p167_0p167",t:101,s:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,14.608],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}],e:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,17.295],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}]},{i:{x:0.833,y:0.833},o:{x:0.167,y:0},n:"0p833_0p833_0p167_0",t:104,s:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,17.295],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}],e:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,14.608],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0.167},n:"0p667_1_0p167_0p167",t:107,s:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,14.608],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}],e:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,17.295],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}]},{t:110}]},nm:"Path 1",mn:"ADBE Vector Shape - Group"},{ty:"fl",c:{a:0,k:[1,0.8823529411764706,0.32941176470588235,1]},o:{a:1,k:[{t:14,s:[0],h:1},{t:54,s:[100],h:1}]},nm:"Fill 1",mn:"ADBE Vector Graphic - Fill"},{ty:"st",c:{a:0,k:[1,0.8823529411764706,0.32941176470588235,1]},o:{a:1,k:[{t:14,s:[0],h:1},{t:54,s:[100],h:1}]},w:{a:0,k:2.641},lc:2,lj:1,ml:10,nm:"Stroke 1",mn:"ADBE Vector Graphic - Stroke"},{ty:"tr",p:{a:0,k:[233.421,461.195],ix:2},a:{a:0,k:[0,0],ix:1},s:{a:0,k:[100,100],ix:3},r:{a:0,k:0,ix:6},o:{a:0,k:100,ix:7},sk:{a:0,k:0,ix:4},sa:{a:0,k:0,ix:5},nm:"Transform"}],nm:"Open Smile",np:3,mn:"ADBE Vector Group"},{ty:"gr",it:[{ind:0,ty:"sh",ks:{a:0,k:{i:[[0,0],[-13.602,0.167],[-0.817,13.364]],o:[[1.145,13.34],[13.603,-0.166],[0,0]],v:[[-25.719,-11.551],[0.292,12.014],[25.719,-12.182]],c:false}},nm:"Path 1",mn:"ADBE Vector Shape - Group"},{ty:"tm",s:{a:1,k:[{i:{x:[0.667],y:[1]},o:{x:[0.333],y:[0]},n:["0p667_1_0p333_0"],t:14,s:[45],e:[0]},{t:34}],ix:1},e:{a:1,k:[{i:{x:[0.667],y:[1]},o:{x:[0.333],y:[0]},n:["0p667_1_0p333_0"],t:14,s:[55],e:[100]},{t:34}],ix:2},o:{a:0,k:0,ix:3},m:1,ix:2,nm:"Trim Paths 1",mn:"ADBE Vector Filter - Trim"},{ty:"st",c:{a:0,k:[1,0.8823529411764706,0.32941176470588235,1]},o:{a:1,k:[{t:14,s:[100],h:1},{t:54,s:[0],h:1}]},w:{a:0,k:2.641},lc:2,lj:1,ml:10,nm:"Stroke 1",mn:"ADBE Vector Graphic - Stroke"},{ty:"tr",p:{a:0,k:[230.43,463.945],ix:2},a:{a:0,k:[0,0],ix:1},s:{a:0,k:[100,100],ix:3},r:{a:0,k:0,ix:6},o:{a:0,k:100,ix:7},sk:{a:0,k:0,ix:4},sa:{a:0,k:0,ix:5},nm:"Transform"}],nm:"Smile",np:3,mn:"ADBE Vector Group"},{ty:"gr",it:[{ind:0,ty:"sh",ks:{a:0,k:{i:[[10.322,1.475],[0,0],[4.634,9.335],[0,0],[3.041,-0.007],[0,0],[-4.62,-2.413],[0,0],[1.789,10.268],[0,0],[-7.447,7.297],[0,0]],o:[[0,0],[-10.319,-1.474],[0,0],[-2.319,-4.67],[0,0],[6.08,-0.016],[0,0],[9.237,4.826],[0,0],[-1.79,-10.269],[0,0],[7.447,-7.294]],v:[[30.878,-26.746],[4.089,-30.567],[-23.103,-50.22],[-35.144,-74.456],[-43.549,-81.447],[-43.189,60.499],[-26.405,64.095],[-2.419,76.628],[11.128,66.733],[6.486,40.071],[16.773,8.136],[36.102,-10.803]],c:true}},nm:"Path 1",mn:"ADBE Vector Shape - Group"},{ty:"fl",c:{a:0,k:[1,0.8823529411764706,0.32941176470588235,1]},o:{a:0,k:100},nm:"Fill 1",mn:"ADBE Vector Graphic - Fill"},{ty:"tr",p:{a:0,k:[275.242,440.626],ix:2},a:{a:0,k:[0,0],ix:1},s:{a:0,k:[100,100],ix:3},r:{a:0,k:0,ix:6},o:{a:0,k:100,ix:7},sk:{a:0,k:0,ix:4},sa:{a:0,k:0,ix:5},nm:"Transform"}],nm:"Body_shader",np:2,mn:"ADBE Vector Group"},{ty:"gr",it:[{ind:0,ty:"sh",ks:{a:0,k:{i:[[0,0],[-4.636,-9.336],[0,0],[-10.32,-1.474],[0,0],[7.448,-7.294],[0,0],[-1.789,-10.269],[0,0],[9.237,4.826],[0,0],[9.213,-4.873],[0,0],[-1.735,10.277],[0,0],[7.482,7.258],[0,0],[-10.314,1.526],[0,0],[-4.59,9.36]],o:[[4.59,-9.359],[0,0],[4.634,9.335],[0,0],[10.322,1.475],[0,0],[-7.446,7.297],[0,0],[1.788,10.269],[0,0],[-9.237,-4.826],[0,0],[-9.215,4.873],[0,0],[1.736,-10.28],[0,0],[-7.482,-7.256],[0,0],[10.315,-1.525],[0,0]],v:[[-8.533,-73.371],[8.244,-73.413],[20.285,-49.178],[47.477,-29.525],[74.265,-25.704],[79.489,-9.76],[60.16,9.178],[49.874,41.114],[54.515,67.775],[40.969,77.671],[16.983,65.137],[-16.569,65.22],[-40.491,77.876],[-54.088,68.051],[-49.58,41.366],[-60.029,9.483],[-79.455,-9.358],[-74.312,-25.327],[-47.543,-29.285],[-20.447,-49.076]],c:true}},nm:"Path 1",mn:"ADBE Vector Shape - Group"},{ty:"fl",c:{a:0,k:[1,0.8823529411764706,0.32941176470588235,1]},o:{a:0,k:100},nm:"Fill 1",mn:"ADBE Vector Graphic - Fill"},{ty:"tr",p:{a:0,k:[231.695,439.583],ix:2},a:{a:0,k:[0,0],ix:1},s:{a:0,k:[100,100],ix:3},r:{a:0,k:0,ix:6},o:{a:0,k:100,ix:7},sk:{a:0,k:0,ix:4},sa:{a:0,k:0,ix:5},nm:"Transform"}],nm:"Body",np:2,mn:"ADBE Vector Group"}],ip:90,op:90,st:14,bm:0,sr:1,hidden:14},{ddd:0,ind:2,ty:4,nm:"Star_02",parent:0,ks:{o:{a:1,k:[{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:79,s:[100],e:[0]},{t:89}]},r:{a:1,k:[{i:{x:[0],y:[1]},o:{x:[0.167],y:[0.167]},n:["0_1_0p167_0p167"],t:7,s:[-720],e:[-1509]},{t:107}]},p:{a:1,k:[{i:{x:0.833,y:0.833},o:{x:0.333,y:0},n:"0p833_0p833_0p333_0",t:7,s:[-55.808,-64.938,0],e:[-234.808,76.062,0],to:[-20,-147.83332824707,0],ti:[-2,-323.166656494141,0]},{t:90}]},a:{a:0,k:[231.37,449.226,0]},s:{a:1,k:[{i:{x:[0,0,0.667],y:[1,1,0.667]},o:{x:[0.167,0.167,0.167],y:[0.167,0.167,0.167]},n:["0_1_0p167_0p167","0_1_0p167_0p167","0p667_0p667_0p167_0p167"],t:7,s:[0,0,100],e:[100,100,100]},{t:47}]}},ao:0,shapes:[{ty:"gr",it:[{ind:0,ty:"sh",ks:{a:0,k:{i:[[0,0],[0,0],[0,0]],o:[[0,0],[0,0],[0,0]],v:[[-36.571,-9.612],[-27.799,-1.99],[-36.683,5.428]],c:false}},nm:"Path 2",mn:"ADBE Vector Shape - Group"},{ind:1,ty:"sh",ks:{a:0,k:{i:[[0,0],[0,0],[0,0]],o:[[0,0],[0,0],[0,0]],v:[[3.95,-9.308],[-4.935,-1.817],[3.838,5.731]],c:false}},nm:"Path 1",mn:"ADBE Vector Shape - Group"},{ty:"st",c:{a:0,k:[1,0.8823529411764706,0.32941176470588235,1]},o:{a:1,k:[{t:7,s:[100],h:1},{t:27,s:[0],h:1}]},w:{a:0,k:2.641},lc:2,lj:2,nm:"Stroke 1",mn:"ADBE Vector Graphic - Stroke"},{ty:"tr",p:{a:0,k:[247.846,433.746],ix:2},a:{a:0,k:[0,0],ix:1},s:{a:0,k:[100,100],ix:3},r:{a:0,k:0,ix:6},o:{a:0,k:100,ix:7},sk:{a:0,k:0,ix:4},sa:{a:0,k:0,ix:5},nm:"Transform"}],nm:"Eyes_Closed",np:3,mn:"ADBE Vector Group"},{ty:"gr",it:[{ind:0,ty:"sh",ks:{a:1,k:[{i:{x:0.667,y:1},o:{x:0.333,y:0},n:"0p667_1_0p333_0",t:27,s:[{i:[[0.013,-0.202],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.096,-0.1],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.733,-0.323]],c:true}],e:[{i:[[0.054,-2.972],[2.972,0.054],[-0.054,2.973],[-2.976,-0.054]],o:[[-0.054,2.976],[-2.972,-0.054],[0.054,-2.973],[2.971,0.054]],v:[[-18.385,0.097],[-23.869,5.385],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.667,y:1},o:{x:0.333,y:0},n:"0p667_1_0p333_0",t:37,s:[{i:[[0.054,-2.972],[2.972,0.054],[-0.054,2.973],[-2.976,-0.054]],o:[[-0.054,2.976],[-2.972,-0.054],[0.054,-2.973],[2.971,0.054]],v:[[-18.385,0.097],[-23.869,5.385],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.054,-2.972],[2.972,0.054],[-0.054,2.973],[-2.976,-0.054]],o:[[-0.054,2.976],[-2.972,-0.054],[0.054,-2.973],[2.971,0.054]],v:[[-18.385,0.097],[-23.869,5.385],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.667,y:1},o:{x:0.333,y:0},n:"0p667_1_0p333_0",t:47,s:[{i:[[0.054,-2.972],[2.972,0.054],[-0.054,2.973],[-2.976,-0.054]],o:[[-0.054,2.976],[-2.972,-0.054],[0.054,-2.973],[2.971,0.054]],v:[[-18.385,0.097],[-23.869,5.385],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:55,s:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.644,-0.884],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0},n:"0p667_1_0p167_0",t:61,s:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.644,-0.884],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:64,s:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.644,-0.884],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0},n:"0p667_1_0p167_0",t:67,s:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.644,-0.884],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:70,s:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.644,-0.884],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0},n:"0p667_1_0p167_0",t:73,s:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.644,-0.884],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:76,s:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.644,-0.884],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0},n:"0p667_1_0p167_0",t:79,s:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.644,-0.884],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:82,s:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.644,-0.884],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0},n:"0p667_1_0p167_0",t:85,s:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.644,-0.884],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:88,s:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.644,-0.884],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0},n:"0p667_1_0p167_0",t:91,s:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.644,-0.884],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:94,s:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.644,-0.884],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0},n:"0p667_1_0p167_0",t:97,s:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.644,-0.884],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:100,s:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.644,-0.884],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{t:103}]},nm:"Path 2",mn:"ADBE Vector Shape - Group"},{ind:1,ty:"sh",ks:{a:1,k:[{i:{x:0.667,y:1},o:{x:0.333,y:0},n:"0p667_1_0p333_0",t:27,s:[{i:[[0.023,-0.016],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[0.014,-0.036],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.014,-0.105]],c:true}],e:[{i:[[0.003,-2.973],[2.973,0.003],[-0.003,2.973],[-2.976,-0.003]],o:[[-0.003,2.976],[-2.974,-0.003],[0.003,-2.973],[2.971,0.003]],v:[[5.386,0.004],[-0.006,5.385],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.667,y:1},o:{x:0.333,y:0},n:"0p667_1_0p333_0",t:37,s:[{i:[[0.003,-2.973],[2.973,0.003],[-0.003,2.973],[-2.976,-0.003]],o:[[-0.003,2.976],[-2.974,-0.003],[0.003,-2.973],[2.971,0.003]],v:[[5.386,0.004],[-0.006,5.385],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.003,-2.973],[2.973,0.003],[-0.003,2.973],[-2.976,-0.003]],o:[[-0.003,2.976],[-2.974,-0.003],[0.003,-2.973],[2.971,0.003]],v:[[5.386,0.004],[-0.006,5.385],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.667,y:1},o:{x:0.333,y:0},n:"0p667_1_0p333_0",t:47,s:[{i:[[0.003,-2.973],[2.973,0.003],[-0.003,2.973],[-2.976,-0.003]],o:[[-0.003,2.976],[-2.974,-0.003],[0.003,-2.973],[2.971,0.003]],v:[[5.386,0.004],[-0.006,5.385],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:55,s:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.145,-0.852],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0},n:"0p667_1_0p167_0",t:61,s:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.145,-0.852],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:64,s:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.145,-0.852],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0},n:"0p667_1_0p167_0",t:67,s:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.145,-0.852],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:70,s:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.145,-0.852],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0},n:"0p667_1_0p167_0",t:73,s:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.145,-0.852],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:76,s:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.145,-0.852],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0},n:"0p667_1_0p167_0",t:79,s:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.145,-0.852],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:82,s:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.145,-0.852],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0},n:"0p667_1_0p167_0",t:85,s:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.145,-0.852],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:88,s:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.145,-0.852],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0},n:"0p667_1_0p167_0",t:91,s:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.145,-0.852],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:94,s:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.145,-0.852],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0},n:"0p667_1_0p167_0",t:97,s:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.145,-0.852],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:100,s:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.145,-0.852],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{t:103}]},nm:"Path 1",mn:"ADBE Vector Shape - Group"},{ty:"fl",c:{a:0,k:[1,0.8823529411764706,0.32941176470588235,1]},o:{a:1,k:[{t:7,s:[0],h:1},{t:27,s:[100],h:1}]},nm:"Fill 1",mn:"ADBE Vector Graphic - Fill"},{ty:"tr",p:{a:0,k:[242.997,431.73],ix:2},a:{a:0,k:[0,0],ix:1},s:{a:0,k:[100,100],ix:3},r:{a:0,k:0,ix:6},o:{a:0,k:100,ix:7},sk:{a:0,k:0,ix:4},sa:{a:0,k:0,ix:5},nm:"Transform"}],nm:"Eyes_Open",np:3,mn:"ADBE Vector Group"},{ty:"gr",it:[{ind:0,ty:"sh",ks:{a:1,k:[{i:{x:0.667,y:1},o:{x:0.333,y:0},n:"0p667_1_0p333_0",t:47,s:[{i:[[0,0],[0.109,-0.906],[13.65,0.572],[1.781,12.531],[0,0],[-24,-0.295]],o:[[0,0],[-1.541,12.793],[-13.007,-0.545],[-0.128,-0.903],[0,0],[22.624,0.278]],v:[[23.024,-8.94],[22.994,-8.863],[-2.946,14.608],[-28.522,-7.528],[-28.716,-8.86],[-2.671,14.6]],c:true}],e:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,14.608],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}]},{i:{x:0.833,y:0.833},o:{x:0.167,y:0},n:"0p833_0p833_0p167_0",t:55,s:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,14.608],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}],e:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,17.108],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0.167},n:"0p667_1_0p167_0p167",t:58,s:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,17.108],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}],e:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,17.295],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}]},{i:{x:0.833,y:0.833},o:{x:0.167,y:0},n:"0p833_0p833_0p167_0",t:61,s:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,17.295],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}],e:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,14.608],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0.167},n:"0p667_1_0p167_0p167",t:64,s:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,14.608],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}],e:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,17.295],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}]},{i:{x:0.833,y:0.833},o:{x:0.167,y:0},n:"0p833_0p833_0p167_0",t:67,s:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,17.295],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}],e:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,14.608],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0.167},n:"0p667_1_0p167_0p167",t:70,s:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,14.608],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}],e:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,17.295],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}]},{i:{x:0.833,y:0.833},o:{x:0.167,y:0},n:"0p833_0p833_0p167_0",t:73,s:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,17.295],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}],e:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,14.608],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0.167},n:"0p667_1_0p167_0p167",t:76,s:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,14.608],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}],e:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,17.295],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}]},{i:{x:0.833,y:0.833},o:{x:0.167,y:0},n:"0p833_0p833_0p167_0",t:79,s:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,17.295],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}],e:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,14.608],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0.167},n:"0p667_1_0p167_0p167",t:82,s:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,14.608],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}],e:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,17.295],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}]},{i:{x:0.833,y:0.833},o:{x:0.167,y:0},n:"0p833_0p833_0p167_0",t:85,s:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,17.295],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}],e:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,14.608],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0.167},n:"0p667_1_0p167_0p167",t:88,s:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,14.608],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}],e:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,17.295],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}]},{i:{x:0.833,y:0.833},o:{x:0.167,y:0},n:"0p833_0p833_0p167_0",t:91,s:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,17.295],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}],e:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,14.608],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0.167},n:"0p667_1_0p167_0p167",t:94,s:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,14.608],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}],e:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,17.295],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}]},{i:{x:0.833,y:0.833},o:{x:0.167,y:0},n:"0p833_0p833_0p167_0",t:97,s:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,17.295],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}],e:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,14.608],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0.167},n:"0p667_1_0p167_0p167",t:100,s:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,14.608],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}],e:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,17.295],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}]},{t:103}]},nm:"Path 1",mn:"ADBE Vector Shape - Group"},{ty:"fl",c:{a:0,k:[1,0.8823529411764706,0.32941176470588235,1]},o:{a:1,k:[{t:7,s:[0],h:1},{t:47,s:[100],h:1}]},nm:"Fill 1",mn:"ADBE Vector Graphic - Fill"},{ty:"st",c:{a:0,k:[1,0.8823529411764706,0.32941176470588235,1]},o:{a:1,k:[{t:7,s:[0],h:1},{t:47,s:[100],h:1}]},w:{a:0,k:2.641},lc:2,lj:1,ml:10,nm:"Stroke 1",mn:"ADBE Vector Graphic - Stroke"},{ty:"tr",p:{a:0,k:[233.421,461.195],ix:2},a:{a:0,k:[0,0],ix:1},s:{a:0,k:[100,100],ix:3},r:{a:0,k:0,ix:6},o:{a:0,k:100,ix:7},sk:{a:0,k:0,ix:4},sa:{a:0,k:0,ix:5},nm:"Transform"}],nm:"Open Smile",np:3,mn:"ADBE Vector Group"},{ty:"gr",it:[{ind:0,ty:"sh",ks:{a:0,k:{i:[[0,0],[-13.602,0.167],[-0.817,13.364]],o:[[1.145,13.34],[13.603,-0.166],[0,0]],v:[[-25.719,-11.551],[0.292,12.014],[25.719,-12.182]],c:false}},nm:"Path 1",mn:"ADBE Vector Shape - Group"},{ty:"tm",s:{a:1,k:[{i:{x:[0.667],y:[1]},o:{x:[0.333],y:[0]},n:["0p667_1_0p333_0"],t:7,s:[45],e:[0]},{t:27}],ix:1},e:{a:1,k:[{i:{x:[0.667],y:[1]},o:{x:[0.333],y:[0]},n:["0p667_1_0p333_0"],t:7,s:[55],e:[100]},{t:27}],ix:2},o:{a:0,k:0,ix:3},m:1,ix:2,nm:"Trim Paths 1",mn:"ADBE Vector Filter - Trim"},{ty:"st",c:{a:0,k:[1,0.8823529411764706,0.32941176470588235,1]},o:{a:1,k:[{t:7,s:[100],h:1},{t:47,s:[0],h:1}]},w:{a:0,k:2.641},lc:2,lj:1,ml:10,nm:"Stroke 1",mn:"ADBE Vector Graphic - Stroke"},{ty:"tr",p:{a:0,k:[230.43,463.945],ix:2},a:{a:0,k:[0,0],ix:1},s:{a:0,k:[100,100],ix:3},r:{a:0,k:0,ix:6},o:{a:0,k:100,ix:7},sk:{a:0,k:0,ix:4},sa:{a:0,k:0,ix:5},nm:"Transform"}],nm:"Smile",np:3,mn:"ADBE Vector Group"},{ty:"gr",it:[{ind:0,ty:"sh",ks:{a:0,k:{i:[[10.322,1.475],[0,0],[4.634,9.335],[0,0],[3.041,-0.007],[0,0],[-4.62,-2.413],[0,0],[1.789,10.268],[0,0],[-7.447,7.297],[0,0]],o:[[0,0],[-10.319,-1.474],[0,0],[-2.319,-4.67],[0,0],[6.08,-0.016],[0,0],[9.237,4.826],[0,0],[-1.79,-10.269],[0,0],[7.447,-7.294]],v:[[30.878,-26.746],[4.089,-30.567],[-23.103,-50.22],[-35.144,-74.456],[-43.549,-81.447],[-43.189,60.499],[-26.405,64.095],[-2.419,76.628],[11.128,66.733],[6.486,40.071],[16.773,8.136],[36.102,-10.803]],c:true}},nm:"Path 1",mn:"ADBE Vector Shape - Group"},{ty:"fl",c:{a:0,k:[1,0.8823529411764706,0.32941176470588235,1]},o:{a:0,k:100},nm:"Fill 1",mn:"ADBE Vector Graphic - Fill"},{ty:"tr",p:{a:0,k:[275.242,440.626],ix:2},a:{a:0,k:[0,0],ix:1},s:{a:0,k:[100,100],ix:3},r:{a:0,k:0,ix:6},o:{a:0,k:100,ix:7},sk:{a:0,k:0,ix:4},sa:{a:0,k:0,ix:5},nm:"Transform"}],nm:"Body_shader",np:2,mn:"ADBE Vector Group"},{ty:"gr",it:[{ind:0,ty:"sh",ks:{a:0,k:{i:[[0,0],[-4.636,-9.336],[0,0],[-10.32,-1.474],[0,0],[7.448,-7.294],[0,0],[-1.789,-10.269],[0,0],[9.237,4.826],[0,0],[9.213,-4.873],[0,0],[-1.735,10.277],[0,0],[7.482,7.258],[0,0],[-10.314,1.526],[0,0],[-4.59,9.36]],o:[[4.59,-9.359],[0,0],[4.634,9.335],[0,0],[10.322,1.475],[0,0],[-7.446,7.297],[0,0],[1.788,10.269],[0,0],[-9.237,-4.826],[0,0],[-9.215,4.873],[0,0],[1.736,-10.28],[0,0],[-7.482,-7.256],[0,0],[10.315,-1.525],[0,0]],v:[[-8.533,-73.371],[8.244,-73.413],[20.285,-49.178],[47.477,-29.525],[74.265,-25.704],[79.489,-9.76],[60.16,9.178],[49.874,41.114],[54.515,67.775],[40.969,77.671],[16.983,65.137],[-16.569,65.22],[-40.491,77.876],[-54.088,68.051],[-49.58,41.366],[-60.029,9.483],[-79.455,-9.358],[-74.312,-25.327],[-47.543,-29.285],[-20.447,-49.076]],c:true}},nm:"Path 1",mn:"ADBE Vector Shape - Group"},{ty:"fl",c:{a:0,k:[1,0.8823529411764706,0.32941176470588235,1]},o:{a:0,k:100},nm:"Fill 1",mn:"ADBE Vector Graphic - Fill"},{ty:"tr",p:{a:0,k:[231.695,439.583],ix:2},a:{a:0,k:[0,0],ix:1},s:{a:0,k:[100,100],ix:3},r:{a:0,k:0,ix:6},o:{a:0,k:100,ix:7},sk:{a:0,k:0,ix:4},sa:{a:0,k:0,ix:5},nm:"Transform"}],nm:"Body",np:2,mn:"ADBE Vector Group"}],ip:90,op:90,st:7,bm:0,sr:1,hidden:7},{ddd:0,ind:3,ty:4,nm:"Star_01",parent:0,ks:{o:{a:1,k:[{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:66,s:[100],e:[0]},{t:75}]},r:{a:1,k:[{i:{x:[0],y:[1]},o:{x:[0.167],y:[0.167]},n:["0_1_0p167_0p167"],t:0,s:[-720],e:[60]},{t:90}]},p:{a:1,k:[{i:{x:0.833,y:0.833},o:{x:0.333,y:0},n:"0p833_0p833_0p333_0",t:0,s:[31.192,-0.938,0],e:[223.192,87.062,0],to:[27,-133.83332824707,0],ti:[-7,-196.16667175293,0]},{t:90}]},a:{a:0,k:[231.37,449.226,0]},s:{a:1,k:[{i:{x:[0,0,0.667],y:[1,1,0.667]},o:{x:[0.167,0.167,0.167],y:[0.167,0.167,0.167]},n:["0_1_0p167_0p167","0_1_0p167_0p167","0p667_0p667_0p167_0p167"],t:0,s:[0,0,100],e:[100,100,100]},{t:40}]}},ao:0,shapes:[{ty:"gr",it:[{ind:0,ty:"sh",ks:{a:0,k:{i:[[0,0],[0,0],[0,0]],o:[[0,0],[0,0],[0,0]],v:[[-36.571,-9.612],[-27.799,-1.99],[-36.683,5.428]],c:false}},nm:"Path 2",mn:"ADBE Vector Shape - Group"},{ind:1,ty:"sh",ks:{a:0,k:{i:[[0,0],[0,0],[0,0]],o:[[0,0],[0,0],[0,0]],v:[[3.95,-9.308],[-4.935,-1.817],[3.838,5.731]],c:false}},nm:"Path 1",mn:"ADBE Vector Shape - Group"},{ty:"st",c:{a:0,k:[1,0.8823529411764706,0.32941176470588235,1]},o:{a:1,k:[{t:0,s:[100],h:1},{t:20,s:[0],h:1}]},w:{a:0,k:2.641},lc:2,lj:2,nm:"Stroke 1",mn:"ADBE Vector Graphic - Stroke"},{ty:"tr",p:{a:0,k:[247.846,433.746],ix:2},a:{a:0,k:[0,0],ix:1},s:{a:0,k:[100,100],ix:3},r:{a:0,k:0,ix:6},o:{a:0,k:100,ix:7},sk:{a:0,k:0,ix:4},sa:{a:0,k:0,ix:5},nm:"Transform"}],nm:"Eyes_Closed",np:3,mn:"ADBE Vector Group"},{ty:"gr",it:[{ind:0,ty:"sh",ks:{a:1,k:[{i:{x:0.667,y:1},o:{x:0.333,y:0},n:"0p667_1_0p333_0",t:20,s:[{i:[[0.013,-0.202],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.096,-0.1],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.733,-0.323]],c:true}],e:[{i:[[0.054,-2.972],[2.972,0.054],[-0.054,2.973],[-2.976,-0.054]],o:[[-0.054,2.976],[-2.972,-0.054],[0.054,-2.973],[2.971,0.054]],v:[[-18.385,0.097],[-23.869,5.385],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.667,y:1},o:{x:0.333,y:0},n:"0p667_1_0p333_0",t:30,s:[{i:[[0.054,-2.972],[2.972,0.054],[-0.054,2.973],[-2.976,-0.054]],o:[[-0.054,2.976],[-2.972,-0.054],[0.054,-2.973],[2.971,0.054]],v:[[-18.385,0.097],[-23.869,5.385],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.054,-2.972],[2.972,0.054],[-0.054,2.973],[-2.976,-0.054]],o:[[-0.054,2.976],[-2.972,-0.054],[0.054,-2.973],[2.971,0.054]],v:[[-18.385,0.097],[-23.869,5.385],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.667,y:1},o:{x:0.333,y:0},n:"0p667_1_0p333_0",t:40,s:[{i:[[0.054,-2.972],[2.972,0.054],[-0.054,2.973],[-2.976,-0.054]],o:[[-0.054,2.976],[-2.972,-0.054],[0.054,-2.973],[2.971,0.054]],v:[[-18.385,0.097],[-23.869,5.385],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:48,s:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.644,-0.884],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0},n:"0p667_1_0p167_0",t:54,s:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.644,-0.884],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:57,s:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.644,-0.884],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0},n:"0p667_1_0p167_0",t:60,s:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.644,-0.884],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:63,s:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.644,-0.884],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0},n:"0p667_1_0p167_0",t:66,s:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.644,-0.884],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:69,s:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.644,-0.884],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0},n:"0p667_1_0p167_0",t:72,s:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.644,-0.884],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:75,s:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.644,-0.884],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0},n:"0p667_1_0p167_0",t:78,s:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.644,-0.884],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:81,s:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.644,-0.884],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0},n:"0p667_1_0p167_0",t:84,s:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.644,-0.884],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:87,s:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.644,-0.884],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0},n:"0p667_1_0p167_0",t:90,s:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.644,-0.884],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:93,s:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.769,-0.053],[-29.155,-0.099],[-23.671,-5.385]],c:true}],e:[{i:[[0.049,-2.972],[2.972,0.054],[0.096,-0.006],[-2.976,-0.054]],o:[[0.013,-0.015],[-2.972,-0.054],[0.083,-2.972],[2.971,0.054]],v:[[-18.385,0.097],[-23.644,-0.884],[-29.155,-0.099],[-23.671,-5.385]],c:true}]},{t:96}]},nm:"Path 2",mn:"ADBE Vector Shape - Group"},{ind:1,ty:"sh",ks:{a:1,k:[{i:{x:0.667,y:1},o:{x:0.333,y:0},n:"0p667_1_0p333_0",t:20,s:[{i:[[0.023,-0.016],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[0.014,-0.036],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.014,-0.105]],c:true}],e:[{i:[[0.003,-2.973],[2.973,0.003],[-0.003,2.973],[-2.976,-0.003]],o:[[-0.003,2.976],[-2.974,-0.003],[0.003,-2.973],[2.971,0.003]],v:[[5.386,0.004],[-0.006,5.385],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.667,y:1},o:{x:0.333,y:0},n:"0p667_1_0p333_0",t:30,s:[{i:[[0.003,-2.973],[2.973,0.003],[-0.003,2.973],[-2.976,-0.003]],o:[[-0.003,2.976],[-2.974,-0.003],[0.003,-2.973],[2.971,0.003]],v:[[5.386,0.004],[-0.006,5.385],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.003,-2.973],[2.973,0.003],[-0.003,2.973],[-2.976,-0.003]],o:[[-0.003,2.976],[-2.974,-0.003],[0.003,-2.973],[2.971,0.003]],v:[[5.386,0.004],[-0.006,5.385],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.667,y:1},o:{x:0.333,y:0},n:"0p667_1_0p333_0",t:40,s:[{i:[[0.003,-2.973],[2.973,0.003],[-0.003,2.973],[-2.976,-0.003]],o:[[-0.003,2.976],[-2.974,-0.003],[0.003,-2.973],[2.971,0.003]],v:[[5.386,0.004],[-0.006,5.385],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:48,s:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.145,-0.852],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0},n:"0p667_1_0p167_0",t:54,s:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.145,-0.852],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:57,s:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.145,-0.852],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0},n:"0p667_1_0p167_0",t:60,s:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.145,-0.852],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:63,s:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.145,-0.852],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0},n:"0p667_1_0p167_0",t:66,s:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.145,-0.852],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:69,s:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.145,-0.852],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0},n:"0p667_1_0p167_0",t:72,s:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.145,-0.852],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:75,s:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.145,-0.852],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0},n:"0p667_1_0p167_0",t:78,s:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.145,-0.852],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:81,s:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.145,-0.852],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0},n:"0p667_1_0p167_0",t:84,s:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.145,-0.852],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:87,s:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.145,-0.852],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0},n:"0p667_1_0p167_0",t:90,s:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.145,-0.852],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{i:{x:0.833,y:1},o:{x:0.167,y:0},n:"0p833_1_0p167_0",t:93,s:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.02,-0.021],[-5.386,-0.006],[0.007,-5.386]],c:true}],e:[{i:[[0.116,-2.97],[2.973,0.003],[0.014,0.057],[-2.976,-0.003]],o:[[0.054,0.078],[-2.974,-0.003],[-0.236,-3.255],[2.971,0.003]],v:[[5.386,0.004],[0.145,-0.852],[-5.386,-0.006],[0.007,-5.386]],c:true}]},{t:96}]},nm:"Path 1",mn:"ADBE Vector Shape - Group"},{ty:"fl",c:{a:0,k:[1,0.8823529411764706,0.32941176470588235,1]},o:{a:1,k:[{t:0,s:[0],h:1},{t:20,s:[100],h:1}]},nm:"Fill 1",mn:"ADBE Vector Graphic - Fill"},{ty:"tr",p:{a:0,k:[242.997,431.73],ix:2},a:{a:0,k:[0,0],ix:1},s:{a:0,k:[100,100],ix:3},r:{a:0,k:0,ix:6},o:{a:0,k:100,ix:7},sk:{a:0,k:0,ix:4},sa:{a:0,k:0,ix:5},nm:"Transform"}],nm:"Eyes_Open",np:3,mn:"ADBE Vector Group"},{ty:"gr",it:[{ind:0,ty:"sh",ks:{a:1,k:[{i:{x:0.667,y:1},o:{x:0.333,y:0},n:"0p667_1_0p333_0",t:40,s:[{i:[[0,0],[0.109,-0.906],[13.65,0.572],[1.781,12.531],[0,0],[-24,-0.295]],o:[[0,0],[-1.541,12.793],[-13.007,-0.545],[-0.128,-0.903],[0,0],[22.624,0.278]],v:[[23.024,-8.94],[22.994,-8.863],[-2.946,14.608],[-28.522,-7.528],[-28.716,-8.86],[-2.671,14.6]],c:true}],e:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,14.608],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}]},{i:{x:0.833,y:0.833},o:{x:0.167,y:0},n:"0p833_0p833_0p167_0",t:48,s:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,14.608],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}],e:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,17.108],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0.167},n:"0p667_1_0p167_0p167",t:51,s:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,17.108],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}],e:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,17.295],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}]},{i:{x:0.833,y:0.833},o:{x:0.167,y:0},n:"0p833_0p833_0p167_0",t:54,s:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,17.295],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}],e:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,14.608],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0.167},n:"0p667_1_0p167_0p167",t:57,s:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,14.608],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}],e:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,17.295],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}]},{i:{x:0.833,y:0.833},o:{x:0.167,y:0},n:"0p833_0p833_0p167_0",t:60,s:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,17.295],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}],e:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,14.608],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0.167},n:"0p667_1_0p167_0p167",t:63,s:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,14.608],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}],e:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,17.295],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}]},{i:{x:0.833,y:0.833},o:{x:0.167,y:0},n:"0p833_0p833_0p167_0",t:66,s:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,17.295],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}],e:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,14.608],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0.167},n:"0p667_1_0p167_0p167",t:69,s:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,14.608],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}],e:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,17.295],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}]},{i:{x:0.833,y:0.833},o:{x:0.167,y:0},n:"0p833_0p833_0p167_0",t:72,s:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,17.295],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}],e:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,14.608],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0.167},n:"0p667_1_0p167_0p167",t:75,s:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,14.608],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}],e:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,17.295],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}]},{i:{x:0.833,y:0.833},o:{x:0.167,y:0},n:"0p833_0p833_0p167_0",t:78,s:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,17.295],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}],e:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,14.608],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0.167},n:"0p667_1_0p167_0p167",t:81,s:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,14.608],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}],e:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,17.295],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}]},{i:{x:0.833,y:0.833},o:{x:0.167,y:0},n:"0p833_0p833_0p167_0",t:84,s:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,17.295],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}],e:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,14.608],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0.167},n:"0p667_1_0p167_0p167",t:87,s:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,14.608],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}],e:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,17.295],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}]},{i:{x:0.833,y:0.833},o:{x:0.167,y:0},n:"0p833_0p833_0p167_0",t:90,s:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,17.295],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}],e:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,14.608],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}]},{i:{x:0.667,y:1},o:{x:0.167,y:0.167},n:"0p667_1_0p167_0p167",t:93,s:[{i:[[0,0],[0.123,-0.904],[13.118,0.071],[1.781,12.531],[-0.771,0.001],[-13.559,-0.008]],o:[[0.771,-0.001],[-1.708,12.576],[-13.016,-0.067],[-0.128,-0.903],[0,0],[13.343,0.006]],v:[[21.337,-9.257],[22.625,-7.808],[-2.946,14.608],[-28.522,-7.528],[-27.263,-9.176],[-2.671,-5.545]],c:true}],e:[{i:[[0,0],[0.125,-0.904],[13.019,-0.021],[1.781,12.531],[-0.913,0.001],[-11.625,0.045]],o:[[0.913,-0.002],[-1.74,12.536],[-13.018,0.021],[-0.128,-0.903],[0,0],[11.625,-0.045]],v:[[21.024,-9.315],[22.557,-7.613],[-2.946,17.295],[-28.522,-7.528],[-26.994,-9.235],[-2.671,-9.275]],c:true}]},{t:96}]},nm:"Path 1",mn:"ADBE Vector Shape - Group"},{ty:"fl",c:{a:0,k:[1,0.8823529411764706,0.32941176470588235,1]},o:{a:1,k:[{t:0,s:[0],h:1},{t:40,s:[100],h:1}]},nm:"Fill 1",mn:"ADBE Vector Graphic - Fill"},{ty:"st",c:{a:0,k:[1,0.8823529411764706,0.32941176470588235,1]},o:{a:1,k:[{t:0,s:[0],h:1},{t:40,s:[100],h:1}]},w:{a:0,k:2.641},lc:2,lj:1,ml:10,nm:"Stroke 1",mn:"ADBE Vector Graphic - Stroke"},{ty:"tr",p:{a:0,k:[233.421,461.195],ix:2},a:{a:0,k:[0,0],ix:1},s:{a:0,k:[100,100],ix:3},r:{a:0,k:0,ix:6},o:{a:0,k:100,ix:7},sk:{a:0,k:0,ix:4},sa:{a:0,k:0,ix:5},nm:"Transform"}],nm:"Open Smile",np:3,mn:"ADBE Vector Group"},{ty:"gr",it:[{ind:0,ty:"sh",ks:{a:0,k:{i:[[0,0],[-13.602,0.167],[-0.817,13.364]],o:[[1.145,13.34],[13.603,-0.166],[0,0]],v:[[-25.719,-11.551],[0.292,12.014],[25.719,-12.182]],c:false}},nm:"Path 1",mn:"ADBE Vector Shape - Group"},{ty:"tm",s:{a:1,k:[{i:{x:[0.667],y:[1]},o:{x:[0.333],y:[0]},n:["0p667_1_0p333_0"],t:0,s:[45],e:[0]},{t:20}],ix:1},e:{a:1,k:[{i:{x:[0.667],y:[1]},o:{x:[0.333],y:[0]},n:["0p667_1_0p333_0"],t:0,s:[55],e:[100]},{t:20}],ix:2},o:{a:0,k:0,ix:3},m:1,ix:2,nm:"Trim Paths 1",mn:"ADBE Vector Filter - Trim"},{ty:"st",c:{a:0,k:[1,0.8823529411764706,0.32941176470588235,1]},o:{a:1,k:[{t:0,s:[100],h:1},{t:40,s:[0],h:1}]},w:{a:0,k:2.641},lc:2,lj:1,ml:10,nm:"Stroke 1",mn:"ADBE Vector Graphic - Stroke"},{ty:"tr",p:{a:0,k:[230.43,463.945],ix:2},a:{a:0,k:[0,0],ix:1},s:{a:0,k:[100,100],ix:3},r:{a:0,k:0,ix:6},o:{a:0,k:100,ix:7},sk:{a:0,k:0,ix:4},sa:{a:0,k:0,ix:5},nm:"Transform"}],nm:"Smile",np:3,mn:"ADBE Vector Group"},{ty:"gr",it:[{ind:0,ty:"sh",ks:{a:0,k:{i:[[10.322,1.475],[0,0],[4.634,9.335],[0,0],[3.041,-0.007],[0,0],[-4.62,-2.413],[0,0],[1.789,10.268],[0,0],[-7.447,7.297],[0,0]],o:[[0,0],[-10.319,-1.474],[0,0],[-2.319,-4.67],[0,0],[6.08,-0.016],[0,0],[9.237,4.826],[0,0],[-1.79,-10.269],[0,0],[7.447,-7.294]],v:[[30.878,-26.746],[4.089,-30.567],[-23.103,-50.22],[-35.144,-74.456],[-43.549,-81.447],[-43.189,60.499],[-26.405,64.095],[-2.419,76.628],[11.128,66.733],[6.486,40.071],[16.773,8.136],[36.102,-10.803]],c:true}},nm:"Path 1",mn:"ADBE Vector Shape - Group"},{ty:"fl",c:{a:0,k:[1,0.8823529411764706,0.32941176470588235,1]},o:{a:0,k:100},nm:"Fill 1",mn:"ADBE Vector Graphic - Fill"},{ty:"tr",p:{a:0,k:[275.242,440.626],ix:2},a:{a:0,k:[0,0],ix:1},s:{a:0,k:[100,100],ix:3},r:{a:0,k:0,ix:6},o:{a:0,k:100,ix:7},sk:{a:0,k:0,ix:4},sa:{a:0,k:0,ix:5},nm:"Transform"}],nm:"Body_shader",np:2,mn:"ADBE Vector Group"},{ty:"gr",it:[{ind:0,ty:"sh",ks:{a:0,k:{i:[[0,0],[-4.636,-9.336],[0,0],[-10.32,-1.474],[0,0],[7.448,-7.294],[0,0],[-1.789,-10.269],[0,0],[9.237,4.826],[0,0],[9.213,-4.873],[0,0],[-1.735,10.277],[0,0],[7.482,7.258],[0,0],[-10.314,1.526],[0,0],[-4.59,9.36]],o:[[4.59,-9.359],[0,0],[4.634,9.335],[0,0],[10.322,1.475],[0,0],[-7.446,7.297],[0,0],[1.788,10.269],[0,0],[-9.237,-4.826],[0,0],[-9.215,4.873],[0,0],[1.736,-10.28],[0,0],[-7.482,-7.256],[0,0],[10.315,-1.525],[0,0]],v:[[-8.533,-73.371],[8.244,-73.413],[20.285,-49.178],[47.477,-29.525],[74.265,-25.704],[79.489,-9.76],[60.16,9.178],[49.874,41.114],[54.515,67.775],[40.969,77.671],[16.983,65.137],[-16.569,65.22],[-40.491,77.876],[-54.088,68.051],[-49.58,41.366],[-60.029,9.483],[-79.455,-9.358],[-74.312,-25.327],[-47.543,-29.285],[-20.447,-49.076]],c:true}},nm:"Path 1",mn:"ADBE Vector Shape - Group"},{ty:"fl",c:{a:0,k:[1,0.8823529411764706,0.32941176470588235,1]},o:{a:0,k:100},nm:"Fill 1",mn:"ADBE Vector Graphic - Fill"},{ty:"tr",p:{a:0,k:[231.695,439.583],ix:2},a:{a:0,k:[0,0],ix:1},s:{a:0,k:[100,100],ix:3},r:{a:0,k:0,ix:6},o:{a:0,k:100,ix:7},sk:{a:0,k:0,ix:4},sa:{a:0,k:0,ix:5},nm:"Transform"}],nm:"Body",np:2,mn:"ADBE Vector Group"}],ip:90,op:90,st:0,bm:0,sr:1,hidden:0},{ddd:0,ind:4,ty:4,nm:"Fireworks_08",parent:0,ks:{o:{a:0,k:100},r:{a:0,k:0},p:{a:0,k:[-41,-125.553,0]},a:{a:0,k:[312.5,177.5,0]},s:{a:0,k:[100,100,100]}},ao:0,shapes:[{ty:"gr",it:[{ind:0,ty:"sh",ks:{a:0,k:{i:[[0,0],[-3.733,3.212],[3.516,3.448],[1.007,-0.109],[-0.831,-1.602],[-1.804,-0.048],[-1.498,2.82],[1.857,2.598],[1.894,4.895],[-2.186,3.33],[0.394,3.963],[4.488,1.512],[0.67,2.591],[-1.061,1.667],[3.352,6.121],[-0.017,5.733],[-0.824,5.056],[1.288,6.795],[2.266,9.62],[0.775,2.384],[-2.086,5.33]],o:[[4.912,0.354],[3.734,-3.212],[-0.723,-0.709],[-1.794,0.194],[0.831,1.602],[3.192,0.085],[1.498,-2.82],[-3.052,-4.27],[-1.438,-3.716],[2.186,-3.33],[-0.468,-4.712],[-2.536,-0.855],[-0.495,-1.913],[3.747,-5.888],[-2.754,-5.028],[0.015,-5.123],[1.113,-6.827],[-1.84,-9.71],[-0.575,-2.44],[-1.769,-5.444],[0,0]],v:[[19.657,33.614],[33.618,30.114],[35.047,17.054],[32.352,15.881],[30.503,20.092],[35.067,22.494],[42.924,17.911],[42.323,8.835],[30.752,-1.506],[33.523,-12.651],[37.839,-23.525],[28.4,-33.073],[22.087,-37.425],[23.799,-42.917],[27.536,-62.474],[17.953,-76.278],[24.534,-89.921],[16.335,-108.508],[24.585,-136.227],[21.753,-143.18],[24.179,-159.818]],c:false}},nm:"Path 2",mn:"ADBE Vector Shape - Group"},{ty:"st",c:{a:0,k:[1,1,1,1]},o:{a:1,k:[{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:14,s:[100],e:[100]},{i:{x:[0.667],y:[1]},o:{x:[0.333],y:[0]},n:["0p667_1_0p333_0"],t:46.381,s:[100],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:68.762,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:70,s:[0],e:[0]},{i:{x:[0.833],y:[1]},o:{x:[0.167],y:[0]},n:["0p833_1_0p167_0"],t:103,s:[0],e:[100]},{i:{x:[0.833],y:[1]},o:{x:[0.167],y:[0]},n:["0p833_1_0p167_0"],t:104,s:[100],e:[0]},{i:{x:[0.833],y:[1]},o:{x:[0.167],y:[0]},n:["0p833_1_0p167_0"],t:643,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:644,s:[100],e:[100]},{i:{x:[0.667],y:[1]},o:{x:[0.333],y:[0]},n:["0p667_1_0p333_0"],t:676.381,s:[100],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:698.762,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:700,s:[0],e:[0]},{t:733}]},w:{a:0,k:4.829},lc:1,lj:1,ml:10,nm:"Stroke 1",mn:"ADBE Vector Graphic - Stroke"},{ty:"tm",s:{a:1,k:[{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:14,s:[0],e:[0]},{i:{x:[0.667],y:[1]},o:{x:[0.167],y:[0.167]},n:["0p667_1_0p167_0p167"],t:25,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:67,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:70,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0]},n:["0p833_0p833_0p167_0"],t:103,s:[100],e:[0]},{i:{x:[0.833],y:[1]},o:{x:[0.167],y:[0.167]},n:["0p833_1_0p167_0p167"],t:104,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0]},n:["0p833_0p833_0p167_0"],t:643,s:[100],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:644,s:[0],e:[0]},{i:{x:[0.667],y:[1]},o:{x:[0.167],y:[0.167]},n:["0p667_1_0p167_0p167"],t:655,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:697,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:700,s:[100],e:[100]},{t:733}],ix:1},e:{a:1,k:[{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:14,s:[0],e:[0]},{i:{x:[0],y:[1]},o:{x:[0.167],y:[0.167]},n:["0_1_0p167_0p167"],t:24,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:68.762,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:70,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0]},n:["0p833_0p833_0p167_0"],t:103,s:[100],e:[0]},{i:{x:[0.833],y:[1]},o:{x:[0.167],y:[0.167]},n:["0p833_1_0p167_0p167"],t:104,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0]},n:["0p833_0p833_0p167_0"],t:643,s:[100],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:644,s:[0],e:[0]},{i:{x:[0],y:[1]},o:{x:[0.167],y:[0.167]},n:["0_1_0p167_0p167"],t:654,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:698.762,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:700,s:[100],e:[100]},{t:733}],ix:2},o:{a:0,k:0,ix:3},m:1,ix:3,nm:"Trim Paths 1",mn:"ADBE Vector Filter - Trim"},{ty:"tr",p:{a:0,k:[312.078,177.185],ix:2},a:{a:0,k:[0,0],ix:1},s:{a:0,k:[100,100],ix:3},r:{a:0,k:0,ix:6},o:{a:0,k:100,ix:7},sk:{a:0,k:0,ix:4},sa:{a:0,k:0,ix:5},nm:"Transform"}],nm:"Group 1",np:3,mn:"ADBE Vector Group"}],ip:14,op:450,st:24,bm:0,sr:1},{ddd:0,ind:5,ty:4,nm:"Fireworks_07",parent:0,ks:{o:{a:0,k:100},r:{a:0,k:0},p:{a:0,k:[-41,-125.553,0]},a:{a:0,k:[312.5,177.5,0]},s:{a:0,k:[100,100,100]}},ao:0,shapes:[{ty:"gr",it:[{ind:0,ty:"sh",ks:{a:0,k:{i:[[0,0],[-3.987,2.255],[-3.851,-0.605],[-3.81,0.826],[0.199,3.894],[-0.057,1.725],[-3.528,0.655],[-3.35,1.286],[-0.385,4.173],[-1.666,2.264],[-4.338,1.184],[0.652,6.571],[-0.575,1.771],[-4.258,0.478],[-2.004,3.788],[0.798,2.901],[-1.515,4.958],[-6.098,3.216],[-0.018,8.318],[-2.756,4.522]],o:[[-1.536,-4.314],[3.393,-1.919],[3.852,0.605],[3.811,-0.825],[-0.088,-1.723],[0.118,-3.586],[3.529,-0.654],[3.912,-1.503],[0.258,-2.799],[2.666,-3.621],[6.371,-1.74],[-0.183,-1.853],[1.322,-4.076],[4.258,-0.479],[1.407,-2.659],[-1.374,-4.999],[2.015,-6.594],[7.358,-3.88],[0.011,-5.295],[0,0]],v:[[168.47,147.842],[172.892,135.992],[184.314,134.937],[195.915,135.611],[203.185,127.697],[202.336,122.605],[209.757,115.984],[220.374,114.415],[227.58,104.899],[228.797,96.697],[241.534,93.832],[249.311,77.395],[249.402,71.854],[260.021,65.997],[271.274,60.989],[271.241,52.188],[269.636,36.947],[284.659,23.584],[299.994,5.52],[299.485,-10.017]],c:false}},nm:"Path 6",mn:"ADBE Vector Shape - Group"},{ty:"st",c:{a:0,k:[1,0.10196078431372549,0.21176470588235294,1]},o:{a:1,k:[{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:12,s:[100],e:[100]},{i:{x:[0.667],y:[1]},o:{x:[0.333],y:[0]},n:["0p667_1_0p333_0"],t:41.048,s:[100],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:60.096,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:68,s:[0],e:[0]},{i:{x:[0.833],y:[1]},o:{x:[0.167],y:[0]},n:["0p833_1_0p167_0"],t:101,s:[0],e:[100]},{i:{x:[0.833],y:[1]},o:{x:[0.167],y:[0]},n:["0p833_1_0p167_0"],t:102,s:[100],e:[0]},{i:{x:[0.833],y:[1]},o:{x:[0.167],y:[0]},n:["0p833_1_0p167_0"],t:641,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:642,s:[100],e:[100]},{i:{x:[0.667],y:[1]},o:{x:[0.333],y:[0]},n:["0p667_1_0p333_0"],t:671.048,s:[100],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:690.096,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:698,s:[0],e:[0]},{t:731}]},w:{a:0,k:4.829},lc:1,lj:1,ml:10,nm:"Stroke 1",mn:"ADBE Vector Graphic - Stroke"},{ty:"tm",s:{a:1,k:[{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:12,s:[0],e:[0]},{i:{x:[0.667],y:[1]},o:{x:[0.167],y:[0.167]},n:["0p667_1_0p167_0p167"],t:23.904,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:62,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:68,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0]},n:["0p833_0p833_0p167_0"],t:101,s:[100],e:[0]},{i:{x:[0.833],y:[1]},o:{x:[0.167],y:[0.167]},n:["0p833_1_0p167_0p167"],t:102,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0]},n:["0p833_0p833_0p167_0"],t:641,s:[100],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:642,s:[0],e:[0]},{i:{x:[0.667],y:[1]},o:{x:[0.167],y:[0.167]},n:["0p667_1_0p167_0p167"],t:653.904,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:692,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:698,s:[100],e:[100]},{t:731}],ix:1},e:{a:1,k:[{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:12,s:[0],e:[0]},{i:{x:[0],y:[1]},o:{x:[0.167],y:[0.167]},n:["0_1_0p167_0p167"],t:22,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:60.096,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:68,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0]},n:["0p833_0p833_0p167_0"],t:101,s:[100],e:[0]},{i:{x:[0.833],y:[1]},o:{x:[0.167],y:[0.167]},n:["0p833_1_0p167_0p167"],t:102,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0]},n:["0p833_0p833_0p167_0"],t:641,s:[100],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:642,s:[0],e:[0]},{i:{x:[0],y:[1]},o:{x:[0.167],y:[0.167]},n:["0_1_0p167_0p167"],t:652,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:690.096,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:698,s:[100],e:[100]},{t:731}],ix:2},o:{a:0,k:0,ix:3},m:1,ix:3,nm:"Trim Paths 1",mn:"ADBE Vector Filter - Trim"},{ty:"tr",p:{a:0,k:[312.078,177.185],ix:2},a:{a:0,k:[0,0],ix:1},s:{a:0,k:[100,100],ix:3},r:{a:0,k:0,ix:6},o:{a:0,k:100,ix:7},sk:{a:0,k:0,ix:4},sa:{a:0,k:0,ix:5},nm:"Transform"}],nm:"Group 1",np:3,mn:"ADBE Vector Group"}],ip:12,op:450,st:22,bm:0,sr:1},{ddd:0,ind:6,ty:4,nm:"Fireworks_06",parent:0,ks:{o:{a:0,k:100},r:{a:0,k:0},p:{a:0,k:[-41,-125.553,0]},a:{a:0,k:[312.5,177.5,0]},s:{a:0,k:[100,100,100]}},ao:0,shapes:[{ty:"gr",it:[{ind:0,ty:"sh",ks:{a:0,k:{i:[[0,0],[-5.281,4.43],[-0.914,3.014],[5.89,1.428],[1.278,-0.706],[-0.398,-2.024],[-1.595,-1.307],[-5.767,2.717],[-1.596,6.171],[3.096,3.922],[3.061,0.395],[-0.362,-3.113],[-0.844,-0.845],[-5.948,1.68],[-4.203,4.531],[-0.402,6.099],[7.253,2.417],[1.355,-3.406],[-1.315,-1.81],[-5.511,1.088],[-3.533,4.367],[0.195,7.031],[5.769,4.024],[2.472,-0.019],[1.072,-2.228],[-1.583,-1.944],[-2.424,-0.639],[-4.257,7.616],[6.316,6.022],[2.637,-1.208],[-1.496,-2.496],[-2.893,0.316],[-2.212,1.892],[-0.927,3.55],[2.473,2.71]],o:[[6.373,2.623],[2.413,-2.024],[1.757,-5.8],[-1.419,-0.345],[-1.805,0.998],[0.397,2.024],[4.929,4.043],[5.767,-2.716],[1.252,-4.838],[-1.912,-2.422],[-3.109,-0.402],[0.138,1.187],[4.367,4.372],[5.948,-1.679],[4.157,-4.48],[0.503,-7.629],[-3.478,-1.159],[-0.826,2.079],[3.303,4.544],[5.511,-1.089],[4.423,-5.47],[-0.195,-7.031],[-2.027,-1.414],[-2.472,0.019],[-1.087,2.258],[1.582,1.944],[8.437,2.224],[4.257,-7.617],[-2.098,-2.001],[-2.645,1.213],[1.495,2.497],[2.892,-0.316],[2.788,-2.385],[0.926,-3.551],[0,0]],v:[[155.107,26.434],[174.284,22.087],[179.759,14.55],[171.698,0.45],[167.431,0.768],[165.247,6.125],[168.605,11.174],[186.637,13.021],[198.146,-1.482],[195.964,-15.777],[188.107,-20.228],[181.374,-15.649],[183.12,-12.598],[200.404,-8.883],[215.596,-19.099],[223.786,-35.098],[211.8,-52.728],[202.231,-49.982],[203.534,-43.686],[218.597,-38.425],[232.409,-47.474],[239.401,-66.919],[230.087,-85.004],[223.214,-87.454],[217.117,-83.941],[218.253,-76.909],[224.63,-73.166],[247.016,-82.674],[243.387,-106.723],[235.556,-109.098],[233.618,-101.608],[241.18,-98.275],[248.909,-102.043],[254.954,-111.038],[252.759,-121.366]],c:false}},nm:"Path 7",mn:"ADBE Vector Shape - Group"},{ty:"st",c:{a:0,k:[0.4666666666666667,0.8980392156862745,0.8352941176470589,1]},o:{a:1,k:[{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:10,s:[100],e:[100]},{i:{x:[0.667],y:[1]},o:{x:[0.333],y:[0]},n:["0p667_1_0p333_0"],t:40,s:[100],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:60.001,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:66,s:[0],e:[0]},{i:{x:[0.833],y:[1]},o:{x:[0.167],y:[0]},n:["0p833_1_0p167_0"],t:99,s:[0],e:[100]},{i:{x:[0.833],y:[1]},o:{x:[0.167],y:[0]},n:["0p833_1_0p167_0"],t:100,s:[100],e:[0]},{i:{x:[0.833],y:[1]},o:{x:[0.167],y:[0]},n:["0p833_1_0p167_0"],t:639,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:640,s:[100],e:[100]},{i:{x:[0.667],y:[1]},o:{x:[0.333],y:[0]},n:["0p667_1_0p333_0"],t:670,s:[100],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:690.001,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:696,s:[0],e:[0]},{t:729}]},w:{a:0,k:4.829},lc:1,lj:1,ml:10,nm:"Stroke 1",mn:"ADBE Vector Graphic - Stroke"},{ty:"tm",s:{a:1,k:[{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:10,s:[0],e:[0]},{i:{x:[0.667],y:[1]},o:{x:[0.167],y:[0.167]},n:["0p667_1_0p167_0p167"],t:22,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:62,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:66,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0]},n:["0p833_0p833_0p167_0"],t:99,s:[100],e:[0]},{i:{x:[0.833],y:[1]},o:{x:[0.167],y:[0.167]},n:["0p833_1_0p167_0p167"],t:100,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0]},n:["0p833_0p833_0p167_0"],t:639,s:[100],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:640,s:[0],e:[0]},{i:{x:[0.667],y:[1]},o:{x:[0.167],y:[0.167]},n:["0p667_1_0p167_0p167"],t:652,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:692,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:696,s:[100],e:[100]},{t:729}],ix:1},e:{a:1,k:[{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:10,s:[0],e:[0]},{i:{x:[0],y:[1]},o:{x:[0.167],y:[0.167]},n:["0_1_0p167_0p167"],t:20,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:60.001,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:66,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0]},n:["0p833_0p833_0p167_0"],t:99,s:[100],e:[0]},{i:{x:[0.833],y:[1]},o:{x:[0.167],y:[0.167]},n:["0p833_1_0p167_0p167"],t:100,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0]},n:["0p833_0p833_0p167_0"],t:639,s:[100],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:640,s:[0],e:[0]},{i:{x:[0],y:[1]},o:{x:[0.167],y:[0.167]},n:["0_1_0p167_0p167"],t:650,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:690.001,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:696,s:[100],e:[100]},{t:729}],ix:2},o:{a:0,k:0,ix:3},m:1,ix:3,nm:"Trim Paths 1",mn:"ADBE Vector Filter - Trim"},{ty:"tr",p:{a:0,k:[312.078,177.185],ix:2},a:{a:0,k:[0,0],ix:1},s:{a:0,k:[100,100],ix:3},r:{a:0,k:0,ix:6},o:{a:0,k:100,ix:7},sk:{a:0,k:0,ix:4},sa:{a:0,k:0,ix:5},nm:"Transform"}],nm:"Group 1",np:3,mn:"ADBE Vector Group"}],ip:10,op:450,st:20,bm:0,sr:1},{ddd:0,ind:7,ty:4,nm:"Fireworks_05",parent:0,ks:{o:{a:0,k:100},r:{a:0,k:0},p:{a:0,k:[-41,-125.553,0]},a:{a:0,k:[312.5,177.5,0]},s:{a:0,k:[100,100,100]}},ao:0,shapes:[{ty:"gr",it:[{ind:0,ty:"sh",ks:{a:0,k:{i:[[0,0],[4.131,7.797],[-5.227,7.109],[-8.766,-1.006],[-2.056,-1.844],[1.011,-2.57],[2.071,-1.017],[11.297,8.656],[-0.667,11.76],[-11.746,0.887],[-2.541,-1.671],[0.36,-3.02],[2.745,-1.724],[12.069,6.836],[4.344,10.921],[-2.995,9.212],[-2.692,2.073],[-2.84,0.366],[-3.616,-4.508],[6.115,-4.567],[7.593,0.777],[7.683,3.722],[3.783,5.39],[0.942,5.093],[-3.631,7.488],[-8.288,0.753]],o:[[-8.772,0.947],[-4.13,-7.797],[5.226,-7.109],[2.743,0.315],[2.056,1.843],[-0.844,2.146],[-12.773,6.277],[-9.35,-7.164],[0.667,-11.759],[3.033,-0.229],[2.541,1.671],[-0.384,3.219],[-11.744,7.379],[-10.227,-5.792],[-3.581,-9.002],[1.05,-3.231],[2.268,-1.747],[5.732,-0.739],[4.777,5.954],[-6.116,4.567],[-8.493,-0.868],[-5.926,-2.871],[-2.976,-4.239],[-1.513,-8.184],[3.631,-7.489],[0,0]],v:[[21.947,19.676],[-0.004,7.853],[1.987,-17.173],[25.207,-27.138],[32.799,-24.171],[34.978,-16.7],[29.978,-12.152],[-10.184,-17.613],[-25.547,-47.891],[-3.824,-71.879],[4.928,-69.965],[8.88,-62.255],[3.165,-54.794],[-36.376,-57.061],[-59.814,-82.497],[-60.73,-110.966],[-55.446,-119.498],[-47.461,-122.373],[-31.596,-117.55],[-35.706,-97.459],[-57.634,-93.077],[-82.148,-100.034],[-97.524,-112.094],[-103.116,-126.461],[-100.635,-150.883],[-81.46,-165.113]],c:false}},nm:"Path 4",mn:"ADBE Vector Shape - Group"},{ty:"st",c:{a:0,k:[0.4666666666666667,0.8980392156862745,0.8352941176470589,1]},o:{a:1,k:[{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:8,s:[100],e:[100]},{i:{x:[0.667],y:[1]},o:{x:[0.333],y:[0]},n:["0p667_1_0p333_0"],t:34.667,s:[100],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:51.334,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:64,s:[0],e:[0]},{i:{x:[0.833],y:[1]},o:{x:[0.167],y:[0]},n:["0p833_1_0p167_0"],t:97,s:[0],e:[100]},{i:{x:[0.833],y:[1]},o:{x:[0.167],y:[0]},n:["0p833_1_0p167_0"],t:98,s:[100],e:[0]},{i:{x:[0.833],y:[1]},o:{x:[0.167],y:[0]},n:["0p833_1_0p167_0"],t:637,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:638,s:[100],e:[100]},{i:{x:[0.667],y:[1]},o:{x:[0.333],y:[0]},n:["0p667_1_0p333_0"],t:664.667,s:[100],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:681.334,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:694,s:[0],e:[0]},{t:727}]},w:{a:0,k:4.829},lc:1,lj:1,ml:10,nm:"Stroke 1",mn:"ADBE Vector Graphic - Stroke"},{ty:"tm",s:{a:1,k:[{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:8,s:[0],e:[0]},{i:{x:[0.667],y:[1]},o:{x:[0.167],y:[0.167]},n:["0p667_1_0p167_0p167"],t:19.666,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:53,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:64,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0]},n:["0p833_0p833_0p167_0"],t:97,s:[100],e:[0]},{i:{x:[0.833],y:[1]},o:{x:[0.167],y:[0.167]},n:["0p833_1_0p167_0p167"],t:98,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0]},n:["0p833_0p833_0p167_0"],t:637,s:[100],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:638,s:[0],e:[0]},{i:{x:[0.667],y:[1]},o:{x:[0.167],y:[0.167]},n:["0p667_1_0p167_0p167"],t:649.666,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:683,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:694,s:[100],e:[100]},{t:727}],ix:1},e:{a:1,k:[{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:8,s:[0],e:[0]},{i:{x:[0],y:[1]},o:{x:[0.167],y:[0.167]},n:["0_1_0p167_0p167"],t:18,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:51.334,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:64,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0]},n:["0p833_0p833_0p167_0"],t:97,s:[100],e:[0]},{i:{x:[0.833],y:[1]},o:{x:[0.167],y:[0.167]},n:["0p833_1_0p167_0p167"],t:98,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0]},n:["0p833_0p833_0p167_0"],t:637,s:[100],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:638,s:[0],e:[0]},{i:{x:[0],y:[1]},o:{x:[0.167],y:[0.167]},n:["0_1_0p167_0p167"],t:648,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:681.334,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:694,s:[100],e:[100]},{t:727}],ix:2},o:{a:0,k:0,ix:3},m:1,ix:3,nm:"Trim Paths 1",mn:"ADBE Vector Filter - Trim"},{ty:"tr",p:{a:0,k:[312.078,177.185],ix:2},a:{a:0,k:[0,0],ix:1},s:{a:0,k:[100,100],ix:3},r:{a:0,k:0,ix:6},o:{a:0,k:100,ix:7},sk:{a:0,k:0,ix:4},sa:{a:0,k:0,ix:5},nm:"Transform"}],nm:"Group 1",np:3,mn:"ADBE Vector Group"}],ip:8,op:450,st:18,bm:0,sr:1},{ddd:0,ind:8,ty:4,nm:"Fireworks_04",parent:0,ks:{o:{a:0,k:100},r:{a:0,k:0},p:{a:0,k:[-41,-125.553,0]},a:{a:0,k:[312.5,177.5,0]},s:{a:0,k:[100,100,100]}},ao:0,shapes:[{ty:"gr",it:[{ind:0,ty:"sh",ks:{a:0,k:{i:[[0,0],[-0.913,5.269],[1.635,5.641],[2.07,9.641],[-1.235,6.159],[3.608,2.85],[2.872,6.752],[1.643,6.444],[3.337,2.11],[2.014,7.467],[0.352,3.318],[3.517,3.226],[3.39,3.021],[1.953,8.137]],o:[[-4.197,-3.313],[1.002,-5.787],[-2.745,-9.471],[-1.319,-6.142],[0.904,-4.508],[-5.759,-4.546],[-2.603,-6.119],[-0.976,-3.826],[-6.538,-4.133],[-0.869,-3.222],[-0.503,-4.746],[-3.347,-3.069],[-6.248,-5.568],[0,0]],v:[[-57.252,23.762],[-62.715,9.49],[-58.964,-7.44],[-80.304,-26.391],[-74.597,-44.016],[-79.12,-56.32],[-97.537,-67.369],[-96.248,-86.954],[-103.868,-95.641],[-120.542,-110.88],[-121.281,-120.84],[-127.589,-133.348],[-138.641,-141.284],[-149.101,-163.655]],c:false}},nm:"Path 3",mn:"ADBE Vector Shape - Group"},{ty:"st",c:{a:0,k:[1,0.10196078431372549,0.21176470588235294,1]},o:{a:1,k:[{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:6,s:[100],e:[100]},{i:{x:[0.667],y:[1]},o:{x:[0.333],y:[0]},n:["0p667_1_0p333_0"],t:33.144,s:[100],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:50.286,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:62,s:[0],e:[0]},{i:{x:[0.833],y:[1]},o:{x:[0.167],y:[0]},n:["0p833_1_0p167_0"],t:95,s:[0],e:[100]},{i:{x:[0.833],y:[1]},o:{x:[0.167],y:[0]},n:["0p833_1_0p167_0"],t:96,s:[100],e:[0]},{i:{x:[0.833],y:[1]},o:{x:[0.167],y:[0]},n:["0p833_1_0p167_0"],t:635,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:636,s:[100],e:[100]},{i:{x:[0.667],y:[1]},o:{x:[0.333],y:[0]},n:["0p667_1_0p333_0"],t:663.144,s:[100],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:680.286,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:692,s:[0],e:[0]},{t:725}]},w:{a:0,k:4.829},lc:1,lj:1,ml:10,nm:"Stroke 1",mn:"ADBE Vector Graphic - Stroke"},{ty:"tm",s:{a:1,k:[{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:6,s:[0],e:[0]},{i:{x:[0.667],y:[1]},o:{x:[0.167],y:[0.167]},n:["0p667_1_0p167_0p167"],t:17.714,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:52,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:62,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0]},n:["0p833_0p833_0p167_0"],t:95,s:[100],e:[0]},{i:{x:[0.833],y:[1]},o:{x:[0.167],y:[0.167]},n:["0p833_1_0p167_0p167"],t:96,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0]},n:["0p833_0p833_0p167_0"],t:635,s:[100],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:636,s:[0],e:[0]},{i:{x:[0.667],y:[1]},o:{x:[0.167],y:[0.167]},n:["0p667_1_0p167_0p167"],t:647.714,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:682,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:692,s:[100],e:[100]},{t:725}],ix:1},e:{a:1,k:[{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:6,s:[0],e:[0]},{i:{x:[0],y:[1]},o:{x:[0.167],y:[0.167]},n:["0_1_0p167_0p167"],t:16,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:50.286,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:62,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0]},n:["0p833_0p833_0p167_0"],t:95,s:[100],e:[0]},{i:{x:[0.833],y:[1]},o:{x:[0.167],y:[0.167]},n:["0p833_1_0p167_0p167"],t:96,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0]},n:["0p833_0p833_0p167_0"],t:635,s:[100],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:636,s:[0],e:[0]},{i:{x:[0],y:[1]},o:{x:[0.167],y:[0.167]},n:["0_1_0p167_0p167"],t:646,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:680.286,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:692,s:[100],e:[100]},{t:725}],ix:2},o:{a:0,k:0,ix:3},m:1,ix:3,nm:"Trim Paths 1",mn:"ADBE Vector Filter - Trim"},{ty:"tr",p:{a:0,k:[312.078,177.185],ix:2},a:{a:0,k:[0,0],ix:1},s:{a:0,k:[100,100],ix:3},r:{a:0,k:0,ix:6},o:{a:0,k:100,ix:7},sk:{a:0,k:0,ix:4},sa:{a:0,k:0,ix:5},nm:"Transform"}],nm:"Group 1",np:3,mn:"ADBE Vector Group"}],ip:6,op:450,st:16,bm:0,sr:1},{ddd:0,ind:9,ty:4,nm:"Fireworks_03",parent:0,ks:{o:{a:0,k:100},r:{a:0,k:0},p:{a:0,k:[-41,-125.553,0]},a:{a:0,k:[312.5,177.5,0]},s:{a:0,k:[100,100,100]}},ao:0,shapes:[{ty:"gr",it:[{ind:0,ty:"sh",ks:{a:0,k:{i:[[0,0],[6.04,1.773],[1.254,-6.169],[-0.817,-1.005],[-1.139,2.006],[1.203,1.968],[4.066,-0.354],[1.495,-3.798],[3.934,-5.435],[5.091,0.029],[3.978,-3.177],[-1.497,-5.865],[2.314,-2.52],[2.526,-0.02],[4.235,-7.851],[6.161,-3.967],[5.996,-2.631],[6.393,-6.106],[8.746,-9.115],[2.019,-2.488],[7.167,-1.468]],o:[[-3.035,-5.515],[-6.041,-1.772],[-0.258,1.269],[1.455,1.789],[1.14,-2.005],[-2.128,-3.483],[-4.066,0.354],[-2.458,6.242],[-2.986,4.125],[-5.092,-0.03],[-4.729,3.778],[0.846,3.314],[-1.708,1.861],[-8.921,0.074],[-3.479,6.449],[-5.505,3.545],[-8.096,3.552],[-9.136,8.724],[-2.218,2.313],[-4.609,5.682],[0,0]],v:[[-89.377,35.497],[-102.837,22.955],[-117.839,30.501],[-117.223,34.207],[-111.421,33.263],[-112.017,26.697],[-122.395,21.455],[-131.712,28.41],[-134.761,48.01],[-148.642,52.786],[-163.307,55.715],[-166.986,72.477],[-167.266,82.274],[-174.347,84.255],[-197.923,93.843],[-206.068,113.718],[-225.276,116.143],[-239.515,137.858],[-274.982,148.278],[-280.472,156.15],[-300.005,165.113]],c:false}},nm:"Path 2",mn:"ADBE Vector Shape - Group"},{ty:"st",c:{a:0,k:[1,0.10196078431372549,0.21176470588235294,1]},o:{a:1,k:[{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:4,s:[100],e:[100]},{i:{x:[0.667],y:[1]},o:{x:[0.333],y:[0]},n:["0p667_1_0p333_0"],t:33.524,s:[100],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:53.048,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:60,s:[0],e:[0]},{i:{x:[0.833],y:[1]},o:{x:[0.167],y:[0]},n:["0p833_1_0p167_0"],t:93,s:[0],e:[100]},{i:{x:[0.833],y:[1]},o:{x:[0.167],y:[0]},n:["0p833_1_0p167_0"],t:94,s:[100],e:[0]},{i:{x:[0.833],y:[1]},o:{x:[0.167],y:[0]},n:["0p833_1_0p167_0"],t:633,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:634,s:[100],e:[100]},{i:{x:[0.667],y:[1]},o:{x:[0.333],y:[0]},n:["0p667_1_0p333_0"],t:663.524,s:[100],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:683.048,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:690,s:[0],e:[0]},{t:723}]},w:{a:0,k:4.829},lc:1,lj:1,ml:10,nm:"Stroke 1",mn:"ADBE Vector Graphic - Stroke"},{ty:"tm",s:{a:1,k:[{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:4,s:[0],e:[0]},{i:{x:[0.667],y:[1]},o:{x:[0.167],y:[0.167]},n:["0p667_1_0p167_0p167"],t:15.952,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:55,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:60,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0]},n:["0p833_0p833_0p167_0"],t:93,s:[100],e:[0]},{i:{x:[0.833],y:[1]},o:{x:[0.167],y:[0.167]},n:["0p833_1_0p167_0p167"],t:94,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0]},n:["0p833_0p833_0p167_0"],t:633,s:[100],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:634,s:[0],e:[0]},{i:{x:[0.667],y:[1]},o:{x:[0.167],y:[0.167]},n:["0p667_1_0p167_0p167"],t:645.952,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:685,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:690,s:[100],e:[100]},{t:723}],ix:1},e:{a:1,k:[{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:4,s:[0],e:[0]},{i:{x:[0],y:[1]},o:{x:[0.167],y:[0.167]},n:["0_1_0p167_0p167"],t:14,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:53.048,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:60,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0]},n:["0p833_0p833_0p167_0"],t:93,s:[100],e:[0]},{i:{x:[0.833],y:[1]},o:{x:[0.167],y:[0.167]},n:["0p833_1_0p167_0p167"],t:94,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0]},n:["0p833_0p833_0p167_0"],t:633,s:[100],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:634,s:[0],e:[0]},{i:{x:[0],y:[1]},o:{x:[0.167],y:[0.167]},n:["0_1_0p167_0p167"],t:644,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:683.048,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:690,s:[100],e:[100]},{t:723}],ix:2},o:{a:0,k:0,ix:3},m:1,ix:3,nm:"Trim Paths 1",mn:"ADBE Vector Filter - Trim"},{ty:"tr",p:{a:0,k:[312.078,177.185],ix:2},a:{a:0,k:[0,0],ix:1},s:{a:0,k:[100,100],ix:3},r:{a:0,k:0,ix:6},o:{a:0,k:100,ix:7},sk:{a:0,k:0,ix:4},sa:{a:0,k:0,ix:5},nm:"Transform"}],nm:"Group 1",np:3,mn:"ADBE Vector Group"}],ip:4,op:450,st:14,bm:0,sr:1},{ddd:0,ind:10,ty:4,nm:"Fireworks_02",parent:0,ks:{o:{a:0,k:100},r:{a:0,k:0},p:{a:0,k:[-41,-125.553,0]},a:{a:0,k:[312.5,177.5,0]},s:{a:0,k:[100,100,100]}},ao:0,shapes:[{ty:"gr",it:[{ind:0,ty:"sh",ks:{a:0,k:{i:[[0,0],[-7.933,14.672],[0.349,16.675],[5.473,5.656],[4.908,1.164],[4.876,-2.608],[-1.549,-5.308],[-6.55,-0.009],[-1.872,0.928],[-0.997,4.469],[2.661,12.031],[2.233,3.641],[3.652,2.818],[8.412,2.835]],o:[[11.892,-11.695],[7.932,-14.672],[-0.166,-7.869],[-3.508,-3.625],[-5.381,-1.276],[-4.876,2.608],[1.834,6.288],[2.089,0.003],[4.103,-2.034],[2.684,-12.026],[-0.923,-4.171],[-2.412,-3.933],[-7.029,-5.423],[0,0]],v:[[119.191,30.962],[149.872,-8.329],[162.384,-56.202],[155.159,-78.093],[141.943,-85.036],[125.763,-83.813],[119.055,-70.028],[134.91,-60.892],[141.017,-62.022],[147.861,-73.389],[147.896,-110.061],[143.478,-122.026],[133.96,-131.966],[110.582,-144.469]],c:false}},nm:"Path 5",mn:"ADBE Vector Shape - Group"},{ty:"st",c:{a:0,k:[1,0.8823529411764706,0.32941176470588235,1]},o:{a:1,k:[{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:2,s:[100],e:[100]},{i:{x:[0.667],y:[1]},o:{x:[0.333],y:[0]},n:["0p667_1_0p333_0"],t:27.715,s:[100],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:43.429,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:58,s:[0],e:[0]},{i:{x:[0.833],y:[1]},o:{x:[0.167],y:[0]},n:["0p833_1_0p167_0"],t:91,s:[0],e:[100]},{i:{x:[0.833],y:[1]},o:{x:[0.167],y:[0]},n:["0p833_1_0p167_0"],t:92,s:[100],e:[0]},{i:{x:[0.833],y:[1]},o:{x:[0.167],y:[0]},n:["0p833_1_0p167_0"],t:631,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:632,s:[100],e:[100]},{i:{x:[0.667],y:[1]},o:{x:[0.333],y:[0]},n:["0p667_1_0p333_0"],t:657.715,s:[100],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:673.429,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:688,s:[0],e:[0]},{t:721}]},w:{a:0,k:4.829},lc:1,lj:1,ml:10,nm:"Stroke 1",mn:"ADBE Vector Graphic - Stroke"},{ty:"tm",s:{a:1,k:[{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:2,s:[0],e:[0]},{i:{x:[0.667],y:[1]},o:{x:[0.167],y:[0.167]},n:["0p667_1_0p167_0p167"],t:13.571,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:45,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:58,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0]},n:["0p833_0p833_0p167_0"],t:91,s:[100],e:[0]},{i:{x:[0.833],y:[1]},o:{x:[0.167],y:[0.167]},n:["0p833_1_0p167_0p167"],t:92,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0]},n:["0p833_0p833_0p167_0"],t:631,s:[100],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:632,s:[0],e:[0]},{i:{x:[0.667],y:[1]},o:{x:[0.167],y:[0.167]},n:["0p667_1_0p167_0p167"],t:643.571,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:675,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:688,s:[100],e:[100]},{t:721}],ix:1},e:{a:1,k:[{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:2,s:[0],e:[0]},{i:{x:[0],y:[1]},o:{x:[0.167],y:[0.167]},n:["0_1_0p167_0p167"],t:12,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:43.429,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:58,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0]},n:["0p833_0p833_0p167_0"],t:91,s:[100],e:[0]},{i:{x:[0.833],y:[1]},o:{x:[0.167],y:[0.167]},n:["0p833_1_0p167_0p167"],t:92,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0]},n:["0p833_0p833_0p167_0"],t:631,s:[100],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:632,s:[0],e:[0]},{i:{x:[0],y:[1]},o:{x:[0.167],y:[0.167]},n:["0_1_0p167_0p167"],t:642,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:673.429,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:688,s:[100],e:[100]},{t:721}],ix:2},o:{a:0,k:0,ix:3},m:1,ix:3,nm:"Trim Paths 1",mn:"ADBE Vector Filter - Trim"},{ty:"tr",p:{a:0,k:[312.078,177.185],ix:2},a:{a:0,k:[0,0],ix:1},s:{a:0,k:[100,100],ix:3},r:{a:0,k:0,ix:6},o:{a:0,k:100,ix:7},sk:{a:0,k:0,ix:4},sa:{a:0,k:0,ix:5},nm:"Transform"}],nm:"Group 1",np:3,mn:"ADBE Vector Group"}],ip:2,op:450,st:12,bm:0,sr:1},{ddd:0,ind:11,ty:4,nm:"Fireworks_01",parent:0,ks:{o:{a:0,k:100},r:{a:0,k:0},p:{a:0,k:[-41,-125.553,0]},a:{a:0,k:[312.5,177.5,0]},s:{a:0,k:[100,100,100]}},ao:0,shapes:[{ty:"gr",it:[{ind:0,ty:"sh",ks:{a:0,k:{i:[[0,0],[11.69,6.335],[-0.042,3.716],[-1.247,1.266],[-2.612,-1.139],[1.105,-2.627],[5.141,2.153],[1.829,8.959],[3.076,2.136],[3.312,2.666],[6.996,6.602],[3.62,1.755],[1.41,3.485],[2.977,4.448],[4.619,1.026],[4.136,2.297],[3.748,5.272],[6.456,0.411]],o:[[-11.36,6.845],[-3.267,-1.77],[0.02,-1.777],[2,-2.029],[2.611,1.139],[-2.791,6.636],[-9.286,-3.889],[-0.75,-3.67],[-3.493,-2.425],[-7.686,-6.189],[-2.926,-2.762],[-3.383,-1.641],[-2.008,-4.961],[-2.632,-3.932],[-4.619,-1.026],[-5.656,-3.142],[-3.749,-5.273],[0,0]],v:[[-87.104,119.435],[-125.246,120.525],[-131.776,112.185],[-129.676,107.427],[-121.832,105.665],[-118.75,112.73],[-140.586,115.83],[-152.583,96.072],[-157.893,86.484],[-169.572,81.55],[-177.838,56.291],[-188.771,51.385],[-196.302,43.331],[-200.687,27.987],[-212.76,21.213],[-226.362,17.374],[-239.172,3.039],[-254.425,-7.871]],c:false}},nm:"Path 1",mn:"ADBE Vector Shape - Group"},{ty:"st",c:{a:0,k:[1,0.8823529411764706,0.32941176470588235,1]},o:{a:1,k:[{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:0,s:[100],e:[100]},{i:{x:[0.667],y:[1]},o:{x:[0.333],y:[0]},n:["0p667_1_0p333_0"],t:24.762,s:[100],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:39.524,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:56,s:[0],e:[0]},{i:{x:[0.833],y:[1]},o:{x:[0.167],y:[0]},n:["0p833_1_0p167_0"],t:89,s:[0],e:[100]},{i:{x:[0.833],y:[1]},o:{x:[0.167],y:[0]},n:["0p833_1_0p167_0"],t:90,s:[100],e:[0]},{i:{x:[0.833],y:[1]},o:{x:[0.167],y:[0]},n:["0p833_1_0p167_0"],t:629,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:630,s:[100],e:[100]},{i:{x:[0.667],y:[1]},o:{x:[0.333],y:[0]},n:["0p667_1_0p333_0"],t:654.762,s:[100],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:669.524,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:686,s:[0],e:[0]},{t:719}]},w:{a:0,k:4.829},lc:1,lj:1,ml:10,nm:"Stroke 1",mn:"ADBE Vector Graphic - Stroke"},{ty:"tm",s:{a:1,k:[{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:0,s:[0],e:[0]},{i:{x:[0.667],y:[1]},o:{x:[0.167],y:[0.167]},n:["0p667_1_0p167_0p167"],t:11.477,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:41,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:56,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0]},n:["0p833_0p833_0p167_0"],t:89,s:[100],e:[0]},{i:{x:[0.833],y:[1]},o:{x:[0.167],y:[0.167]},n:["0p833_1_0p167_0p167"],t:90,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0]},n:["0p833_0p833_0p167_0"],t:629,s:[100],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:630,s:[0],e:[0]},{i:{x:[0.667],y:[1]},o:{x:[0.167],y:[0.167]},n:["0p667_1_0p167_0p167"],t:641.477,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:671,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:686,s:[100],e:[100]},{t:719}],ix:1},e:{a:1,k:[{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:0,s:[0],e:[0]},{i:{x:[0],y:[1]},o:{x:[0.167],y:[0.167]},n:["0_1_0p167_0p167"],t:10,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:39.524,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:56,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0]},n:["0p833_0p833_0p167_0"],t:89,s:[100],e:[0]},{i:{x:[0.833],y:[1]},o:{x:[0.167],y:[0.167]},n:["0p833_1_0p167_0p167"],t:90,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0]},n:["0p833_0p833_0p167_0"],t:629,s:[100],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:630,s:[0],e:[0]},{i:{x:[0],y:[1]},o:{x:[0.167],y:[0.167]},n:["0_1_0p167_0p167"],t:640,s:[0],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:669.524,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:686,s:[100],e:[100]},{t:719}],ix:2},o:{a:0,k:0,ix:3},m:1,ix:3,nm:"Trim Paths 1",mn:"ADBE Vector Filter - Trim"},{ty:"tr",p:{a:0,k:[312.078,177.185],ix:2},a:{a:0,k:[0,0],ix:1},s:{a:0,k:[100,100],ix:3},r:{a:0,k:0,ix:6},o:{a:0,k:100,ix:7},sk:{a:0,k:0,ix:4},sa:{a:0,k:0,ix:5},nm:"Transform"}],nm:"Group 1",np:3,mn:"ADBE Vector Group"}],ip:0,op:450,st:10,bm:0,sr:1},{ddd:0,ind:12,ty:4,nm:"Fireworks",parent:0,ks:{o:{a:1,k:[{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:53,s:[100],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:56,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:90,s:[0],e:[100]},{t:93}]},r:{a:0,k:0},p:{a:1,k:[{i:{x:0.833,y:0.833},o:{x:0.333,y:0},n:"0p833_0p833_0p333_0",t:0,s:[7.784,-100.71,0],e:[7.784,99.29,0],to:[0,33.3333320617676,0],ti:[0,-33.3333320617676,0]},{i:{x:0.833,y:0.833},o:{x:0.167,y:0.167},n:"0p833_0p833_0p167_0p167",t:56,s:[7.784,99.29,0],e:[7.784,99.29,0],to:[0,0,0],ti:[0,0,0]},{i:{x:0.667,y:1},o:{x:0.167,y:0.167},n:"0p667_1_0p167_0p167",t:89,s:[7.784,99.29,0],e:[7.784,-100.71,0],to:[0,-33.3333320617676,0],ti:[0,33.3333320617676,0]},{t:90}]},a:{a:0,k:[225.631,140.499,0]},s:{a:0,k:[100,100,100]}},ao:0,shapes:[{ty:"gr",it:[{ind:0,ty:"sh",ks:{a:0,k:{i:[[0,0],[0,0],[0,0],[0,0]],o:[[0,0],[0,0],[0,0],[0,0]],v:[[1.091,10.526],[-8.034,1.938],[-1.091,-10.526],[8.034,-1.938]],c:true}},nm:"Path 1",mn:"ADBE Vector Shape - Group"},{ty:"fl",c:{a:0,k:[1,0.10196078431372549,0.21176470588235294,1]},o:{a:0,k:100},nm:"Fill 1",mn:"ADBE Vector Graphic - Fill"},{ty:"tr",p:{a:1,k:[{i:{x:0,y:1},o:{x:0.167,y:0.167},n:"0_1_0p167_0p167",t:0,s:[218.951,244.775],e:[-64.365,214.365],to:[-47.2194023132324,-5.068359375],ti:[47.2194023132324,5.068359375]},{i:{x:0,y:0},o:{x:0.167,y:0.167},n:"0_0_0p167_0p167",t:50,s:[-64.365,214.365],e:[-64.365,214.365],to:[0,0],ti:[0,0]},{i:{x:0,y:0},o:{x:0.167,y:0.167},n:"0_0_0p167_0p167",t:56,s:[-64.365,214.365],e:[-64.365,214.365],to:[0,0],ti:[0,0]},{i:{x:0.833,y:0.833},o:{x:0.167,y:0},n:"0p833_0p833_0p167_0",t:89,s:[-64.365,214.365],e:[218.951,244.775],to:[47.2194023132324,5.068359375],ti:[-47.2194023132324,-5.068359375]},{t:90}],ix:2},a:{a:0,k:[0,0],ix:1},s:{a:0,k:[100,100],ix:3},r:{a:1,k:[{i:{x:[0],y:[1]},o:{x:[0.167],y:[0.167]},n:["0_1_0p167_0p167"],t:0,s:[-1996],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:50,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:56,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0]},n:["0p833_0p833_0p167_0"],t:89,s:[0],e:[-1996]},{t:90}],ix:6},o:{a:1,k:[{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:0,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:15.834,s:[100],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:50,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:56,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:89,s:[0],e:[100]},{t:90}],ix:7},sk:{a:0,k:0,ix:4},sa:{a:0,k:0,ix:5},nm:"Transform"}],nm:"Group 1",np:2,mn:"ADBE Vector Group"},{ty:"gr",it:[{ind:0,ty:"sh",ks:{a:0,k:{i:[[0,0],[0,0],[0,0],[0,0]],o:[[0,0],[0,0],[0,0],[0,0]],v:[[10.032,-3.369],[3.65,7.414],[-10.032,3.37],[-3.65,-7.414]],c:true}},nm:"Path 1",mn:"ADBE Vector Shape - Group"},{ty:"fl",c:{a:0,k:[1,0.8823529411764706,0.32941176470588235,1]},o:{a:0,k:100},nm:"Fill 1",mn:"ADBE Vector Graphic - Fill"},{ty:"tr",p:{a:1,k:[{i:{x:0,y:1},o:{x:0.167,y:0.167},n:"0_1_0p167_0p167",t:0,s:[217.823,241.687],e:[62.624,26.913],to:[-25.8665370941162,-35.7955741882324],ti:[25.8665370941162,35.7955741882324]},{i:{x:0,y:0},o:{x:0.167,y:0.167},n:"0_0_0p167_0p167",t:33,s:[62.624,26.913],e:[62.624,26.913],to:[0,0],ti:[0,0]},{i:{x:0,y:0},o:{x:0.167,y:0.167},n:"0_0_0p167_0p167",t:56,s:[62.624,26.913],e:[62.624,26.913],to:[0,0],ti:[0,0]},{i:{x:0.833,y:0.833},o:{x:0.167,y:0},n:"0p833_0p833_0p167_0",t:89,s:[62.624,26.913],e:[217.823,241.687],to:[25.8665370941162,35.7955741882324],ti:[-25.8665370941162,-35.7955741882324]},{t:90}],ix:2},a:{a:0,k:[0,0],ix:1},s:{a:0,k:[100,100],ix:3},r:{a:1,k:[{i:{x:[0],y:[1]},o:{x:[0.167],y:[0.167]},n:["0_1_0p167_0p167"],t:0,s:[1909],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:33,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:56,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0]},n:["0p833_0p833_0p167_0"],t:89,s:[0],e:[1909]},{t:90}],ix:6},o:{a:1,k:[{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:0,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:10.45,s:[100],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:33,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:56,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:89,s:[0],e:[100]},{t:90}],ix:7},sk:{a:0,k:0,ix:4},sa:{a:0,k:0,ix:5},nm:"Transform"}],nm:"Group 2",np:2,mn:"ADBE Vector Group"},{ty:"gr",it:[{ind:0,ty:"sh",ks:{a:0,k:{i:[[0,0],[0,0],[0,0],[0,0]],o:[[0,0],[0,0],[0,0],[0,0]],v:[[5.439,-9.079],[7.591,3.266],[-5.438,9.079],[-7.591,-3.265]],c:true}},nm:"Path 1",mn:"ADBE Vector Shape - Group"},{ty:"fl",c:{a:0,k:[1,0.10196078431372549,0.21176470588235294,1]},o:{a:0,k:100},nm:"Fill 1",mn:"ADBE Vector Graphic - Fill"},{ty:"tr",p:{a:1,k:[{i:{x:0,y:1},o:{x:0.167,y:0.167},n:"0_1_0p167_0p167",t:0,s:[216.419,243.707],e:[310.345,5.738],to:[15.654296875,-39.6614570617676],ti:[-15.654296875,39.6614570617676]},{i:{x:0,y:0},o:{x:0.167,y:0.167},n:"0_0_0p167_0p167",t:44,s:[310.345,5.738],e:[310.345,5.738],to:[0,0],ti:[0,0]},{i:{x:0,y:0},o:{x:0.167,y:0.167},n:"0_0_0p167_0p167",t:56,s:[310.345,5.738],e:[310.345,5.738],to:[0,0],ti:[0,0]},{i:{x:0.833,y:0.833},o:{x:0.167,y:0},n:"0p833_0p833_0p167_0",t:89,s:[310.345,5.738],e:[216.419,243.707],to:[-15.654296875,39.6614570617676],ti:[15.654296875,-39.6614570617676]},{t:90}],ix:2},a:{a:0,k:[0,0],ix:1},s:{a:0,k:[100,100],ix:3},r:{a:1,k:[{i:{x:[0],y:[1]},o:{x:[0.167],y:[0.167]},n:["0_1_0p167_0p167"],t:0,s:[-1082],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:44,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:56,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0]},n:["0p833_0p833_0p167_0"],t:89,s:[0],e:[-1082]},{t:90}],ix:6},o:{a:1,k:[{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:0,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:13.934,s:[100],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:44,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:56,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:89,s:[0],e:[100]},{t:90}],ix:7},sk:{a:0,k:0,ix:4},sa:{a:0,k:0,ix:5},nm:"Transform"}],nm:"Group 3",np:2,mn:"ADBE Vector Group"},{ty:"gr",it:[{ind:0,ty:"sh",ks:{a:0,k:{i:[[0,0],[0,0],[0,0],[0,0]],o:[[0,0],[0,0],[0,0],[0,0]],v:[[10.032,-3.369],[3.649,7.414],[-10.032,3.37],[-3.65,-7.414]],c:true}},nm:"Path 1",mn:"ADBE Vector Shape - Group"},{ty:"fl",c:{a:0,k:[1,0.10196078431372549,0.21176470588235294,1]},o:{a:0,k:100},nm:"Fill 1",mn:"ADBE Vector Graphic - Fill"},{ty:"tr",p:{a:1,k:[{i:{x:0,y:1},o:{x:0.167,y:0.167},n:"0_1_0p167_0p167",t:0,s:[220.852,243.393],e:[503.969,162.999],to:[47.1861991882324,-13.3990888595581],ti:[-47.1861991882324,13.3990888595581]},{i:{x:0,y:0},o:{x:0.167,y:0.167},n:"0_0_0p167_0p167",t:56,s:[503.969,162.999],e:[503.969,162.999],to:[0,0],ti:[0,0]},{i:{x:0.833,y:0.833},o:{x:0.167,y:0},n:"0p833_0p833_0p167_0",t:89,s:[503.969,162.999],e:[220.852,243.393],to:[-47.1861991882324,13.3990888595581],ti:[47.1861991882324,-13.3990888595581]},{t:90}],ix:2},a:{a:0,k:[0,0],ix:1},s:{a:0,k:[100,100],ix:3},r:{a:1,k:[{i:{x:[0],y:[1]},o:{x:[0.167],y:[0.167]},n:["0_1_0p167_0p167"],t:0,s:[-1636],e:[0]},{i:{x:[0],y:[0]},o:{x:[0.167],y:[0.167]},n:["0_0_0p167_0p167"],t:56,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0]},n:["0p833_0p833_0p167_0"],t:89,s:[0],e:[-1636]},{t:90}],ix:6},o:{a:1,k:[{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:0,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:17.733,s:[100],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:56,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:89,s:[0],e:[100]},{t:90}],ix:7},sk:{a:0,k:0,ix:4},sa:{a:0,k:0,ix:5},nm:"Transform"}],nm:"Group 4",np:2,mn:"ADBE Vector Group"},{ty:"gr",it:[{ind:0,ty:"sh",ks:{a:0,k:{i:[[0,0],[0,0],[0,0],[0,0]],o:[[0,0],[0,0],[0,0],[0,0]],v:[[5.635,-8.958],[7.518,3.43],[-5.635,8.958],[-7.518,-3.431]],c:true}},nm:"Path 1",mn:"ADBE Vector Shape - Group"},{ty:"fl",c:{a:0,k:[0.4666666666666667,0.8980392156862745,0.8352941176470589,1]},o:{a:0,k:100},nm:"Fill 1",mn:"ADBE Vector Graphic - Fill"},{ty:"tr",p:{a:1,k:[{i:{x:0,y:1},o:{x:0.167,y:0.167},n:"0_1_0p167_0p167",t:0,s:[216.978,239.574],e:[167.638,-20.883],to:[-8.22330760955811,-43.4095039367676],ti:[8.22330760955811,43.4095039367676]},{i:{x:0,y:0},o:{x:0.167,y:0.167},n:"0_0_0p167_0p167",t:34,s:[167.638,-20.883],e:[167.638,-20.883],to:[0,0],ti:[0,0]},{i:{x:0,y:0},o:{x:0.167,y:0.167},n:"0_0_0p167_0p167",t:56,s:[167.638,-20.883],e:[167.638,-20.883],to:[0,0],ti:[0,0]},{i:{x:0.833,y:0.833},o:{x:0.167,y:0},n:"0p833_0p833_0p167_0",t:89,s:[167.638,-20.883],e:[216.978,239.574],to:[8.22330760955811,43.4095039367676],ti:[-8.22330760955811,-43.4095039367676]},{t:90}],ix:2},a:{a:0,k:[0,0],ix:1},s:{a:0,k:[100,100],ix:3},r:{a:1,k:[{i:{x:[0],y:[1]},o:{x:[0.167],y:[0.167]},n:["0_1_0p167_0p167"],t:0,s:[791],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:34,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:56,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0]},n:["0p833_0p833_0p167_0"],t:89,s:[0],e:[791]},{t:90}],ix:6},o:{a:1,k:[{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:0,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:10.767,s:[100],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:34,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:56,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:89,s:[0],e:[100]},{t:90}],ix:7},sk:{a:0,k:0,ix:4},sa:{a:0,k:0,ix:5},nm:"Transform"}],nm:"Group 5",np:2,mn:"ADBE Vector Group"},{ty:"gr",it:[{ind:0,ty:"sh",ks:{a:0,k:{i:[[0,0],[0,0],[0,0],[0,0]],o:[[0,0],[0,0],[0,0],[0,0]],v:[[12.714,-4.27],[4.625,9.396],[-12.714,4.27],[-4.625,-9.396]],c:true}},nm:"Path 1",mn:"ADBE Vector Shape - Group"},{ty:"fl",c:{a:0,k:[1,0.8823529411764706,0.32941176470588235,1]},o:{a:0,k:100},nm:"Fill 1",mn:"ADBE Vector Graphic - Fill"},{ty:"tr",p:{a:1,k:[{i:{x:0,y:1},o:{x:0.167,y:0.167},n:"0_1_0p167_0p167",t:0,s:[216.807,247.359],e:[306.713,-26.422],to:[14.984375,-45.6302070617676],ti:[-14.984375,45.6302070617676]},{i:{x:0,y:0},o:{x:0.167,y:0.167},n:"0_0_0p167_0p167",t:35,s:[306.713,-26.422],e:[306.713,-26.422],to:[0,0],ti:[0,0]},{i:{x:0,y:0},o:{x:0.167,y:0.167},n:"0_0_0p167_0p167",t:56,s:[306.713,-26.422],e:[306.713,-26.422],to:[0,0],ti:[0,0]},{i:{x:0.833,y:0.833},o:{x:0.167,y:0},n:"0p833_0p833_0p167_0",t:89,s:[306.713,-26.422],e:[216.807,247.359],to:[-14.984375,45.6302070617676],ti:[14.984375,-45.6302070617676]},{t:90}],ix:2},a:{a:0,k:[0,0],ix:1},s:{a:0,k:[100,100],ix:3},r:{a:1,k:[{i:{x:[0],y:[1]},o:{x:[0.167],y:[0.167]},n:["0_1_0p167_0p167"],t:0,s:[-1349],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:35,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:56,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0]},n:["0p833_0p833_0p167_0"],t:89,s:[0],e:[-1349]},{t:90}],ix:6},o:{a:1,k:[{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:0,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:11.084,s:[100],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:35,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:56,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:89,s:[0],e:[100]},{t:90}],ix:7},sk:{a:0,k:0,ix:4},sa:{a:0,k:0,ix:5},nm:"Transform"}],nm:"Group 6",np:2,mn:"ADBE Vector Group"},{ty:"gr",it:[{ind:0,ty:"sh",ks:{a:0,k:{i:[[0,0],[0,0],[0,0],[0,0]],o:[[0,0],[0,0],[0,0],[0,0]],v:[[16.462,-5.529],[5.988,12.166],[-16.462,5.529],[-5.99,-12.166]],c:true}},nm:"Path 1",mn:"ADBE Vector Shape - Group"},{ty:"fl",c:{a:0,k:[1,1,1,1]},o:{a:0,k:100},nm:"Fill 1",mn:"ADBE Vector Graphic - Fill"},{ty:"tr",p:{a:1,k:[{i:{x:0,y:1},o:{x:0.167,y:0.167},n:"0_1_0p167_0p167",t:0,s:[220.337,243.096],e:[496.388,105.69],to:[46.0084648132324,-22.9010410308838],ti:[-46.0084648132324,22.9010410308838]},{i:{x:0,y:0},o:{x:0.167,y:0.167},n:"0_0_0p167_0p167",t:50,s:[496.388,105.69],e:[496.388,105.69],to:[0,0],ti:[0,0]},{i:{x:0,y:0},o:{x:0.167,y:0.167},n:"0_0_0p167_0p167",t:56,s:[496.388,105.69],e:[496.388,105.69],to:[0,0],ti:[0,0]},{i:{x:0.833,y:0.833},o:{x:0.167,y:0},n:"0p833_0p833_0p167_0",t:89,s:[496.388,105.69],e:[220.337,243.096],to:[-46.0084648132324,22.9010410308838],ti:[46.0084648132324,-22.9010410308838]},{t:90}],ix:2},a:{a:0,k:[0,0],ix:1},s:{a:0,k:[100,100],ix:3},r:{a:1,k:[{i:{x:[0],y:[1]},o:{x:[0.167],y:[0.167]},n:["0_1_0p167_0p167"],t:0,s:[1085],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:50,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:56,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0]},n:["0p833_0p833_0p167_0"],t:89,s:[0],e:[1085]},{t:90}],ix:6},o:{a:1,k:[{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:0,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:15.834,s:[100],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:50,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:56,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:89,s:[0],e:[100]},{t:90}],ix:7},sk:{a:0,k:0,ix:4},sa:{a:0,k:0,ix:5},nm:"Transform"}],nm:"Group 7",np:2,mn:"ADBE Vector Group"},{ty:"gr",it:[{ind:0,ty:"sh",ks:{a:0,k:{i:[[0,0],[0,0],[0,0],[0,0]],o:[[0,0],[0,0],[0,0],[0,0]],v:[[7.21,-15.799],[12.976,3.938],[-7.209,15.799],[-12.976,-3.938]],c:true}},nm:"Path 1",mn:"ADBE Vector Shape - Group"},{ty:"fl",c:{a:0,k:[1,1,1,1]},o:{a:0,k:100},nm:"Fill 1",mn:"ADBE Vector Graphic - Fill"},{ty:"tr",p:{a:1,k:[{i:{x:0,y:1},o:{x:0.167,y:0.167},n:"0_1_0p167_0p167",t:0,s:[216.862,239.004],e:[502.475,218.079],to:[47.6022148132324,-3.48763012886047],ti:[-47.6022148132324,3.48763012886047]},{i:{x:0,y:0},o:{x:0.167,y:0.167},n:"0_0_0p167_0p167",t:28,s:[502.475,218.079],e:[502.475,218.079],to:[0,0],ti:[0,0]},{i:{x:0,y:0},o:{x:0.167,y:0.167},n:"0_0_0p167_0p167",t:56,s:[502.475,218.079],e:[502.475,218.079],to:[0,0],ti:[0,0]},{i:{x:0.833,y:0.833},o:{x:0.167,y:0},n:"0p833_0p833_0p167_0",t:89,s:[502.475,218.079],e:[216.862,239.004],to:[-47.6022148132324,3.48763012886047],ti:[47.6022148132324,-3.48763012886047]},{t:90}],ix:2},a:{a:0,k:[0,0],ix:1},s:{a:0,k:[100,100],ix:3},r:{a:1,k:[{i:{x:[0],y:[1]},o:{x:[0.167],y:[0.167]},n:["0_1_0p167_0p167"],t:0,s:[544],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:28,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:56,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0]},n:["0p833_0p833_0p167_0"],t:89,s:[0],e:[544]},{t:90}],ix:6},o:{a:1,k:[{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:0,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:8.867,s:[100],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:28,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:56,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:89,s:[0],e:[100]},{t:90}],ix:7},sk:{a:0,k:0,ix:4},sa:{a:0,k:0,ix:5},nm:"Transform"}],nm:"Group 8",np:2,mn:"ADBE Vector Group"},{ty:"gr",it:[{ind:0,ty:"sh",ks:{a:0,k:{i:[[0,0],[0,0],[0,0],[0,0]],o:[[0,0],[0,0],[0,0],[0,0]],v:[[11.889,12.659],[-8.563,10.515],[-11.889,-12.659],[8.562,-10.516]],c:true}},nm:"Path 1",mn:"ADBE Vector Shape - Group"},{ty:"fl",c:{a:0,k:[1,1,1,1]},o:{a:0,k:100},nm:"Fill 1",mn:"ADBE Vector Graphic - Fill"},{ty:"tr",p:{a:1,k:[{i:{x:0,y:1},o:{x:0.167,y:0.167},n:"0_1_0p167_0p167",t:0,s:[219.276,237.668],e:[218.221,-27.157],to:[-0.17578125,-44.1373710632324],ti:[0.17578125,44.1373710632324]},{i:{x:0,y:0},o:{x:0.167,y:0.167},n:"0_0_0p167_0p167",t:42,s:[218.221,-27.157],e:[218.221,-27.157],to:[0,0],ti:[0,0]},{i:{x:0,y:0},o:{x:0.167,y:0.167},n:"0_0_0p167_0p167",t:56,s:[218.221,-27.157],e:[218.221,-27.157],to:[0,0],ti:[0,0]},{i:{x:0.833,y:0.833},o:{x:0.167,y:0},n:"0p833_0p833_0p167_0",t:89,s:[218.221,-27.157],e:[219.276,237.668],to:[0.17578125,44.1373710632324],ti:[-0.17578125,-44.1373710632324]},{t:90}],ix:2},a:{a:0,k:[0,0],ix:1},s:{a:0,k:[100,100],ix:3},r:{a:1,k:[{i:{x:[0],y:[1]},o:{x:[0.167],y:[0.167]},n:["0_1_0p167_0p167"],t:0,s:[-1017],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:42,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:56,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0]},n:["0p833_0p833_0p167_0"],t:89,s:[0],e:[-1017]},{t:90}],ix:6},o:{a:1,k:[{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:0,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:13.301,s:[100],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:42,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:56,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:89,s:[0],e:[100]},{t:90}],ix:7},sk:{a:0,k:0,ix:4},sa:{a:0,k:0,ix:5},nm:"Transform"}],nm:"Group 9",np:2,mn:"ADBE Vector Group"},{ty:"gr",it:[{ind:0,ty:"sh",ks:{a:0,k:{i:[[0,0],[0,0],[0,0],[0,0]],o:[[0,0],[0,0],[0,0],[0,0]],v:[[11.889,12.66],[-8.562,10.516],[-11.889,-12.66],[8.562,-10.515]],c:true}},nm:"Path 1",mn:"ADBE Vector Shape - Group"},{ty:"fl",c:{a:0,k:[1,1,1,1]},o:{a:0,k:100},nm:"Fill 1",mn:"ADBE Vector Graphic - Fill"},{ty:"tr",p:{a:1,k:[{i:{x:0,y:1},o:{x:0.167,y:0.167},n:"0_1_0p167_0p167",t:0,s:[219.081,240.186],e:[-48.224,-10.22],to:[-44.55078125,-41.734375],ti:[44.55078125,41.734375]},{i:{x:0,y:0},o:{x:0.167,y:0.167},n:"0_0_0p167_0p167",t:25,s:[-48.224,-10.22],e:[-48.224,-10.22],to:[0,0],ti:[0,0]},{i:{x:0,y:0},o:{x:0.167,y:0.167},n:"0_0_0p167_0p167",t:56,s:[-48.224,-10.22],e:[-48.224,-10.22],to:[0,0],ti:[0,0]},{i:{x:0.833,y:0.833},o:{x:0.167,y:0},n:"0p833_0p833_0p167_0",t:89,s:[-48.224,-10.22],e:[219.081,240.186],to:[44.55078125,41.734375],ti:[-44.55078125,-41.734375]},{t:90}],ix:2},a:{a:0,k:[0,0],ix:1},s:{a:0,k:[100,100],ix:3},r:{a:1,k:[{i:{x:[0],y:[1]},o:{x:[0.167],y:[0.167]},n:["0_1_0p167_0p167"],t:0,s:[1408],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:25,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:56,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0]},n:["0p833_0p833_0p167_0"],t:89,s:[0],e:[1408]},{t:90}],ix:6},o:{a:1,k:[{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:0,s:[100],e:[100]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:7.917,s:[100],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:25,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:56,s:[0],e:[0]},{i:{x:[0.833],y:[0.833]},o:{x:[0.167],y:[0.167]},n:["0p833_0p833_0p167_0p167"],t:89,s:[0],e:[100]},{t:90}],ix:7},sk:{a:0,k:0,ix:4},sa:{a:0,k:0,ix:5},nm:"Transform"}],nm:"Group 10",np:2,mn:"ADBE Vector Group"}],ip:0,op:450,st:0,bm:0,sr:1},{ddd:0,ind:13,ty:1,nm:"White Solid 1",ks:{o:{a:0,k:100},r:{a:0,k:0},p:{a:0,k:[400,398,0]},a:{a:0,k:[400,400,0]},s:{a:0,k:[100,100,100]}},ao:0,sw:800,sh:800,sc:"",ip:0,op:0,st:0,bm:0,sr:1}];var confetti = {v:v,fr:fr,ip:ip,op:op,w:w,h:h,ddd:ddd,assets:assets,layers:layers};

const useStyles$t = makeStyles({
  background: {
    zIndex: 1,
    position: 'relative',
    background: 'linear-gradient(180deg, #DAD5FA -7.36%, #D6ECF5 108.9%)'
  },
  celebrationWrapper: {
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    position: 'absolute'
  },
  celebration: {
    width: '250%',
    height: '250%',
    position: 'absolute',
    left: '-75%',
    top: '-50%',
    zIndex: -1
  }
});
const AmpersandImages = _ref => {
  let {
    studentAvatarUrl = '',
    scid,
    studentName = '',
    shouldCelebrate,
    collegeName
  } = _ref;
  const classes = useStyles$t();
  const studentAvatarSrc = studentAvatarUrl ? imageAsFullImageSrc(studentAvatarUrl) : undefined;
  const {
    preferenceMatchContent
  } = useContext(Context$2);
  return /*#__PURE__*/React.createElement(Box, {
    className: classes.background
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    position: "relative",
    alignItems: "center",
    justifyContent: "center",
    height: "128px"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.celebrationWrapper
  }, /*#__PURE__*/React.createElement(LottieComponent, {
    className: classes.celebration,
    show: shouldCelebrate,
    animationData: confetti,
    durationMilliseconds: 4000
  })), /*#__PURE__*/React.createElement(AvatarWithFallback, {
    iconColor: ICON_COLOR.secondary,
    title: studentName,
    sourceUrl: studentAvatarSrc,
    fallbackIcon: studentName.charAt(0),
    variant: "circular"
  }), /*#__PURE__*/React.createElement(Box, {
    m: 1
  }, /*#__PURE__*/React.createElement(AvatarWithFallback, {
    iconColor: ICON_COLOR.secondary,
    fallbackIcon: "&",
    size: "sm",
    variant: "circular"
  })), /*#__PURE__*/React.createElement(Paper, {
    elevation: 0,
    title: collegeName
  }, /*#__PURE__*/React.createElement(CollegeCrest, {
    scid: scid,
    alt: `${collegeName} logo`
  }))), /*#__PURE__*/React.createElement(React.Fragment, null, preferenceMatchContent ? preferenceMatchContent : null));
};
AmpersandImages.propTypes = {
  studentAvatarUrl: PropTypes.string,
  scid: PropTypes.number,
  studentName: PropTypes.string,
  collegeName: PropTypes.string,
  shouldCelebrate: PropTypes.bool,
  footer: PropTypes.node
};

const Labels = _ref => {
  let {
    matchedPreferences
  } = _ref;
  const prefs = reject(matchedPreferences, pref => {
    return isEmpty(pref.props.preference[0]);
  });
  return prefs.map((pref, idx) => /*#__PURE__*/React.createElement(Box, {
    key: idx,
    pr: 1,
    pb: 1,
    display: "inline-block"
  }, /*#__PURE__*/React.createElement(Pill, {
    color: "secondary"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faCheck
  }), " \xA0 ", pref)));
};
Labels.propTypes = {
  matchedPreferences: PropTypes.array
};

const getCurrentMatchState = (hasPreferences, hasMatchedPreferences) => {
  return hasMatchedPreferences ? MATCHED : hasPreferences ? NOT_MATCHED : NO_PREFERENCES;
};
const withoutEmptyValues = obj => {
  const newObj = {};
  forEach(obj, (value, key) => {
    if (!isEmpty(value)) {
      newObj[key] = value;
    }
  });
  return newObj;
};
const getStudentPreferences = student => {
  const MustHave = withoutEmptyValues(get(student, 'MustHave', {}));
  const NiceToHave = withoutEmptyValues(get(student, 'NiceToHave', {}));
  return {
    MustHave,
    NiceToHave,
    hasPreferences: !isEmpty(MustHave) || !isEmpty(NiceToHave)
  };
};
const ARRAY_PATH_REGEX = /\.\d+\b/gi;
const getMatchedPreferences = (studentPreferences, preferenceMatches) => {
  const matchedPreferences = {};
  preferenceMatches.forEach(matchedPath => {
    const value = get(studentPreferences, matchedPath);
    if (isNumber(value) || isBoolean(value) || !isEmpty(value)) {
      if (ARRAY_PATH_REGEX.test(matchedPath)) {
        const trimmedPath = matchedPath.replace(ARRAY_PATH_REGEX, '');
        if (!isArray(get(matchedPreferences, trimmedPath))) {
          set(matchedPreferences, trimmedPath, []);
        }
        const arr = get(matchedPreferences, trimmedPath);
        arr.push(value);
      } else {
        set(matchedPreferences, matchedPath, value);
      }
    }
  });
  return matchedPreferences;
};
const getDisplayPreferences = (studentPreferences, preferenceMatches) => {
  const matchedPreferences = getMatchedPreferences(studentPreferences, preferenceMatches);
  const {
    MustHave,
    NiceToHave
  } = getStudentPreferences(matchedPreferences);
  let displayPreferences = [];
  if (!isEmpty(MustHave)) {
    displayPreferences = concat(displayPreferences, preferenceDisplayHelper(MustHave));
  }
  if (!isEmpty(NiceToHave)) {
    displayPreferences = concat(displayPreferences, preferenceDisplayHelper(NiceToHave));
  }
  return displayPreferences;
};
const CONTENT_TITLE_GETTERS = {
  [NO_PREFERENCES]: _ref => {
    let {
      collegeName
    } = _ref;
    return `Is ${collegeName} a match?`;
  },
  [MATCHED]: _ref2 => {
    let {
      collegeName,
      isStudent,
      studentFirstName
    } = _ref2;
    return isStudent ? `${collegeName} matches these preferences` : `${collegeName} and ${studentFirstName}'s preferences`;
  },
  [NOT_MATCHED]: _ref3 => {
    let {
      isStudent
    } = _ref3;
    return isStudent ? 'Like this college?' : 'Still finding a fit';
  }
};
const CONTENT_BODY_GETTERS = {
  [NO_PREFERENCES]: _ref4 => {
    let {
      studentFirstName,
      isStudent
    } = _ref4;
    return isStudent ? "Let's find out!" : `Encourage ${studentFirstName} to add preferences to find out`;
  },
  [MATCHED]: () => undefined,
  [NOT_MATCHED]: _ref5 => {
    let {
      isStudent,
      studentFirstName,
      collegeName
    } = _ref5;
    return isStudent ? 'Update your preferences to find more like it' : `${collegeName} doesn't match ${studentFirstName}'s preferences`;
  }
};

const useUpdateStudentPreferencesIfNeeded = (studentPreferences, onChangeStudentPreferences) => {
  const lastStudentPrefs = useRef(JSON.stringify(studentPreferences));
  const studentPreferencesHasChanged = lastStudentPrefs.current !== JSON.stringify(studentPreferences);
  if (studentPreferencesHasChanged) {
    lastStudentPrefs.current = JSON.stringify(studentPreferences);
    onChangeStudentPreferences();
  }
};

const PreferenceMatchCard = _ref => {
  let {
    getActions,
    college,
    students = [],
    isStudent,
    preferenceMatches = [],
    currentStudentIndex = 0,
    onClickEditPreferences,
    onChangeCurrentStudentIndex,
    onChangeStudentPreferences
  } = _ref;
  const collegeName = get(college, 'Name');
  const scid = get(college, 'Scid');
  const currentStudent = students[currentStudentIndex]; // eslint-disable-line
  const studentAvatarUrl = get(currentStudent, 'AvatarUrl');
  const studentFirstName = get(currentStudent, 'FirstName');
  const studentLastName = get(currentStudent, 'LastName');
  const studentName = `${studentFirstName} ${studentLastName}`;
  const studentPreferences = getStudentPreferences(currentStudent);
  const {
    hasPreferences
  } = studentPreferences;
  const matchedPreferenceValues = getDisplayPreferences(studentPreferences, preferenceMatches);
  const currentMatchState = getCurrentMatchState(hasPreferences, !isEmpty(matchedPreferenceValues));
  const getContentTitle = CONTENT_TITLE_GETTERS[currentMatchState];
  const contentTitle = getContentTitle({
    collegeName,
    isStudent,
    studentFirstName
  });
  const getContentBody = CONTENT_BODY_GETTERS[currentMatchState];
  const contentBody = getContentBody({
    collegeName,
    isStudent,
    studentFirstName
  });
  const hasMultipleStudents = students.length > 1;
  const isMatched = currentMatchState === MATCHED;
  const canUpdatePreferences = isStudent && isMatched && hasPreferences && isFunction(onClickEditPreferences);
  useUpdateStudentPreferencesIfNeeded(studentPreferences, onChangeStudentPreferences);
  return /*#__PURE__*/React.createElement(ComplexCard, {
    editControls: hasMultipleStudents && /*#__PURE__*/React.createElement(StudentSelector, {
      students: students,
      selectedIndex: currentStudentIndex,
      onSelect: idx => onChangeCurrentStudentIndex(idx)
    }),
    customMedia: currentMatchState !== NOT_MATCHED && /*#__PURE__*/React.createElement(AmpersandImages, {
      shouldCelebrate: isMatched,
      studentAvatarUrl: studentAvatarUrl,
      studentName: studentName,
      collegeName: collegeName,
      scid: scid
    }),
    maxWidth: "100%",
    contentTitle: contentTitle,
    contentBody: contentBody,
    contentIcon: canUpdatePreferences && /*#__PURE__*/React.createElement(IconButton, {
      size: "small",
      color: "primary",
      onClick: onClickEditPreferences
    }, /*#__PURE__*/React.createElement(Box, {
      height: "30px",
      width: "30px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faUserEdit
    }))),
    labels: /*#__PURE__*/React.createElement(Labels, {
      matchedPreferences: matchedPreferenceValues
    }),
    actions: isFunction(getActions) && getActions(currentStudent, scid, currentMatchState),
    showContentEmptyState: false
  });
};
PreferenceMatchCard.propTypes = {
  college: PropTypes.object.isRequired,
  students: PropTypes.array,
  preferenceMatches: PropTypes.array,
  isStudent: PropTypes.bool,
  onClickEditPreferences: PropTypes.func,
  onChangeCurrentStudentIndex: PropTypes.func,
  currentStudentIndex: PropTypes.number,
  getActions: PropTypes.func,
  onChangeStudentPreferences: PropTypes.func
};

const sortStudents = students => {
  return orderBy(students, ['Profile.GraduationYear', 'LastName', 'FirstName', 'MiddleName'], ['asc', 'asc', 'asc', 'asc']);
};
const PreferenceMatchSection = _ref => {
  let {
    scid,
    college,
    isInStudentApp,
    preferenceMatchStudents = [],
    preferenceMatchStudentsLoaded = true,
    getPreferenceMatchCardActions,
    getPreferenceMatches,
    onClickEditPreferences,
    onReportHasContent
  } = _ref;
  const students = useMemo(() => {
    return sortStudents(preferenceMatchStudents);
  }, [preferenceMatchStudents]);
  const [currentStudentIndex, setCurrentStudentIndex] = useState(0);
  const currentStudent = students[currentStudentIndex];
  const {
    loading,
    preferenceMatches,
    refetchStudentPreferences
  } = usePreferenceMatches(getPreferenceMatches, scid, get(currentStudent, 'Id'));
  const hasContent = isFunction(getPreferenceMatches) && !isEmpty(students);
  useCallbackOnMount(() => {
    if (preferenceMatchStudentsLoaded) {
      onReportHasContent(hasContent);
    }
  }, [hasContent, preferenceMatchStudentsLoaded]);
  return !hasContent ? null : loading ? /*#__PURE__*/React.createElement(Box, {
    p: 2,
    justifyContent: "center",
    display: "flex"
  }, /*#__PURE__*/React.createElement(LoadingIndicator, {
    enabled: true
  })) : /*#__PURE__*/React.createElement(PreferenceMatchCard, {
    college: college,
    students: students,
    isStudent: isInStudentApp,
    preferenceMatches: preferenceMatches,
    onClickEditPreferences: onClickEditPreferences,
    currentStudentIndex: currentStudentIndex,
    onChangeCurrentStudentIndex: setCurrentStudentIndex,
    onChangeStudentPreferences: refetchStudentPreferences,
    getActions: getPreferenceMatchCardActions
  });
};
PreferenceMatchSection.propTypes = {
  scid: PropTypes.number,
  college: PropTypes.object,
  isInStudentApp: PropTypes.bool,
  preferenceMatchStudents: PropTypes.array,
  preferenceMatchStudentsLoaded: PropTypes.bool,
  getPreferenceMatches: PropTypes.func,
  onClickEditPreferences: PropTypes.func,
  onReportHasContent: PropTypes.func.isRequired,
  getPreferenceMatchCardActions: PreferenceMatchCard.propTypes.getActions
};
var PreferenceMatchSection$1 = withContext(PreferenceMatchSection, Context$2);

const useStyles$s = makeStyles(theme => ({
  root: {
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      paddingBottom: '0px',
      paddingTop: '0px'
    }
  }
}));
const ColumnList = _ref => {
  let {
    subheader,
    subheaderProps,
    items,
    width
  } = _ref;
  const classes = useStyles$s();
  return /*#__PURE__*/React.createElement(Box, {
    display: "inline-block",
    width: width,
    minWidth: "250px"
  }, /*#__PURE__*/React.createElement(List, {
    subheader: subheader && /*#__PURE__*/React.createElement(ListSubheader, subheaderProps, subheader),
    className: classes.root
  }, map(items, (item, idx) => {
    return /*#__PURE__*/React.createElement(ListItem, {
      key: idx
    }, /*#__PURE__*/React.createElement(Box, {
      mr: 2
    }, item.isScoirApplyIcon ? /*#__PURE__*/React.createElement(DisplayScoirApplyIcon, {
      isScoirApplyEnabled: true,
      fontSize: "32px"
    }) : item.iconComponent || /*#__PURE__*/React.createElement(AvatarWithFallback, {
      variant: "circular",
      size: "sm",
      iconColor: ICON_COLOR.info,
      sourceUrl: item.iconImage,
      fallbackIcon: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        size: "xs",
        icon: item.icon
      })
    })), /*#__PURE__*/React.createElement(ListItemText, {
      primary: item.primaryText,
      secondary: item.secondaryText
    }));
  })));
};
ColumnList.propTypes = {
  subheader: PropTypes.string,
  subheaderProps: PropTypes.object,
  items: PropTypes.array,
  width: PropTypes.string.isRequired
};

const ColumnLists = _ref => {
  let {
    subheader,
    lists,
    subheaderProps
  } = _ref;
  const isMultiList = lists.length > 1;
  const boxProps = isMultiList ? {
    display: 'flex',
    flexWrap: 'wrap'
  } : undefined;
  return /*#__PURE__*/React.createElement(Box, boxProps, map(lists, (items, idx) => /*#__PURE__*/React.createElement(ColumnList, {
    subheader: subheader,
    subheaderProps: subheaderProps,
    items: items,
    key: idx,
    width: isMultiList ? '50%' : '100%'
  })));
};
ColumnLists.propTypes = {
  subheader: PropTypes.string,
  subheaderProps: PropTypes.object,
  lists: PropTypes.array
};

var img$3 = "data:image/png;base64,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";

const HBCU = 'Historically Black College and University (HBCU)';
const HBCU_DESCRIPTION = 'A college established prior to 1964 whose principal mission was, and is, the education of Black Americans. Today, HBCUs serve a vital role in higher education, providing stable and nurturing environments for students to complete college.';
const SCOIR_APPLY = 'Apply with Scoir';
const SCOIR_APPLY_DESCRIPTION = 'Fill out the basics for one college application, and fast-track your others using the same info. Goodbye copy-and-paste! 👋';
const COALITION = 'Coalition for College';
const COALITION_DESCRIPTION = 'Coalition member schools are committed to making college affordable and ensuring students graduate on time with low-to-no debt.';
const UNIV_TYPE_LESS_THAN_2 = 'Less than 2-Year';
const UNIV_TYPE_LESS_THAN_2_DESCRIPTION = 'Offers Certificate programs typically lasting less than two years.';
const UNIV_TYPE_2_YEAR = '2-Year';
const UNIV_TYPE_2_YEAR_DESCRIPTION = 'Offers Associate degrees and vocational training programs typically completed within two years.';
const UNIV_TYPE_4_YEAR = '4-Year';
const UNIV_TYPE_4_YEAR_DESCRIPTION = "Offers Bachelor's degrees typically completed in four years.";
const CAREER_AND_TRADE = 'Career & Trade';
const CAREER_AND_TRADE_DESCRIPTION = 'Offers specialized hands-on training and certification programs.';
const UNIV_TYPES = {
  'Less than 2 year': {
    type: UNIV_TYPE_LESS_THAN_2,
    description: UNIV_TYPE_LESS_THAN_2_DESCRIPTION,
    icon: faFileCertificate
  },
  '2 year': {
    type: UNIV_TYPE_2_YEAR,
    description: UNIV_TYPE_2_YEAR_DESCRIPTION,
    icon: faAward
  },
  '4 year': {
    type: UNIV_TYPE_4_YEAR,
    description: UNIV_TYPE_4_YEAR_DESCRIPTION,
    icon: faDiploma
  }
};
const isItemInvalid = item => {
  return isUndefined(item) || isEmpty(item) || item == 'Not applicable' || item == 'None';
};
const getReligionDisplayText = college => {
  const religion = get(college, 'GeneralInfo.OthRelig');
  const hasReligion = !isItemInvalid(religion);
  let religionDisplayText = '';
  if (hasReligion) {
    religionDisplayText = `${religion} affiliation`;
  }
  return {
    religionDisplayText,
    hasReligion: !isItemInvalid(religion)
  };
};
const getUnivType = function (college) {
  let isTnTSearchFilterEnabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const univTypeValue = get(college, 'GeneralInfo.UnivType');
  const hasUnivType = isTnTSearchFilterEnabled && Boolean(univTypeValue);
  let univTypeData = {};
  if (hasUnivType) {
    univTypeData = get(UNIV_TYPES, univTypeValue, {});
  }
  return {
    univType: univTypeData.type,
    univTypeDescription: univTypeData.description,
    univTypeIcon: univTypeData.icon,
    hasUnivType: hasUnivType
  };
};
const getHbcu = college => {
  const hasHbcu = get(college, 'GeneralInfo.HBCU', false);
  return {
    hbcu: HBCU,
    hbcuDescription: HBCU_DESCRIPTION,
    hasHbcu
  };
};
const getScoirApply = college => {
  const isScoirApplyEnabled = get(college, 'DisplayAsScoirApply', false);
  return {
    scoirApplyText: SCOIR_APPLY,
    scoirApplyDesc: SCOIR_APPLY_DESCRIPTION,
    isScoirApplyEnabled
  };
};
const getCoalition = college => {
  const isCoalitionMember = get(college, 'CoalitionMember', false);
  return {
    coalitionText: COALITION,
    coalitionDesc: COALITION_DESCRIPTION,
    isCoalitionMember
  };
};
const getSchoolClassifier = (college, isTnTSearchFilterEnabled) => {
  const schoolClassifierValue = get(college, 'GeneralInfo.SchoolClassifier');
  const hasSchoolClassifier = isTnTSearchFilterEnabled && schoolClassifierValue === 'CareerAndTrade';
  return {
    schoolClassifierText: CAREER_AND_TRADE,
    schoolClassifierDesc: CAREER_AND_TRADE_DESCRIPTION,
    hasSchoolClassifier
  };
};
const getLists$2 = function () {
  let college = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let isTnTSearchFilterEnabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const {
    schoolType,
    schoolTypeDescription,
    hasSchoolType
  } = getSchoolType(college);
  const {
    univType,
    univTypeDescription,
    univTypeIcon,
    hasUnivType
  } = getUnivType(college, isTnTSearchFilterEnabled);
  const {
    schoolClassifierText,
    schoolClassifierDesc,
    hasSchoolClassifier
  } = getSchoolClassifier(college, isTnTSearchFilterEnabled);
  const {
    religionDisplayText,
    hasReligion
  } = getReligionDisplayText(college);
  const {
    hbcu,
    hbcuDescription,
    hasHbcu
  } = getHbcu(college);
  const {
    scoirApplyText,
    scoirApplyDesc,
    isScoirApplyEnabled
  } = getScoirApply(college);
  const {
    coalitionText,
    coalitionDesc,
    isCoalitionMember
  } = getCoalition(college);
  return reject([reject([isScoirApplyEnabled && {
    primaryText: scoirApplyText,
    secondaryText: scoirApplyDesc,
    isScoirApplyIcon: true
  }, isCoalitionMember && {
    iconImage: img$3,
    primaryText: coalitionText,
    secondaryText: coalitionDesc
  }, hasUnivType && {
    icon: univTypeIcon,
    primaryText: univType,
    secondaryText: univTypeDescription
  }, hasSchoolClassifier && {
    icon: faTools,
    primaryText: schoolClassifierText,
    secondaryText: schoolClassifierDesc
  }, hasSchoolType && {
    icon: faUniversity,
    primaryText: schoolType,
    secondaryText: schoolTypeDescription
  }, hasReligion && {
    icon: faPlaceOfWorship,
    primaryText: religionDisplayText
  }, hasHbcu && {
    icon: faBadge,
    primaryText: hbcu,
    secondaryText: hbcuDescription
  }], item => !item)], item => isEmpty(item));
};

const useStyles$r = makeStyles(() => ({
  visitButton: {
    '& .MuiButton-iconSizeLarge': {
      fontSize: 18,
      '& > *:first-child': {
        fontSize: 18
      }
    }
  }
}));
const AboutUs = _ref => {
  let {
    college,
    onReportHasContent,
    isTnTSearchFilterEnabled = false
  } = _ref;
  const classes = useStyles$r();
  const eventTracking = useEventTracking();
  const [getMetadata] = useMetadata();
  const lists = getLists$2(college, isTnTSearchFilterEnabled);
  const url = college.WwwUrl;
  const hasUrl = !isEmpty(url);
  const hasLists = !isEmpty(lists);
  const hasContent = hasUrl || hasLists;
  useCallbackOnMount(() => {
    onReportHasContent(hasContent);
  }, [hasContent]);
  const trackEvent = () => {
    get(eventTracking, 'visitWebsite', noop)(url, getMetadata());
  };
  return !hasContent ? null : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SectionTitle, {
    title: "About Us",
    titleProps: {
      component: 'h3'
    },
    actions: hasUrl && /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      color: "primary",
      size: "large",
      href: url,
      target: "_blank",
      rel: "noopener",
      className: classes.visitButton,
      endIcon: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faArrowUpRightFromSquare
      }),
      onClick: trackEvent
    }, "View Website")
  }), /*#__PURE__*/React.createElement(Box, {
    mt: hasUrl ? 1 : 3
  }, /*#__PURE__*/React.createElement(Paper, {
    elevation: 0
  }, hasLists && /*#__PURE__*/React.createElement(ColumnLists, {
    lists: lists
  }))));
};
AboutUs.propTypes = {
  college: PropTypes.object.isRequired,
  onReportHasContent: PropTypes.func.isRequired,
  isTnTSearchFilterEnabled: PropTypes.bool
};
var AboutUs$1 = withContext(AboutUs, Context$2);

let count = 0;
const transformCip6s = (cip6, cip6Key, cip4Key, cip2Key) => {
  count++;
  return {
    level: 6,
    name: cip6.CIPName,
    id: `${cip2Key}-${cip4Key}-${cip6Key}`
  };
};
const transformCip4s = (cip4, cip4Key, cip2Key) => {
  const sorted = sortBy(cip4.Cip6s, 'CIPName');
  return {
    level: 4,
    name: cip4.Cip4Name,
    id: `${cip2Key}-${cip4Key}`,
    children: map(sorted, (value, cip6Key) => {
      return transformCip6s(value, cip6Key, cip4Key, cip2Key);
    })
  };
};
const transformCip2s = (cip2, cip2Key) => {
  const sorted = sortBy(cip2.Cip4s, 'Cip4Name');
  return {
    level: 2,
    name: cip2.Cip2Name,
    id: `${cip2Key}`,
    children: map(sorted, (value, cip4Key) => {
      return transformCip4s(value, cip4Key, cip2Key);
    })
  };
};
const getData$8 = college => {
  const cip2s = get(college, 'FieldsOfStudy.Cip2s');
  count = 0;
  const sorted = sortBy(cip2s, 'Cip2Name');
  return {
    data: map(sorted, (value, key) => {
      return transformCip2s(value, key);
    }),
    count
  };
};

const NOT_REPORTED = 'Not reported';

const isNumberPositive$1 = number => {
  return !isUndefined(number) && number != 0;
};
const getRange$1 = (min, max) => {
  const hasRange = isNumberPositive$1(min) && isNumberPositive$1(max);
  return {
    range: hasRange ? min + ' - ' + max : NOT_REPORTED,
    hasRange
  };
};
const getAverage$1 = college => {
  const average = get(college, 'CalculatedFields.SATAvg');
  const isPositive = isNumberPositive$1(average);
  return {
    average: isPositive ? average : NOT_REPORTED,
    hasAverage: isPositive
  };
};
const getComposite$1 = college => {
  const min = get(college, 'CalculatedFields.SATMin');
  const max = get(college, 'CalculatedFields.SATMax');
  const {
    range,
    hasRange
  } = getRange$1(min, max);
  return {
    composite: range,
    hasComposite: hasRange
  };
};
const getReading = college => {
  const min = get(college, 'TestScores.SATReasoningRangeCriticalreading1');
  const max = get(college, 'TestScores.SATReasoningRangeCriticalreading2');
  const {
    range,
    hasRange
  } = getRange$1(min, max);
  return {
    reading: range,
    hasReading: hasRange
  };
};
const getMath$1 = college => {
  const min = get(college, 'TestScores.SATReasoningRangeMath1');
  const max = get(college, 'TestScores.SATReasoningRangeMath2');
  const {
    range,
    hasRange
  } = getRange$1(min, max);
  return {
    math: range,
    hasMath: hasRange
  };
};
const getValue$1 = (isValid, value) => {
  return /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: isValid ? 'textPrimary' : 'textSecondary'
  }, value);
};
const getData$7 = college => {
  const {
    average,
    hasAverage
  } = getAverage$1(college);
  const {
    composite,
    hasComposite
  } = getComposite$1(college);
  const {
    reading,
    hasReading
  } = getReading(college);
  const {
    math,
    hasMath
  } = getMath$1(college);
  const hasData = hasAverage || hasComposite || hasReading || hasMath;
  const hasAtleastOneNotReported = includes([average, composite, reading, math], NOT_REPORTED);
  return {
    hasData,
    hasAtleastOneNotReported,
    data: !hasData ? [] : [{
      title: 'Average SAT',
      value: getValue$1(hasAverage, average)
    }, {
      title: 'Composite',
      value: getValue$1(hasComposite, composite)
    }, {
      title: 'Reading',
      value: getValue$1(hasReading, reading)
    }, {
      title: 'Math',
      value: getValue$1(hasMath, math)
    }],
    average,
    hasAverage
  };
};

const isNumberPositive = number => {
  return !isUndefined(number) && number != 0;
};
const getAverage = college => {
  const average = get(college, 'CalculatedFields.ACTAvg');
  const isPositive = isNumberPositive(average);
  return {
    average: isPositive ? average : NOT_REPORTED,
    hasAverage: isPositive
  };
};
const getRange = (min, max) => {
  const hasRange = isNumberPositive(min) && isNumberPositive(max);
  return {
    range: hasRange ? min + ' - ' + max : NOT_REPORTED,
    hasRange
  };
};
const getComposite = college => {
  const min = get(college, 'CalculatedFields.ACTMin');
  const max = get(college, 'CalculatedFields.ACTMax');
  const {
    range,
    hasRange
  } = getRange(min, max);
  return {
    composite: range,
    hasComposite: hasRange
  };
};
const getEnglish = college => {
  const min = get(college, 'TestScores.ACTrangeEngl1');
  const max = get(college, 'TestScores.ACTrangeEngl2');
  const {
    range,
    hasRange
  } = getRange(min, max);
  return {
    english: range,
    hasEnglish: hasRange
  };
};
const getMath = college => {
  const min = get(college, 'TestScores.ACTrangeMath1');
  const max = get(college, 'TestScores.ACTrangeMath2');
  const {
    range,
    hasRange
  } = getRange(min, max);
  return {
    math: range,
    hasMath: hasRange
  };
};
const getData$6 = function () {
  let college = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    average,
    hasAverage
  } = getAverage(college);
  const {
    composite,
    hasComposite
  } = getComposite(college);
  const {
    english,
    hasEnglish
  } = getEnglish(college);
  const {
    math,
    hasMath
  } = getMath(college);
  const hasData = hasAverage || hasComposite || hasEnglish || hasMath;
  const hasAtleastOneNotReported = includes([average, composite, english, math], NOT_REPORTED);
  return {
    hasData,
    hasAtleastOneNotReported,
    data: !hasData ? [] : [{
      title: 'Average ACT',
      value: average,
      isValid: hasAverage
    }, {
      title: 'Composite',
      value: composite,
      isValid: hasComposite
    }, {
      title: 'English',
      value: english,
      isValid: hasEnglish
    }, {
      title: 'Math',
      value: math,
      isValid: hasMath
    }],
    average,
    hasAverage
  };
};

const toDollars = value => {
  return `$${value.toLocaleString()}`;
};
const toPercentage = value => {
  return `${Math.round(value)}%`;
};

const TITLES$1 = {
  tuition: 'Tuition',
  inDistrictTuition: 'In-District Tuition',
  outDistrictTuition: 'Out-of-District Tuition',
  inStateTuition: 'In-State Tuition',
  outStateTuition: 'Out-of-State Tuition',
  fees: 'Fees',
  inDistrictFees: 'In-District Fees',
  outDistrictFees: 'Out-of-District Fees',
  inStateFees: 'In-State Fees',
  outStateFees: 'Out-of-State Fees',
  roomAndBoard: 'Room and Board'
};
function formatDollars$2(value) {
  return !isUndefined(value) && value > 0 ? toDollars(value) : NOT_REPORTED;
}
const isTwoYear = college => {
  const degrees = get(college, 'Degrees');
  return isEqual(degrees, ['Associates']);
};
const isInternational$6 = college => {
  const country = get(college, 'Country');
  return !isEqual(country, 'United States');
};
const getTuition$1 = college => {
  return isInternational$6(college) ? getInternationalTuition(college) : isTwoYear(college) ? getTwoYearTuition(college) : getFourYearTuition(college);
};
const getInternationalTuition = college => {
  const outstateTuition = formatDollars$2(get(college, 'TuitionAndExpenses.TuitionOutstate'));
  return [{
    title: TITLES$1.tuition,
    value: outstateTuition
  }];
};
const getTwoYearTuition = college => {
  const inDistrictTuition = formatDollars$2(get(college, 'TuitionAndExpenses.TuitionIndistrict'));
  const outDistrictTuition = formatDollars$2(get(college, 'TuitionAndExpenses.TuitionInstate'));
  return [{
    title: TITLES$1.inDistrictTuition,
    value: inDistrictTuition
  }, {
    title: TITLES$1.outDistrictTuition,
    value: outDistrictTuition
  }];
};
const getFourYearTuition = college => {
  const inStateTuition = formatDollars$2(get(college, 'TuitionAndExpenses.TuitionInstate'));
  const outStateTuition = formatDollars$2(get(college, 'TuitionAndExpenses.TuitionOutstate'));
  return [{
    title: TITLES$1.inStateTuition,
    value: inStateTuition
  }, {
    title: TITLES$1.outStateTuition,
    value: outStateTuition
  }];
};
const getFees = college => {
  return isInternational$6(college) ? getInternationalFees(college) : isTwoYear(college) ? getTwoYearFees(college) : getFourYearFees(college);
};
const getInternationalFees = college => {
  const outstateFees = formatDollars$2(get(college, 'TuitionAndExpenses.FeesOutstate'));
  return [{
    title: TITLES$1.fees,
    value: outstateFees
  }];
};
const getTwoYearFees = college => {
  const inDistrictFees = formatDollars$2(get(college, 'TuitionAndExpenses.FeesIndistrict'));
  const outDistrictFees = formatDollars$2(get(college, 'TuitionAndExpenses.FeesInstate'));
  return isEqual(inDistrictFees, outDistrictFees) ? [{
    title: TITLES$1.fees,
    value: inDistrictFees
  }] : [{
    title: TITLES$1.inDistrictFees,
    value: inDistrictFees
  }, {
    title: TITLES$1.outDistrictFees,
    value: outDistrictFees
  }];
};
const getFourYearFees = college => {
  const inStateFees = formatDollars$2(get(college, 'TuitionAndExpenses.FeesInstate'));
  const outStateFees = formatDollars$2(get(college, 'TuitionAndExpenses.FeesOutstate'));
  return isEqual(inStateFees, outStateFees) ? [{
    title: TITLES$1.fees,
    value: inStateFees
  }] : [{
    title: TITLES$1.inStateFees,
    value: inStateFees
  }, {
    title: TITLES$1.outStateFees,
    value: outStateFees
  }];
};
const getRoomAndBoard = college => {
  const roomAndBoardRaw = get(college, 'TuitionAndExpenses.RoomBoard');
  const roomAndBoard = formatDollars$2(roomAndBoardRaw);
  return {
    title: TITLES$1.roomAndBoard,
    value: roomAndBoard
  };
};
const getExpenses = function () {
  let college = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const tuitions = getTuition$1(college);
  const fees = getFees(college);
  const roomAndBoard = getRoomAndBoard(college);
  return {
    hasData: true,
    data: [...tuitions, ...fees, roomAndBoard]
  };
};

const getValue = (isValid, value) => {
  return /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: isValid ? 'textPrimary' : 'textSecondary'
  }, value);
};
const getAcceptanceRate = college => {
  const rawRate = get(college, 'CalculatedFields.AcceptanceRate', 0);
  const hasAcceptanceRate = rawRate > 0;
  const acceptanceRate = toPercentage(rawRate);
  return {
    rawRate,
    acceptanceRate: hasAcceptanceRate ? acceptanceRate : NOT_REPORTED,
    hasAcceptanceRate
  };
};
const getNumberApplied = college => {
  const rawApplied = get(college, 'FreshEnroll.NumApplReceived', 0);
  const applied = rawApplied.toLocaleString();
  const hasNumberApplied = rawApplied > 0;
  return {
    applied: hasNumberApplied ? applied : NOT_REPORTED,
    hasNumberApplied
  };
};
const getAdmitted = college => {
  const rawAdmitted = get(college, 'FreshEnroll.NumApplOffered', 0);
  const admitted = rawAdmitted.toLocaleString();
  const hasAdmitted = rawAdmitted > 0;
  return {
    admitted: hasAdmitted ? admitted : NOT_REPORTED,
    hasAdmitted
  };
};
const getEnrolled = college => {
  const rawEnrolled = get(college, 'FreshEnroll.NumApplEnrolled', 0);
  const enrolled = rawEnrolled.toLocaleString();
  const hasEnrolled = rawEnrolled > 0;
  return {
    enrolled: hasEnrolled ? enrolled : NOT_REPORTED,
    hasEnrolled
  };
};
const getData$5 = function () {
  let college = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    acceptanceRate,
    hasAcceptanceRate
  } = getAcceptanceRate(college);
  const {
    applied,
    hasNumberApplied
  } = getNumberApplied(college);
  const {
    admitted,
    hasAdmitted
  } = getAdmitted(college);
  const {
    enrolled,
    hasEnrolled
  } = getEnrolled(college);
  const hasData = hasAcceptanceRate || hasNumberApplied || hasAdmitted || hasEnrolled;
  return {
    hasData,
    data: !hasData ? [] : [{
      title: 'Admission Rate',
      value: getValue(hasAcceptanceRate, acceptanceRate)
    }, {
      title: 'Total Applied',
      value: getValue(hasNumberApplied, applied)
    }, {
      title: 'Total Admitted',
      value: getValue(hasAdmitted, admitted)
    }, {
      title: 'Total Enrolled',
      value: getValue(hasEnrolled, enrolled)
    }],
    hasAcceptanceRate,
    acceptanceRate
  };
};

const getUndergradCount = college => {
  const rawCount = get(college, 'GeneralInfo.FtDegree3', 0);
  const count = rawCount.toLocaleString();
  const hasUndergradCount = rawCount > 0;
  return {
    rawCount,
    undergradCount: hasUndergradCount ? count : NOT_REPORTED,
    hasUndergradCount
  };
};
const getTotalCount = college => {
  const rawCount = get(college, 'GeneralInfo.TotalDegree3', 0);
  const count = rawCount.toLocaleString();
  const hasTotalCount = rawCount > 0;
  return {
    totalCount: hasTotalCount ? count : NOT_REPORTED,
    hasTotalCount
  };
};
const useStyles$q = makeStyles({
  row: {
    '&:last-child td': {
      borderBottom: 0
    },
    '&:last-child th': {
      borderBottom: 0
    }
  }
});
const Enrollment = _ref => {
  let {
    college,
    onReportHasContent
  } = _ref;
  const classes = useStyles$q();
  const {
    undergradCount,
    hasUndergradCount
  } = getUndergradCount(college);
  const {
    totalCount,
    hasTotalCount
  } = getTotalCount(college);
  const hasContent = hasUndergradCount || hasTotalCount;
  useCallbackOnMount(() => {
    onReportHasContent(hasContent);
  }, [hasContent]);
  if (!hasContent) {
    return null;
  }
  const rows = [{
    title: 'Undergraduate Students',
    value: undergradCount,
    isValid: hasUndergradCount
  }, {
    title: 'Total Students',
    value: totalCount,
    isValid: hasTotalCount
  }];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Paper, {
    elevation: 0
  }, /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, /*#__PURE__*/React.createElement("strong", null, "Enrollment"))), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, /*#__PURE__*/React.createElement("strong", null, "Number"))))), /*#__PURE__*/React.createElement(TableBody, null, rows.map(row => /*#__PURE__*/React.createElement(TableRow, {
    key: row.title,
    className: classes.row
  }, /*#__PURE__*/React.createElement(TableCell, {
    width: "50%",
    component: "th",
    scope: "row"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, row.title)), /*#__PURE__*/React.createElement(TableCell, {
    width: "50%"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: row.isValid ? 'textPrimary' : 'textSecondary'
  }, row.value))))))));
};
Enrollment.propTypes = {
  college: PropTypes.object.isRequired,
  onReportHasContent: PropTypes.func.isRequired
};
var Enrollment$1 = withContext(Enrollment, Context$2);

const getFieldsOfStudy = college => {
  const {
    count
  } = getData$8(college);
  const hasFieldsOfStudy = count > 0;
  return {
    fieldsOfStudy: hasFieldsOfStudy ? count : undefined,
    hasFieldsOfStudy
  };
};
const getAdmissionsRate = college => {
  const {
    acceptanceRate,
    rawRate,
    hasAcceptanceRate
  } = getAcceptanceRate(college);
  const admissionRate = rawRate > 0 ? acceptanceRate : undefined;
  return {
    admissionRate,
    hasAdmissionsRate: hasAcceptanceRate
  };
};
const getAverageSAT = college => {
  const {
    average: averageSAT,
    hasAverage: hasAverageSAT
  } = getAverage$1(college);
  return {
    averageSAT: averageSAT === NOT_REPORTED ? undefined : averageSAT,
    hasAverageSAT
  };
};
const getAverageACT = college => {
  const {
    average: averageACT,
    hasAverage: hasAverageACT
  } = getAverage(college);
  return {
    averageACT: averageACT === NOT_REPORTED ? undefined : averageACT,
    hasAverageACT
  };
};
const getHasTuition = value => isString(value) && value !== NOT_REPORTED;
const getTuition = college => {
  const intl = isInternational$6(college);
  const yr2 = !intl && isTwoYear(college);
  const fn = intl ? getInternationalTuition : yr2 ? getTwoYearTuition : getFourYearTuition;
  const [a, b] = fn(college);
  const inTuition = get(a, 'value');
  const outTuition = get(b, 'value');
  const inTuitionTitle = get(a, 'title');
  const outTuitionTitle = get(b, 'title');
  const hasInTuition = getHasTuition(inTuition);
  const hasOutTuition = getHasTuition(outTuition);
  return {
    tuition: {
      inTuition: hasInTuition ? inTuition : undefined,
      inTuitionTitle: hasInTuition ? inTuitionTitle : undefined,
      outTuition: hasOutTuition ? outTuition : undefined,
      outTuitionTitle: hasOutTuition ? outTuitionTitle : undefined,
      hasInTuition,
      hasOutTuition
    },
    hasTuition: hasInTuition || hasOutTuition,
    intl
  };
};
const getStudentsReceivingFinancialAid = (college, intl) => {
  if (intl) {
    return {
      studentsReceivingFinancialAid: undefined,
      hasStudentsReceivingFinancialAid: false
    };
  }
  const raw = get(college, 'FinancialAid.PcFinAidReceived', 0);
  const studentsReceivingFinancialAid = toPercentage(raw);
  const hasStudentsReceivingFinancialAid = raw > 0;
  return {
    studentsReceivingFinancialAid: hasStudentsReceivingFinancialAid ? studentsReceivingFinancialAid : undefined,
    hasStudentsReceivingFinancialAid
  };
};
const getUndergraduateStudents = college => {
  const {
    undergradCount: undergraduateStudents,
    hasUndergradCount: hasUndergraduateStudents
  } = getUndergradCount(college);
  return {
    undergraduateStudents: hasUndergraduateStudents ? undergraduateStudents : undefined,
    hasUndergraduateStudents
  };
};
const getData$4 = college => {
  const {
    fieldsOfStudy,
    hasFieldsOfStudy
  } = getFieldsOfStudy(college);
  const {
    admissionRate,
    hasAdmissionsRate
  } = getAdmissionsRate(college);
  const {
    averageSAT,
    hasAverageSAT
  } = getAverageSAT(college);
  const {
    averageACT,
    hasAverageACT
  } = getAverageACT(college);
  const {
    intl,
    tuition,
    hasTuition
  } = getTuition(college);
  const {
    studentsReceivingFinancialAid,
    hasStudentsReceivingFinancialAid
  } = getStudentsReceivingFinancialAid(college, intl);
  const {
    undergraduateStudents,
    hasUndergraduateStudents
  } = getUndergraduateStudents(college);
  const hasContent = hasFieldsOfStudy || hasAdmissionsRate || hasAverageSAT || hasAverageACT || hasTuition || hasStudentsReceivingFinancialAid || hasUndergraduateStudents;
  return {
    fieldsOfStudy,
    admissionRate,
    averageSAT,
    averageACT,
    ...tuition,
    studentsReceivingFinancialAid,
    undergraduateStudents,
    hasContent
  };
};

// eslint-disable-next-line react/prop-types
const WrappedDataPoint = _ref => {
  let {
    datum,
    ...rest
  } = _ref;
  return isUndefined(datum) ? null : /*#__PURE__*/React.createElement(Grid, {
    item: true,
    lg: 3,
    md: 4,
    xs: 6
  }, /*#__PURE__*/React.createElement(DataPoint, _extends({
    datum: datum
  }, rest)));
};
const ByTheNumbers = _ref2 => {
  let {
    college,
    onReportHasContent
  } = _ref2;
  const {
    fieldsOfStudy,
    admissionRate,
    averageSAT,
    averageACT,
    inTuition,
    inTuitionTitle,
    outTuition,
    outTuitionTitle,
    studentsReceivingFinancialAid,
    undergraduateStudents,
    hasContent
  } = getData$4(college);
  useCallbackOnMount(() => {
    onReportHasContent(hasContent);
  }, [hasContent]);
  return !hasContent ? null : /*#__PURE__*/React.createElement(Box, {
    mt: 3
  }, /*#__PURE__*/React.createElement(SectionTitle, {
    titleProps: {
      component: 'h3'
    },
    title: "By The Numbers"
  }), /*#__PURE__*/React.createElement(Box, {
    mt: 3
  }, /*#__PURE__*/React.createElement(Paper, {
    elevation: 0
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(WrappedDataPoint, {
    title: "Fields of Study",
    datum: fieldsOfStudy
  }), /*#__PURE__*/React.createElement(WrappedDataPoint, {
    title: "Admission Rate",
    datum: admissionRate
  }), /*#__PURE__*/React.createElement(WrappedDataPoint, {
    title: "Average SAT",
    datum: averageSAT,
    tooltipContents: "This value represents the average of 25th and 75th percentile SAT scores."
  }), /*#__PURE__*/React.createElement(WrappedDataPoint, {
    title: "Average ACT",
    datum: averageACT
  }), /*#__PURE__*/React.createElement(WrappedDataPoint, {
    title: inTuitionTitle,
    datum: inTuition
  }), /*#__PURE__*/React.createElement(WrappedDataPoint, {
    title: outTuitionTitle,
    datum: outTuition
  }), /*#__PURE__*/React.createElement(WrappedDataPoint, {
    title: "Students Receiving Financial Aid",
    datum: studentsReceivingFinancialAid,
    tooltipContents: "Percentage of students receiving any form of aid, including grants, scholarships, and federal student loans."
  }), /*#__PURE__*/React.createElement(WrappedDataPoint, {
    title: "Undergraduate Students",
    datum: undergraduateStudents
  })))));
};
ByTheNumbers.propTypes = {
  college: PropTypes.object.isRequired,
  onReportHasContent: PropTypes.func.isRequired
};
var ByTheNumbers$1 = withContext(ByTheNumbers, Context$2);

const useStyles$p = makeStyles({
  typographicCard: {
    color: '#ffffff',
    background: _ref => {
      let {
        color
      } = _ref;
      return color;
    }
  }
});
const COLORS = ['#7491FF', '#21338C', '#0B79D0'];
const getColorByIndex = index => {
  const colorIndex = index % 3;
  return COLORS[colorIndex];
};
const TypographicCard = _ref2 => {
  let {
    body,
    attribution,
    index = 0,
    minHeight
  } = _ref2;
  const color = getColorByIndex(index);
  const classes = useStyles$p({
    color
  });
  const theme = useTheme$1();
  const isMd = useMediaQuery(theme.breakpoints.up('md'));
  const isSm = useMediaQuery(theme.breakpoints.up('sm'));
  return /*#__PURE__*/React.createElement(Paper, {
    className: classes.typographicCard
  }, /*#__PURE__*/React.createElement(Box, {
    p: isSm ? 4 : 2,
    minHeight: minHeight
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: isMd ? 'h4' : 'h5'
  }, body), /*#__PURE__*/React.createElement(Box, {
    pt: 2,
    fontSize: 12
  }, "- ", attribution.toUpperCase())));
};
TypographicCard.propTypes = {
  body: PropTypes.string.isRequired,
  attribution: PropTypes.string.isRequired,
  index: PropTypes.number,
  minHeight: PropTypes.string
};

const {
  Carousel: Carousel$2,
  CarouselBody: CarouselBody$2,
  CarouselControls: CarouselControls$2
} = GridAlignedCarousel;
const TypographicCardCarousel = _ref => {
  let {
    bullets,
    attribution
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    mb: 2
  }, /*#__PURE__*/React.createElement(Carousel$2, null, /*#__PURE__*/React.createElement(SectionTitle, {
    title: "Our Highlights",
    titleProps: {
      component: 'h3'
    },
    actions: /*#__PURE__*/React.createElement(CarouselControls$2, null)
  }), /*#__PURE__*/React.createElement(Paper, {
    elevation: 0
  }, /*#__PURE__*/React.createElement(Box, {
    p: 2,
    overflow: "hidden"
  }, /*#__PURE__*/React.createElement(CarouselBody$2, {
    xs: 9,
    sm: 9,
    md: 9,
    spacing: 2,
    showPartials: {
      md: true,
      sm: true,
      xs: true
    }
  }, map(bullets, (bullet, idx) => {
    return /*#__PURE__*/React.createElement(TypographicCard, {
      key: idx,
      body: bullet,
      attribution: attribution,
      index: idx,
      minHeight: "230px"
    });
  }))))));
};
TypographicCardCarousel.propTypes = {
  bullets: PropTypes.array.isRequired,
  attribution: PropTypes.string.isRequired
};

const OurHighlights = _ref => {
  let {
    college,
    bullets,
    onReportHasContent
  } = _ref;
  const collegeName = get(college, 'Name');
  const hasBullets = !isEmpty(bullets);
  const hasContent = hasBullets;
  useCallbackOnMount(() => {
    onReportHasContent(hasContent);
  }, [hasContent]);
  return !hasContent ? null : /*#__PURE__*/React.createElement(TypographicCardCarousel, {
    bullets: bullets,
    attribution: collegeName
  });
};
OurHighlights.propTypes = {
  college: PropTypes.object.isRequired,
  bullets: PropTypes.array.isRequired,
  onReportHasContent: PropTypes.func.isRequired
};
var OurHighlights$1 = withContext(OurHighlights, Context$2);

const useStyles$o = makeStyles({
  map: {
    width: '100%',
    height: `300px`,
    display: 'block',
    overflow: 'hidden',
    position: 'relative',
    borderRadius: '5px',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    '&::before': {
      content: '"Open this map in a new tab"',
      opacity: 0,
      color: '#ffffff',
      width: '100%',
      height: '100%',
      display: 'flex',
      fontSize: '18px',
      paddingTop: '30px',
      position: 'absolute',
      alignItems: 'center',
      justifyContent: 'center',
      textShadow: '0 0 10px black',
      transition: 'opacity 0.25s ease-out',
      backgroundColor: 'rgba(0, 0, 0, 0.5)'
    },
    '&:focus': {
      '&::before': {
        opacity: 1
      }
    },
    '&:hover': {
      '&::before': {
        opacity: 1
      }
    }
  }
});
const GoogleStaticMap = _ref => {
  let {
    mapUrl,
    name,
    latitude,
    longitude,
    isLarge
  } = _ref;
  const classes = useStyles$o();
  const center = [longitude, latitude].join(',');
  const zoom = 12;
  const backgroundImage = `url('${mapUrl}')`;
  const href = `https://www.google.com/maps/search/${name.replace(' ', '+')}/@${center},${zoom}z`;
  const label = `Google map for ${name}`;
  return /*#__PURE__*/React.createElement("a", {
    className: classes.map,
    href: href,
    "aria-label": label,
    title: label,
    target: "_blank",
    rel: "noreferrer",
    style: {
      height: isLarge ? '600px' : '300px',
      backgroundImage
    }
  });
};
GoogleStaticMap.propTypes = {
  mapUrl: PropTypes.string.isRequired,
  latitude: PropTypes.number.isRequired,
  longitude: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  isLarge: PropTypes.bool
};

const LOCATED_IN_CITY = 'Located in a city';
const LOCATED_IN_SUBURB = 'Located in a suburb';
const LOCATED_IN_TOWN = 'Located in a town';
const LOCATED_IN_RURAL_AREA = 'Located in a rural area';
const SETTING_NOT_REPORTED = 'Campus setting not reported';
const getPublicTransit = college => {
  const rawPublicTransitValue = get(college, 'Environment.PublicTrans');
  const publicTransitValue = rawPublicTransitValue === 'yes' || rawPublicTransitValue === true;
  return {
    publicTransitValue,
    hasPublicTransit: !isUndefined(rawPublicTransitValue) && !(isString(rawPublicTransitValue) && isEmpty(rawPublicTransitValue))
  };
};
const getCampusTypeDisplay = college => {
  const campusType = get(college, 'Setting');
  const hasCampusType = !isUndefined(campusType);
  let campusTypeDisplayText = '';
  let campusTypeIcon;
  if (hasCampusType) {
    if (campusType.includes('City')) {
      campusTypeDisplayText = LOCATED_IN_CITY;
      campusTypeIcon = faCity;
    } else if (campusType.includes('Suburb')) {
      campusTypeDisplayText = LOCATED_IN_SUBURB;
      campusTypeIcon = faCarBuilding;
    } else if (campusType.includes('Town')) {
      campusTypeDisplayText = LOCATED_IN_TOWN;
      campusTypeIcon = faHouse;
    } else if (campusType.includes('Rural')) {
      campusTypeDisplayText = LOCATED_IN_RURAL_AREA;
      campusTypeIcon = faTree;
    } else {
      campusTypeDisplayText = SETTING_NOT_REPORTED;
      campusTypeIcon = faMapMarkerAlt;
    }
  }
  return {
    campusTypeDisplayText,
    campusTypeIcon,
    hasCampusType
  };
};
const getAirport = college => {
  const airportCity = get(college, 'Environment.NearAirportCity', false);
  const airportMiles = get(college, 'Environment.NearAirportMiles', false);
  const missingAirport = !airportCity || !airportMiles;
  return {
    airportCity,
    airportMiles,
    hasAirport: !missingAirport
  };
};
const getTrain = college => {
  const trainCity = get(college, 'Environment.TrainCity', false);
  const trainMiles = get(college, 'Environment.TrainMiles', false);
  const missingTrain = !trainCity || !trainMiles;
  return {
    trainCity,
    trainMiles,
    hasTrain: !missingTrain
  };
};
const getAddress = college => {
  const address = college.Address;
  const city = college.City;
  const state = college.State;
  const country = college.Country;
  const hasAddress = !!address;
  return {
    address,
    city,
    state,
    country,
    hasAddress
  };
};
const getLists$1 = function () {
  let college = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    campusTypeDisplayText,
    campusTypeIcon,
    hasCampusType
  } = getCampusTypeDisplay(college);
  const {
    publicTransitValue,
    hasPublicTransit
  } = getPublicTransit(college);
  const {
    airportCity,
    airportMiles,
    hasAirport
  } = getAirport(college);
  const {
    trainCity,
    trainMiles,
    hasTrain
  } = getTrain(college);
  const {
    address,
    city,
    state,
    country,
    hasAddress
  } = getAddress(college);
  return reject([reject([hasCampusType && {
    icon: campusTypeIcon,
    primaryText: campusTypeDisplayText
  }, hasAddress && {
    icon: faMapMarkerAlt,
    primaryText: 'Address',
    secondaryText: /*#__PURE__*/React.createElement(React.Fragment, null, address, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(GeographicLocation, {
      component: "span",
      city: city,
      state: state,
      country: country
    }))
  }, hasAirport && {
    icon: faPlane,
    primaryText: 'Nearest Airport',
    secondaryText: `${airportCity} (${airportMiles} miles)`
  }], item => !item), reject([hasTrain && {
    icon: faTrain,
    primaryText: 'Nearest Train Station',
    secondaryText: `${trainCity} (${trainMiles} miles)`
  }, hasPublicTransit && {
    icon: faBus,
    primaryText: 'Public Transportation',
    secondaryText: publicTransitValue ? 'Serves campus and surrounding area' : 'Not available in surrounding area'
  }], item => !item)], item => isEmpty(item));
};

const Location = _ref => {
  let {
    college,
    onReportHasContent,
    hasLargeMap,
    hideMap = false
  } = _ref;
  const lists = getLists$1(college);
  const name = get(college, 'Name');
  const mapUrl = get(college, 'MapUrl');
  const latitude = get(college, 'Location.coordinates[0]', 0);
  const longitude = get(college, 'Location.coordinates[1]', 0);
  const missingLists = isEmpty(lists);
  const missingCoords = latitude === 0 && longitude === 0;
  const hasContent = !missingLists || !missingCoords;
  useCallbackOnMount(() => {
    onReportHasContent(hasContent);
  }, [hasContent]);
  return !hasContent ? null : /*#__PURE__*/React.createElement(Box, {
    my: 5
  }, /*#__PURE__*/React.createElement(SectionTitle, {
    title: "Location and Nearby Transportation",
    titleProps: {
      component: 'h3'
    }
  }), !missingLists && /*#__PURE__*/React.createElement(Box, {
    mt: 3
  }, /*#__PURE__*/React.createElement(Paper, {
    elevation: 0
  }, /*#__PURE__*/React.createElement(ColumnLists, {
    lists: lists
  }))), !missingCoords && !hideMap && mapUrl && /*#__PURE__*/React.createElement(Box, {
    mt: 3
  }, /*#__PURE__*/React.createElement(GoogleStaticMap, {
    mapUrl: mapUrl,
    name: name,
    latitude: latitude,
    longitude: longitude,
    isLarge: hasLargeMap
  })));
};
Location.propTypes = {
  college: PropTypes.object.isRequired,
  onReportHasContent: PropTypes.func.isRequired,
  hasLargeMap: PropTypes.bool,
  hideMap: PropTypes.bool
};
var Location$1 = withContext(Location, Context$2);

const UpcomingVisits = _ref => {
  let {
    college,
    getCollege,
    getDisplayVisits,
    onReportHasContent
  } = _ref;
  const visits = get(college, 'Events.Events', []);
  const hasContent = !isEmpty(visits) && isFunction(getDisplayVisits);
  useCallbackOnMount(() => {
    onReportHasContent(hasContent);
  }, [hasContent]);
  return !hasContent ? null : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    mt: 3
  }, /*#__PURE__*/React.createElement(Paper, {
    elevation: 0
  }, /*#__PURE__*/React.createElement(ListSubheader, null, "Upcoming Visits"), /*#__PURE__*/React.createElement(Box, {
    pb: 2
  }, getDisplayVisits(visits, getCollege)))));
};
UpcomingVisits.propTypes = {
  college: PropTypes.object.isRequired,
  getDisplayVisits: PropTypes.func,
  getCollege: PropTypes.func,
  onReportHasContent: PropTypes.func.isRequired
};
var UpcomingVisits$1 = withContext(UpcomingVisits, Context$2);

const CollegeHeadingComp = _ref => {
  let {
    scid,
    city,
    state,
    country,
    name,
    avatarSize,
    children,
    linkToEvents
  } = _ref;
  const getEventsPath = useGetEventsPath();
  const getCollegesPath = useGetCollegesPath();
  const eventsPath = getEventsPath(scid);
  const collegesPath = getCollegesPath(scid);
  return /*#__PURE__*/React.createElement(TrackedImpression, null, /*#__PURE__*/React.createElement(CollegeHeading, {
    name: name,
    scid: scid,
    CollegeCrestProps: {
      size: avatarSize,
      alt: `${name} logo`
    },
    to: linkToEvents === true && isFunction(getEventsPath) ? eventsPath : collegesPath
  }, children || /*#__PURE__*/React.createElement(GeographicLocation, {
    city: city,
    state: state,
    country: country
  })));
};
const CollegeHeadingWithoutLink = _ref2 => {
  let {
    scid,
    city,
    state,
    country,
    name,
    avatarSize
  } = _ref2;
  return /*#__PURE__*/React.createElement(TrackedImpression, null, /*#__PURE__*/React.createElement(CollegeAvatarWithTitle, {
    scid: scid,
    avatarProps: {
      size: avatarSize,
      alt: `${name} logo`
    },
    title: name
  }, /*#__PURE__*/React.createElement(Typography, {
    component: "small",
    color: "textSecondary"
  }, /*#__PURE__*/React.createElement(GeographicLocation, {
    component: "span",
    city: city,
    state: state,
    country: country
  }))));
};
const propTypes = {
  scid: PropTypes.number,
  city: PropTypes.string,
  state: PropTypes.string,
  country: PropTypes.string,
  name: PropTypes.any,
  avatarSize: PropTypes.string,
  children: PropTypes.any,
  linkToEvents: PropTypes.bool
};
CollegeHeadingComp.propTypes = propTypes;
CollegeHeadingWithoutLink.propTypes = propTypes;

const CollegeListItem = _ref => {
  let {
    linkToCollege = false,
    scid,
    name,
    getCollegeListAction,
    ...rest
  } = _ref;
  const HeadingComponent = linkToCollege ? CollegeHeadingComp : CollegeHeadingWithoutLink;
  return /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    "aria-label": name
  }, /*#__PURE__*/React.createElement(HeadingComponent, _extends({
    scid: scid,
    name: name
  }, rest)), getCollegeListAction && getCollegeListAction({
    scid,
    name
  }));
};
CollegeListItem.propTypes = {
  scid: PropTypes.number,
  name: PropTypes.string,
  getCollegeListAction: PropTypes.func,
  ...CollegeHeadingWithoutLink.propTypes
};
var CollegeListItem$1 = withContext(CollegeListItem, Context$2);

const WrappedList = _ref => {
  let {
    colleges,
    ...rest
  } = _ref;
  const eventTracking = useEventTracking();
  return map(colleges, (_ref2, idx) => {
    let {
      SchoolName,
      Name,
      Scid,
      City,
      State
    } = _ref2;
    return /*#__PURE__*/React.createElement(Metadata, {
      value: {
        ...get(eventTracking, 'getScid', noop)(Scid),
        ...get(eventTracking, 'getItemNumber', noop)(idx),
        ...get(eventTracking, 'getLocationIndex', noop)(idx)
      },
      key: Scid
    }, /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement(CollegeListItem$1, _extends({
      name: SchoolName || Name,
      scid: Scid,
      city: City,
      state: State
    }, rest))));
  });
};
WrappedList.propTypes = {
  colleges: PropTypes.array
};

const CollegeList = _ref => {
  let {
    colleges,
    showMoreAfter,
    ...rest
  } = _ref;
  const [open, setOpen] = useState(false);
  const shouldUseToggleBox = isNumber(showMoreAfter) && colleges.length > showMoreAfter;
  return /*#__PURE__*/React.createElement(List, null, shouldUseToggleBox ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(WrappedList, _extends({
    colleges: colleges.slice(0, showMoreAfter)
  }, rest)), /*#__PURE__*/React.createElement(ToggleBox, {
    collapsed: !open
  }, /*#__PURE__*/React.createElement(WrappedList, _extends({
    colleges: colleges.slice(showMoreAfter, colleges.length)
  }, rest))), /*#__PURE__*/React.createElement(Box, {
    mt: 2,
    ml: 2
  }, /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    size: "large",
    endIcon: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: open ? faChevronUp : faChevronDown,
      size: "xs"
    }),
    onClick: () => setOpen(!open)
  }, "Show ", open ? 'Less' : 'More'))) : /*#__PURE__*/React.createElement(WrappedList, _extends({
    colleges: colleges
  }, rest)));
};
CollegeList.propTypes = {
  colleges: PropTypes.array,
  linkToCollege: PropTypes.bool,
  avatarSize: PropTypes.string,
  showMoreAfter: PropTypes.number
};

const useSimilarColleges = (getSimilarColleges, scid) => {
  const [{
    loading,
    loaded,
    data
  }, dispatch] = useReducer(reducer, getInitialState$1());
  useApiOnMount(() => {
    return getSimilarColleges(scid).then(resp => Promise.resolve(get(resp, 'Institutions', []))).catch(noop);
  }, dispatch, [scid]);
  return {
    loading,
    loaded,
    colleges: data
  };
};

const SimilarColleges = _ref => {
  let {
    scid,
    eventTracking,
    getSimilarColleges,
    onReportHasContent
  } = _ref;
  const {
    loading,
    loaded,
    colleges
  } = useSimilarColleges(getSimilarColleges, scid);
  useCallbackOnMount(() => {
    if (loaded || isUndefined(getSimilarColleges)) {
      onReportHasContent(!isEmpty(colleges));
    }
  }, [loaded, colleges]);
  return isEmpty(colleges) ? null : loading ? /*#__PURE__*/React.createElement(Box, {
    p: 2,
    justifyContent: "center",
    display: "flex"
  }, /*#__PURE__*/React.createElement(LoadingIndicator, {
    enabled: true
  })) : /*#__PURE__*/React.createElement(Metadata, {
    value: get(eventTracking, 'similarColleges')
  }, /*#__PURE__*/React.createElement(Box, {
    mt: 3
  }, /*#__PURE__*/React.createElement(Paper, {
    elevation: 0
  }, /*#__PURE__*/React.createElement(ListSubheader, null, "Students Also Follow"), /*#__PURE__*/React.createElement(CollegeList, {
    colleges: colleges,
    showMoreAfter: 5,
    avatarSize: "sm",
    linkToCollege: true
  }))));
};
SimilarColleges.propTypes = {
  scid: PropTypes.number,
  eventTracking: PropTypes.object,
  getSimilarColleges: PropTypes.func,
  onReportHasContent: PropTypes.func.isRequired
};
var SimilarColleges$1 = withContext(SimilarColleges, Context$2);

const getEncodedFilters = arr => arr.map(item => {
  return encodeURIComponent(item);
}).join(',');
const stringifyParams = filters => {
  let paramsA;
  let paramsB;
  let params = '';
  const {
    academicFocuses,
    tags
  } = filters;
  const hasAcademicFocuses = !isEmpty(academicFocuses);
  const hasTags = !isEmpty(tags);
  if (hasAcademicFocuses) {
    paramsA = `academicFocuses=${getEncodedFilters(academicFocuses)}`;
  }
  if (hasTags) {
    paramsB = `tags=${getEncodedFilters(tags)}`;
  }
  params = reject([paramsA, paramsB], isEmpty).join('&');
  return params ? `?${params}` : undefined;
};
const useCollegeContent = (getCollegeContent, scid, type) => {
  const [filters, setFilters] = useState({});
  const [{
    loading,
    loaded,
    data
  }, dispatch] = useReducer(reducer, getInitialState$1());
  useApiOnMount(() => {
    const params = stringifyParams(filters);
    if (getCollegeContent) {
      return getCollegeContent(scid, type, params).then(resp => Promise.resolve(resp)).catch(noop);
    }
  }, dispatch, [scid, filters]);
  return {
    loading,
    loaded,
    content: data,
    filters,
    onChangeFilters: setFilters
  };
};

const Context = /*#__PURE__*/React.createContext({});
const CardContextWrapper = _ref => {
  let {
    children
  } = _ref;
  const [openItemIdx, setOpenItemIdx] = useState();
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: {
      openItemIdx,
      setOpenItemIdx
    }
  }, children);
};
CardContextWrapper.propTypes = {
  items: PropTypes.array,
  children: PropTypes.node
};

const ContentCard = _ref => {
  let {
    type,
    item,
    contentImpressionComponent: ContentImpression,
    idx,
    setOpenItemIdx,
    onViewContent,
    getForYouPill = noop,
    hostedRootPath,
    getTagPillProps = () => {}
  } = _ref;
  const [getMetadata] = useMetadata();
  const onToggleSelect = useCallback(() => {
    const metadata = getMetadata();
    setOpenItemIdx(idx);
    if (onViewContent) {
      onViewContent({
        item,
        metadata,
        ContentItemId: item.Id,
        ContentLaunchedVia: 'modal',
        ContentItemDisplayPosition: idx,
        locationIndex: idx,
        CorrelationId: get(metadata, 'correlationId')
      });
    }
  }, [idx, item, getMetadata, setOpenItemIdx, onViewContent]);
  return /*#__PURE__*/React.createElement(ContentImpression, {
    contentId: item.Id
  }, /*#__PURE__*/React.createElement(ContentItemCard, {
    scid: item.Scid,
    type: type,
    id: item.Id,
    title: item.Title,
    contentImgAlt: item.AltText || item.Title,
    description: item.Description,
    url: item.Link,
    imageUrl: item.ImageUrl ? getContentImageUrl(item) : undefined,
    tags: item.Tags,
    foci: item.AcademicFocus,
    forYouPill: getForYouPill(item.Tags, item.AcademicFocus),
    hostedRootPath: hostedRootPath,
    onShowMoreTags: onToggleSelect,
    getTagPillProps: getTagPillProps,
    onToggleSelect: onToggleSelect,
    collegeEvent: /*#__PURE__*/React.createElement(Event, {
      item: item,
      stackSegments: true
    })
  }));
};
ContentCard.propTypes = {
  item: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  contentImpressionComponent: PropTypes.func,
  idx: PropTypes.number,
  setOpenItemIdx: PropTypes.func.isRequired,
  onClickContentLink: PropTypes.func,
  onViewContent: PropTypes.func,
  getForYouPill: PropTypes.func,
  onSessionsContentClick: PropTypes.func,
  hostedRootPath: PropTypes.string,
  onShowMoreTags: PropTypes.func,
  getTagPillProps: PropTypes.func
};
var ContentCard$1 = withContext(ContentCard, Context);

const CardModal = _ref => {
  let {
    items,
    openItemIdx,
    setOpenItemIdx,
    hostedRootPath,
    onViewContent,
    onClickContentLink,
    getTagPillProps = () => {},
    type
  } = _ref;
  const [getMetadata] = useMetadata();
  const lastTrackedOpenIdx = useRef();
  const selectedItem = get(items, `[${openItemIdx}]`);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(ContentItemModal, {
    getTagPillProps: getTagPillProps,
    itemsCount: size(items),
    item: get(items, `[${openItemIdx}]`),
    hideMedia: false,
    hostedRootPath: hostedRootPath,
    openItemIdx: openItemIdx,
    onChange: openItemIdx => {
      const metadata = getMetadata();
      setOpenItemIdx(openItemIdx);
      if (onViewContent && lastTrackedOpenIdx.current !== openItemIdx) {
        lastTrackedOpenIdx.current = openItemIdx;
        onViewContent({
          item: selectedItem,
          metadata,
          ContentLaunchedVia: 'modal',
          ContentItemDisplayPosition: openItemIdx,
          CorrelationId: get(metadata, 'correlationId')
        });
      }
    },
    onTrackLinkClick: args => {
      const metadata = getMetadata();
      if (onClickContentLink) {
        onClickContentLink({
          args,
          itemIndex: openItemIdx,
          item: selectedItem,
          metadata
        });
      }
    },
    type: type
  }));
};
CardModal.propTypes = {
  items: PropTypes.array.isRequired,
  openItemIdx: PropTypes.number,
  setOpenItemIdx: PropTypes.func.isRequired,
  hostedRootPath: PropTypes.string.isRequired,
  onViewContent: PropTypes.func,
  onClickContentLink: PropTypes.func,
  getTagPillProps: PropTypes.func,
  type: PropTypes.oneOf(Object.values(CONTENT_TYPES))
};
var CardModal$1 = withContext(CardModal, Context);

const useStyles$n = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(1),
    width: '200px'
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  chip: {
    margin: 2
  },
  noLabel: {
    marginTop: theme.spacing(3)
  }
}));
const renderValue = selected => {
  return isEmpty(selected) ? /*#__PURE__*/React.createElement("em", null, "Placeholder") : selected.join(', ');
};
const getAcademicFocuses = (arr, item) => {
  return includes(arr, item) ? without(arr, item) : [...arr, item];
};
const ID = 'cms-academic-focus-filter-multiselect';
const FilterBar = _ref => {
  let {
    total,
    appliedFilters = [],
    onChangeFilters,
    availableFilters = {}
  } = _ref;
  const classes = useStyles$n();
  const options = useMemo(() => sortBy(get(availableFilters, 'AcademicFocus', []), 'Name'));
  const handleChangeAcademicFocuses = useCallback((event, menuItem) => {
    const name = get(menuItem, 'props.value.Name');
    const academicFocuses = getAcademicFocuses(appliedFilters, name);
    const filters = isEmpty(academicFocuses) ? {} : {
      academicFocuses
    };
    onChangeFilters(filters);
  }, [appliedFilters]);
  const appliedFiltersSorted = sortBy(appliedFilters);
  const checked = keyBy(appliedFiltersSorted, identity);
  return /*#__PURE__*/React.createElement(Box, {
    mb: 3
  }, /*#__PURE__*/React.createElement(Paper, {
    elevation: 0
  }, /*#__PURE__*/React.createElement(Box, {
    p: 2,
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined",
    className: classes.formControl
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: ID
  }, "Academic Focus"), /*#__PURE__*/React.createElement(Select, {
    multiple: true,
    title: appliedFiltersSorted.join(', '),
    label: "Academic Focus",
    value: appliedFiltersSorted,
    onChange: handleChangeAcademicFocuses,
    inputProps: {
      name: 'academic-focus',
      id: ID
    },
    renderValue: renderValue,
    MenuProps: {
      PaperProps: {
        style: {
          maxHeight: '75vh',
          width: 250
        }
      }
    }
  }, options.map(option => /*#__PURE__*/React.createElement(MenuItem, {
    key: option.Name,
    value: option
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: !!checked[option.Name],
    color: 'primary'
  }), /*#__PURE__*/React.createElement(ListItemText, {
    primary: `${option.Name} (${option.Count})`
  }))))), /*#__PURE__*/React.createElement(Box, {
    mr: 1,
    display: "inline-block",
    whiteSpace: "nowrap"
  }, total, " Posts"))));
};
FilterBar.propTypes = {
  total: PropTypes.number,
  appliedFilters: PropTypes.array,
  onChangeFilters: PropTypes.func.isRequired,
  availableFilters: PropTypes.object
};

const usePaginate = function () {
  let items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let pageSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  const [currentPage, setCurrentPage] = useState(1);
  const lastPage = Math.ceil(items.length / pageSize);
  const canLoadMore = lastPage > currentPage;
  const onLoadMore = useCallback(() => {
    setCurrentPage(currentPage + 1);
  }, [items, pageSize, currentPage]);
  const paginatedItems = slice(items, 0, currentPage * pageSize);
  useCallbackOnMount(() => {
    setCurrentPage(1);
  }, [items]);
  return {
    paginatedItems,
    canLoadMore,
    onLoadMore
  };
};

const useStyles$m = makeStyles(theme => ({
  gridItem: {
    marginBottom: theme.spacing(3)
  },
  [theme.breakpoints.up('md')]: {
    gridSizer: {
      width: 'calc(32% - 8px)'
    }
  },
  [theme.breakpoints.down('md')]: {
    gridSizer: {
      width: 'calc(32% - 8px)'
    }
  },
  [theme.breakpoints.down('sm')]: {
    gridSizer: {
      width: 'calc(49% - 8px)'
    }
  },
  [theme.breakpoints.down('xs')]: {
    gridSizer: {
      width: '100%'
    }
  },
  masonry: {
    minHeight: '625px'
  }
}));
const FilterableContentCarousel = _ref => {
  let {
    type,
    title,
    items,
    filters,
    hostedRootPath,
    availableFilters,
    onChangeFilters,
    contentImpressionComponent,
    getForYouPill,
    onViewContent,
    onClickContentLink,
    getTagPillProps
  } = _ref;
  const classes = useStyles$m();
  const {
    paginatedItems,
    canLoadMore,
    onLoadMore
  } = usePaginate(items, 14);
  const appliedFilters = get(filters, 'academicFocuses', []);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(CardContextWrapper, null, title && /*#__PURE__*/React.createElement(SectionTitle, {
    title: title,
    titleProps: {
      component: 'h3'
    }
  }), /*#__PURE__*/React.createElement(FilterBar, {
    appliedFilters: appliedFilters,
    total: size(items),
    availableFilters: availableFilters,
    onChangeFilters: onChangeFilters
  }), /*#__PURE__*/React.createElement(Masonry, {
    className: classes.masonry,
    options: {
      columnWidth: `.${classes.gridSizer}`,
      itemSelector: `.${classes.gridItem}`,
      percentPosition: false,
      gutter: 24
    },
    enableResizableChildren: true
  }, /*#__PURE__*/React.createElement("div", {
    className: cn(classes.gridSizer)
  }), map(paginatedItems, (item, idx) => {
    return /*#__PURE__*/React.createElement(Box, {
      className: cn(classes.gridItem, classes.gridSizer),
      key: item.Id
    }, /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(Metadata, {
      value: {
        filter: appliedFilters.join(',')
      }
    }, /*#__PURE__*/React.createElement(ContentCard$1, {
      type: type,
      item: item,
      contentImpressionComponent: contentImpressionComponent,
      idx: idx,
      getForYouPill: getForYouPill,
      onViewContent: args => {
        onViewContent({
          ...args,
          filters: appliedFilters
        });
      },
      hostedRootPath: hostedRootPath,
      getTagPillProps: getTagPillProps
    }))));
  })), canLoadMore && /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    p: 2
  }, /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    variant: "contained",
    onClick: onLoadMore
  }, "Load More")), /*#__PURE__*/React.createElement(CardModal$1, {
    hostedRootPath: hostedRootPath,
    onClickContentLink: onClickContentLink,
    items: items,
    onViewContent: args => {
      onViewContent({
        ...args,
        filters: appliedFilters
      });
    },
    getTagPillProps: getTagPillProps,
    type: type
  })));
};
FilterableContentCarousel.propTypes = {
  items: PropTypes.array.isRequired,
  type: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  filters: PropTypes.object,
  availableFilters: PropTypes.object,
  onChangeFilters: PropTypes.func,
  hostedRootPath: PropTypes.string.isRequired,
  contentImpressionComponent: PropTypes.func,
  getForYouPill: PropTypes.func,
  onViewContent: PropTypes.func,
  onClickContentLink: PropTypes.func,
  getTagPillProps: PropTypes.func
};

const {
  Carousel: Carousel$1,
  CarouselControls: CarouselControls$1,
  CarouselBody: CarouselBody$1
} = GridAlignedCarousel;
const MAX_COLUMNS_BY_TYPE = {
  //3 = 4 columns, 4 = 3 columns
  [CONTENT_TYPES.STUDENT_LIFE]: 3,
  [CONTENT_TYPES.OVERVIEW]: 4,
  [CONTENT_TYPES.ACADEMICS]: 4,
  [CONTENT_TYPES.ADMISSIONS]: 3,
  [CONTENT_TYPES.COST_FINANCIAL_AID]: 3,
  [CONTENT_TYPES.SESSIONS]: 4
};
const StandardContentCarousel = _ref => {
  let {
    type,
    title,
    items,
    hostedRootPath,
    contentImpressionComponent,
    getForYouPill,
    onViewContent,
    onClickContentLink,
    getTagPillProps
  } = _ref;
  return /*#__PURE__*/React.createElement(CardContextWrapper, null, /*#__PURE__*/React.createElement(Carousel$1, null, /*#__PURE__*/React.createElement(SectionTitle, {
    title: title,
    titleProps: {
      component: 'h3'
    },
    actions: /*#__PURE__*/React.createElement(CarouselControls$1, null)
  }), /*#__PURE__*/React.createElement(CarouselBody$1, {
    xs: 10,
    sm: 6,
    md: 4,
    lg: MAX_COLUMNS_BY_TYPE[type] || 4
  }, map(items, (item, idx) => {
    return /*#__PURE__*/React.createElement(Box, {
      pr: 2,
      key: item.Id
    }, /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(ContentCard$1, {
      type: type,
      item: item,
      contentImpressionComponent: contentImpressionComponent,
      idx: idx,
      getForYouPill: getForYouPill,
      onViewContent: onViewContent,
      hostedRootPath: hostedRootPath,
      getTagPillProps: getTagPillProps
    })));
  }))), /*#__PURE__*/React.createElement(CardModal$1, {
    hostedRootPath: hostedRootPath,
    onClickContentLink: onClickContentLink,
    items: items,
    onViewContent: onViewContent,
    getTagPillProps: getTagPillProps,
    type: type
  }));
};
StandardContentCarousel.propTypes = {
  items: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  hostedRootPath: PropTypes.string.isRequired,
  contentImpressionComponent: PropTypes.func,
  getForYouPill: PropTypes.func,
  onViewContent: PropTypes.func,
  onClickContentLink: PropTypes.func,
  getTagPillProps: PropTypes.func
};

const FILTERABLE_CONTENT_TYPES = {
  [CONTENT_TYPES.ACADEMICS]: true
};
const DisplayContentCards = _ref => {
  let {
    type,
    ...rest
  } = _ref;
  const isFilterableType = get(FILTERABLE_CONTENT_TYPES, type, false);
  return isFilterableType ? /*#__PURE__*/React.createElement(FilterableContentCarousel, _extends({
    type: type
  }, rest)) : /*#__PURE__*/React.createElement(StandardContentCarousel, _extends({
    type: type
  }, rest));
};
DisplayContentCards.propTypes = {
  type: PropTypes.string.isRequired
};
var DisplayContentCards$1 = withContext(DisplayContentCards, Context$2, ['getTagPillProps']);

let lastBulletScid;
const ContentSection = _ref => {
  let {
    scid,
    title,
    contentType,
    onReportHasContent,
    getCollegeContent,
    onLoadBullets,
    contentImpressionComponent,
    hostedRootPath,
    onViewContent,
    getForYouPill,
    getSessions,
    getPrograms,
    onClickContentLink
  } = _ref;
  let getContent;
  switch (contentType) {
    case CONTENT_TYPES.SESSIONS:
      getContent = getSessions;
      break;
    case CONTENT_TYPES.PROGRAMS:
      getContent = getPrograms;
      break;
    default:
      getContent = getCollegeContent;
  }
  const {
    loading,
    loaded,
    content,
    filters,
    onChangeFilters
  } = useCollegeContent(getContent, scid, contentType);
  const items = contentType === CONTENT_TYPES.PROGRAMS ? get(content, 'Programs', []) : get(content, 'Items', get(content, 'Sessions', []));
  const bullets = get(content, 'BulletPoints', []);
  const availableFilters = contentType === CONTENT_TYPES.PROGRAMS ? get(content, 'AcademicFocus', {}) : get(content, 'AvailableFilters', {});
  const hasFilters = !isEmpty(filters);
  const showNothing = isEmpty(items) && !hasFilters;
  const showLoading = loading && !hasFilters;
  useCallbackOnMount(() => {
    if (loaded || isUndefined(getContent)) {
      const hasContent = !isEmpty(items);
      onReportHasContent(hasContent);
    }
    if (!isEmpty(bullets) || lastBulletScid !== scid) {
      onLoadBullets(bullets);
      lastBulletScid = scid;
    }
  }, [loaded, content]);
  return showNothing ? null : showLoading ? /*#__PURE__*/React.createElement(Box, {
    p: 2,
    height: "75vh",
    justifyContent: "center",
    display: "flex"
  }, /*#__PURE__*/React.createElement(LoadingIndicator, {
    enabled: true
  })) : /*#__PURE__*/React.createElement(Box, {
    mb: 3,
    width: "100%"
  }, /*#__PURE__*/React.createElement(DisplayContentCards$1, {
    title: title,
    type: contentType,
    items: items,
    filters: filters,
    hostedRootPath: hostedRootPath,
    onChangeFilters: onChangeFilters,
    availableFilters: availableFilters,
    contentImpressionComponent: contentImpressionComponent,
    onViewContent: onViewContent,
    getForYouPill: getForYouPill,
    onClickContentLink: onClickContentLink
  }));
};
ContentSection.propTypes = {
  scid: PropTypes.number.isRequired,
  title: PropTypes.string,
  contentType: PropTypes.string,
  hostedRootPath: PropTypes.string.isRequired,
  onReportHasContent: PropTypes.func.isRequired,
  getCollegeContent: PropTypes.func,
  getSessions: PropTypes.func,
  getPrograms: PropTypes.func,
  contentImpressionComponent: PropTypes.func,
  onViewContent: PropTypes.func,
  onClickContentLink: PropTypes.func,
  getForYouPill: PropTypes.func,
  onLoadBullets: PropTypes.func
};
var ContentSection$1 = withContext(ContentSection, Context$2);

const contentType$6 = CONTENT_TYPES.OVERVIEW;
const FeaturedPosts$4 = _ref => {
  let {
    onReportHasContent
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    mt: 2
  }, /*#__PURE__*/React.createElement(ContentSection$1, {
    title: "Featured Posts",
    contentType: contentType$6,
    onReportHasContent: onReportHasContent
  }));
};
FeaturedPosts$4.propTypes = {
  onReportHasContent: PropTypes.func.isRequired
};

const useStyles$l = makeStyles(() => ({
  avatar: {
    height: 40,
    width: 40
  }
}));
const CollegeContentCard = _ref => {
  let {
    college,
    itemIndex,
    collegeCardProps,
    hostedRootPath,
    onViewContent,
    onClickContentLink
  } = _ref;
  const classes = useStyles$l();
  const [isOpen, setIsOpen] = useState();
  const {
    collegeSubtitle,
    collegeOverviewData,
    getCollegeCardActions,
    getCollegePreferencesPill
  } = collegeCardProps;
  const hasHeaderPills = getCollegePreferencesPill && getCollegePreferencesPill(college);
  const getCollegesPath = useGetCollegesPath();
  const bulletPoints = get(college, 'BulletPoints', get(college, 'Content.CollegeOverview.BulletPoints', []));
  const contentItem = get(college, 'ContentItem', get(college, 'Content.CollegeOverview.Items[0]'));
  const [getMetadata] = useMetadata();
  const lastTrackedContentId = useRef();
  const open = useCallback((open, ContentLaunchedVia) => {
    setIsOpen(open);
    if (open && isFunction(onViewContent) && lastTrackedContentId.current !== get(contentItem, 'Id')) {
      lastTrackedContentId.current = get(contentItem, 'Id');
      onViewContent({
        metadata: getMetadata(),
        ContentItemDisplayPosition: itemIndex,
        contentItem,
        ContentLaunchedVia
      });
    } else if (!open) {
      lastTrackedContentId.current = undefined;
    }
  }, [onViewContent, contentItem]);
  return jsxs(Fragment, {
    children: [jsx(ComplexCard, {
      headerPills: hasHeaderPills ? getCollegePreferencesPill(college) : undefined,
      headerProps: {
        title: college.Name,
        subheader: collegeSubtitle(college),
        avatar: jsx(TrackedImpression, {
          children: jsx(CollegeCrest, {
            scid: college.Scid,
            className: classes.avatar,
            alt: college.Name + ' logo'
          })
        })
      },
      headerToLink: getCollegesPath(college.Scid),
      hasHeaderDivider: true,
      mediaImageSrc: contentItem === null || contentItem === void 0 ? void 0 : contentItem.ImageUrl,
      contentTitle: contentItem === null || contentItem === void 0 ? void 0 : contentItem.Title,
      contentBody: contentItem === null || contentItem === void 0 ? void 0 : contentItem.Description,
      contentIcon: (contentItem === null || contentItem === void 0 ? void 0 : contentItem.Link) ? jsx(LinkIcon, {
        url: contentItem.Link
      }) : null,
      contentTitleTruncate: true,
      contentBodyTruncate: true,
      contentOnClick: () => {
        open(true, 'profile');
      },
      actions: getCollegeCardActions(college),
      expandContentMaxHeight: "185px",
      expandContent: jsx(ExpandableContent, {
        dataSets: [{
          type: 'overview',
          points: collegeOverviewData(college)
        }, {
          type: 'highlights',
          points: bulletPoints
        }]
      })
    }), jsx(ContentItemModal, {
      openItemIdx: 0,
      itemsCount: 1,
      hostedRootPath: hostedRootPath,
      item: isOpen ? contentItem : undefined,
      onChange: () => open(false, 'modal'),
      onTrackLinkClick: args => {
        if (isFunction(onClickContentLink)) {
          onClickContentLink({
            metadata: getMetadata(),
            args,
            itemIndex,
            contentItem
          });
        }
      }
    })]
  });
};

const {
  Carousel,
  CarouselBody,
  CarouselControls
} = GridAlignedCarousel;
const AffiliateCampuses = _ref => {
  let {
    college,
    collegeCardProps,
    onReportHasContent,
    ...rest
  } = _ref;
  const colleges = get(college, 'AffiliateColleges', []);
  const hasContent = !isEmpty(colleges);
  const eventTracking = useEventTracking();
  useCallbackOnMount(() => {
    onReportHasContent(hasContent);
  }, [hasContent]);
  return isEmpty(colleges) ? null : /*#__PURE__*/React.createElement(Carousel, null, /*#__PURE__*/React.createElement(SectionTitle, {
    title: "Affiliate Campuses",
    titleProps: {
      component: 'h3'
    },
    subTitle: "Regional, branch, or satellite campuses affiliated with this college",
    actions: /*#__PURE__*/React.createElement(CarouselControls, null)
  }), /*#__PURE__*/React.createElement(CarouselBody, {
    xs: 9,
    sm: 6,
    md: 4,
    spacing: 3
  }, map(colleges, (item, idx) => {
    return /*#__PURE__*/React.createElement(Metadata, {
      value: get(eventTracking, 'getAffiliateCampuses', noop)(item, idx),
      key: item.Scid
    }, /*#__PURE__*/React.createElement(Box, {
      mx: 0
    }, /*#__PURE__*/React.createElement(TrackedImpression, {
      correlate: true
    }, /*#__PURE__*/React.createElement(CollegeContentCard, _extends({}, rest, {
      college: item,
      itemIndex: idx,
      collegeCardProps: collegeCardProps
    })))));
  })));
};
AffiliateCampuses.propTypes = {
  college: PropTypes.object.isRequired,
  collegeCardProps: PropTypes.object,
  onReportHasContent: PropTypes.func.isRequired
};
var AffiliateCampuses$1 = withContext(AffiliateCampuses, Context$2);

const contentType$5 = CONTENT_TYPES.SESSIONS;
const SessionsContent = _ref => {
  let {
    onReportHasContent
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    mt: 2
  }, /*#__PURE__*/React.createElement(ContentSection$1, {
    title: "Upcoming Events",
    contentType: contentType$5,
    onReportHasContent: onReportHasContent
  }));
};
SessionsContent.propTypes = {
  onReportHasContent: PropTypes.func.isRequired
};
var SessionsContent$1 = withContext(SessionsContent, Context$2);

const contentType$4 = CONTENT_TYPES.PROGRAMS;
const ProgramsContent = _ref => {
  let {
    onReportHasContent
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    mt: 2
  }, /*#__PURE__*/React.createElement(ContentSection$1, {
    title: "Upcoming Summer Programs",
    contentType: contentType$4,
    onReportHasContent: onReportHasContent
  }));
};
ProgramsContent.propTypes = {
  onReportHasContent: PropTypes.func.isRequired
};
var ProgramsContent$1 = withContext(ProgramsContent, Context$2);

const Overview = _ref => {
  let {
    isActiveCurrentStudent,
    hideLocationMap = false,
    isTnTSearchFilterEnabled = false
  } = _ref;
  const {
    overviewPage,
    sessionsPage,
    programsPage
  } = useEventTracking();
  const [hasUpcomingVisits, setHasUpcomingVisits] = useState(null);
  const [hasSimilarColleges, setHasSimilarColleges] = useState(null);
  const [hasPreferenceMatchSection, setHasPreferenceMatchSection] = useState(null);
  const mightHaveUpcomingVisits = isActiveCurrentStudent && hasUpcomingVisits !== false;
  const mightHaveSimilarColleges = hasSimilarColleges !== false;
  const mightHavePreferenceMatchSection = hasPreferenceMatchSection !== false;
  const isLg = useBreakpoint('lg');
  const isUnauthed = useIsUnauthed();
  const shouldShowTwoColumns = isUnauthed ? mightHaveSimilarColleges : mightHaveUpcomingVisits || mightHaveSimilarColleges || mightHavePreferenceMatchSection;
  const numberOfMainSections = 7;
  const numberOfRightRailSections = isUnauthed ? 1 : isActiveCurrentStudent ? 3 : 2;
  const numberOfSections = numberOfRightRailSections + numberOfMainSections;
  const {
    hasContent,
    hasEnoughReports,
    reportHasContent
  } = useReportHasContent(numberOfSections);
  return /*#__PURE__*/React.createElement(Metadata, {
    value: overviewPage
  }, hasEnoughReports && /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(EmptyState$1, {
    isEmpty: !hasContent
  })), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 3
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: shouldShowTwoColumns ? 8 : 12
  }, /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(OurHighlights$1, {
    onReportHasContent: reportHasContent
  })), /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(AboutUs$1, {
    onReportHasContent: reportHasContent,
    isTnTSearchFilterEnabled: isTnTSearchFilterEnabled
  })), /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(ByTheNumbers$1, {
    onReportHasContent: reportHasContent
  })), /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(FeaturedPosts$4, {
    onReportHasContent: reportHasContent
  })), /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(Metadata, {
    value: sessionsPage
  }, /*#__PURE__*/React.createElement(SessionsContent$1, {
    onReportHasContent: reportHasContent
  }))), /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(Location$1, {
    onReportHasContent: reportHasContent,
    hasLargeMap: !shouldShowTwoColumns && isLg,
    hideMap: hideLocationMap
  })), /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(Metadata, {
    value: programsPage
  }, /*#__PURE__*/React.createElement(ProgramsContent$1, {
    onReportHasContent: reportHasContent
  }))), /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(AffiliateCampuses$1, {
    onReportHasContent: reportHasContent
  }))), shouldShowTwoColumns && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    sm: 12,
    md: 4
  }, isUnauthed ? null : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    mt: 3,
    id: "preference-match-section"
  }, /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(PreferenceMatchSection$1, {
    onReportHasContent: value => {
      reportHasContent(value);
      setHasPreferenceMatchSection(value);
    }
  }))), /*#__PURE__*/React.createElement(Box, null, isActiveCurrentStudent && /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(UpcomingVisits$1, {
    onReportHasContent: value => {
      reportHasContent(value);
      setHasUpcomingVisits(value);
    }
  })))), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(SimilarColleges$1, {
    onReportHasContent: value => {
      reportHasContent(value);
      setHasSimilarColleges(value);
    }
  }))))));
};
Overview.propTypes = {
  isActiveCurrentStudent: PropTypes.bool,
  hideLocationMap: PropTypes.bool,
  isTnTSearchFilterEnabled: PropTypes.bool
};
var index$1 = withContext(Overview, Context$2);

const useStyles$k = makeStyles({
  hideEmpty: {
    '&:empty': {
      display: 'none'
    }
  }
});
const HideIfEmpty = _ref => {
  let {
    component: Component = 'div',
    className,
    ...rest
  } = _ref;
  const classes = useStyles$k();
  return /*#__PURE__*/React.createElement(Component, _extends({
    className: cn(classes.hideEmpty, className)
  }, rest));
};
HideIfEmpty.propTypes = {
  component: PropTypes.any,
  className: PropTypes.string
};

const GUTTER$1 = 3;
const BREAKPOINT$1 = 'sm';
const useStyles$j = makeStyles(theme => {
  return {
    colWidth: {
      paddingBottom: theme.spacing(GUTTER$1),
      breakInside: 'avoid'
    },
    wrapper: {
      columnCount: 2,
      columnGap: theme.spacing(GUTTER$1)
    },
    [theme.breakpoints.down(BREAKPOINT$1)]: {
      wrapper: {
        columnCount: 1
      }
    },
    [theme.breakpoints.up(BREAKPOINT$1)]: {
      wrapper: {
        columnCount: 2
      }
    }
  };
});
const TwoColumnGrid = _ref => {
  let {
    children
  } = _ref;
  const classes = useStyles$j();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper
  }, map(children, (child, idx) => {
    return /*#__PURE__*/React.createElement(HideIfEmpty, {
      component: Box,
      className: classes.colWidth,
      key: idx
    }, child);
  }));
};
TwoColumnGrid.propTypes = {
  children: PropTypes.array
};

const HONORS_COLLEGE_MAPPING = {
  Apply: 'Apply to be considered',
  Invite: 'Invitation extended to top applicants'
};
const getHonorsCollege = college => {
  const honorsCollege = get(college, 'GeneralInfo.HonorsCollege', '').trim();
  const honorsDetails = HONORS_COLLEGE_MAPPING[honorsCollege];
  const hasHonorsCollege = !isEmpty(honorsCollege);
  return {
    honorsDetails,
    hasHonorsCollege
  };
};
const getIsTwoYear$1 = college => {
  const degrees = get(college, 'Degrees', []);
  return degrees.length === 1 && degrees.includes('Associates');
};
const getFullTime$1 = college => {
  const rawPercent = get(college, 'StudentBody.FullTimePct', 0);
  const hasPercent = rawPercent > 0;
  const percent = hasPercent ? `${toPercentage(rawPercent)} of students seek a degree with a full-time courseload` : NOT_REPORTED;
  return {
    fullTime: percent,
    hasFullTime: hasPercent
  };
};
const getTransferToFourYear$1 = college => {
  const rawTransfer = get(college, 'AcademicExperience.Pc2to4', 0);
  const hasTransfer = rawTransfer > 0;
  const transfer = hasTransfer ? `${toPercentage(rawTransfer)} of students transfer to a 4-year college` : NOT_REPORTED;
  return {
    transfer,
    hasTransfer
  };
};
const getLists = function () {
  let college = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (getIsTwoYear$1(college)) {
    const {
      fullTime,
      hasFullTime
    } = getFullTime$1(college);
    const {
      transfer,
      hasTransfer
    } = getTransferToFourYear$1(college);
    const hasData = hasFullTime || hasTransfer;
    return !hasData ? [] : [[{
      icon: faUserClock,
      primaryText: 'Full-Time Undergrads',
      secondaryText: fullTime
    }, {
      icon: faRandom,
      primaryText: 'Transfer to 4-year',
      secondaryText: transfer
    }]];
  } else {
    const {
      honorsDetails,
      hasHonorsCollege
    } = getHonorsCollege(college);
    return reject([reject([hasHonorsCollege && {
      icon: faAward,
      primaryText: 'Honors College',
      secondaryText: honorsDetails
    }], item => !item)], item => isEmpty(item));
  }
};

const Details = _ref => {
  let {
    college,
    onReportHasContent
  } = _ref;
  const lists = getLists(college);
  const hasData = !isEmpty(lists);
  useCallbackOnMount(() => {
    onReportHasContent(hasData);
  }, [hasData]);
  return !hasData ? null : /*#__PURE__*/React.createElement(Paper, {
    elevation: 0
  }, /*#__PURE__*/React.createElement(Box, {
    p: 2
  }, /*#__PURE__*/React.createElement(ColumnLists, {
    subheader: "Noteworthy Details",
    lists: lists
  })));
};
Details.propTypes = {
  college: PropTypes.object.isRequired,
  onReportHasContent: PropTypes.func.isRequired
};
var Details$1 = withContext(Details, Context$2);

const useStyles$i = makeStyles(theme => ({
  row: {
    '&:last-child td': {
      borderBottom: 0
    },
    '&:last-child th': {
      borderBottom: 0
    }
  },
  icon: {
    marginRight: theme.spacing(2),
    minWidth: '1em'
  },
  offeredIcon: {
    color: theme.palette.success.light
  },
  notOfferedIcon: {
    color: theme.palette.text.disabled
  }
}));
const getDegrees = college => {
  const degrees = get(college, 'Degrees');
  const hasBachelors = includes(degrees, 'Bachelors');
  const hasAssociate = includes(degrees, 'Associates');
  const hasCertificate = includes(degrees, 'Certificate');
  return {
    hasDegrees: !isEmpty(degrees),
    hasBachelors,
    hasAssociate,
    hasCertificate
  };
};
const Degrees = _ref => {
  let {
    college,
    onReportHasContent
  } = _ref;
  const classes = useStyles$i();
  const {
    hasDegrees,
    hasBachelors,
    hasAssociate,
    hasCertificate
  } = getDegrees(college);
  useCallbackOnMount(() => {
    onReportHasContent(hasDegrees);
  }, [hasDegrees]);
  const rows = [{
    title: "Bachelor's",
    offered: hasBachelors
  }, {
    title: 'Associate',
    offered: hasAssociate
  }, {
    title: 'Certificate',
    offered: hasCertificate
  }];
  return !hasDegrees ? null : /*#__PURE__*/React.createElement(Paper, {
    elevation: 0
  }, /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, /*#__PURE__*/React.createElement("strong", null, "Degree"))), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, /*#__PURE__*/React.createElement("strong", null, "Offered?"))))), /*#__PURE__*/React.createElement(TableBody, null, rows.map(row => /*#__PURE__*/React.createElement(TableRow, {
    key: row.title,
    className: classes.row
  }, /*#__PURE__*/React.createElement(TableCell, {
    width: "50%",
    component: "th",
    scope: "row"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, row.title)), /*#__PURE__*/React.createElement(TableCell, {
    width: "50%"
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: cn(classes.icon, row.offered ? classes.offeredIcon : classes.notOfferedIcon),
    size: "sm",
    icon: row.offered ? faCheck$1 : faTimes
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    "data-testid": `value-${row.title}`
  }, row.offered ? 'Yes' : 'No'))))))));
};
Degrees.propTypes = {
  college: PropTypes.object.isRequired,
  onReportHasContent: PropTypes.func.isRequired
};
var Degrees$1 = withContext(Degrees, Context$2);

const useStyles$h = makeStyles({
  datum: {
    '&:last-child td': {
      borderBottom: 0
    },
    '&:last-child th': {
      borderBottom: 0
    }
  }
});
const TwoColumnTable = _ref => {
  let {
    head1,
    head2,
    data,
    headerContent
  } = _ref;
  const classes = useStyles$h();
  return isEmpty(data) && isUndefined(headerContent) ? null : /*#__PURE__*/React.createElement(Paper, {
    elevation: 0
  }, headerContent, !isEmpty(data) && /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    component: "div"
  }, /*#__PURE__*/React.createElement("strong", null, head1))), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    component: "div"
  }, /*#__PURE__*/React.createElement("strong", null, head2)))))), /*#__PURE__*/React.createElement(TableBody, null, data.map(datum => /*#__PURE__*/React.createElement(TableRow, {
    key: datum.title,
    className: classes.datum
  }, /*#__PURE__*/React.createElement(TableCell, {
    width: "50%",
    component: "th",
    scope: "datum"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, datum.title)), /*#__PURE__*/React.createElement(TableCell, {
    width: "50%"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, datum.value)))))));
};
TwoColumnTable.propTypes = {
  head1: PropTypes.node,
  head2: PropTypes.node,
  data: PropTypes.array,
  headerContent: PropTypes.node
};

const getData$3 = college => {
  const data = get(college, 'PopularDegrees', []).map(degree => ({
    title: degree.Name,
    value: toPercentage(round(degree.Percent * 100))
  }));
  return take(data, 5);
};
const Majors = _ref => {
  let {
    college,
    onReportHasContent
  } = _ref;
  const data = getData$3(college);
  const hasData = !isEmpty(data);
  useCallbackOnMount(() => {
    onReportHasContent(hasData);
  }, [hasData]);
  return /*#__PURE__*/React.createElement(TwoColumnTable, {
    head1: "Popular Major",
    head2: "% of Undergrads",
    data: data
  });
};
Majors.propTypes = {
  college: PropTypes.object.isRequired,
  onReportHasContent: PropTypes.func.isRequired
};
var Majors$1 = withContext(Majors, Context$2);

const getSanitizedTerm = term => term.replace(/[^a-zA-Z0-9]+/gi, '');
const matches = (term, name) => new RegExp(getSanitizedTerm(term), 'gi').test(name);
const getVisibilityConfiguration = (data, term) => {
  const expanded_OBJECT = {};
  const missingTerm = isEmpty(term);
  const names = keys(data);
  const oneMatches = names => some(names, name => matches(term, name));
  const hasMatchingChildren = name => oneMatches(data[name].childNames);
  const shouldShow = name => {
    return matches(term, name) || hasMatchingChildren(name) || oneMatches(keys(data[name].parentNames));
  };
  const setExpanded = name => {
    if (hasMatchingChildren(name)) {
      forEach(data[name].sameNameIds, id => {
        expanded_OBJECT[id] = true;
      });
    }
  };
  const visibilityConfiguration = produce(data, draft => {
    names.forEach(name => {
      const show = missingTerm || shouldShow(name);
      draft[name].show = show;
      if (show && !missingTerm) {
        setExpanded(name);
      }
    });
  });
  return {
    expanded: missingTerm ? [] : keys(expanded_OBJECT),
    visibilityConfiguration
  };
};
const getChildNames = children => {
  const childNames = [];
  const addChildrenLoop = children => {
    forEach(children, child => {
      childNames.push(child.name);
      if (!isEmpty(child.children)) {
        addChildrenLoop(child.children);
      }
    });
  };
  if (!isEmpty(children)) {
    addChildrenLoop(children);
  }
  return childNames;
};
const getDefaultConfiguration = data => {
  const visibilityConfiguration = {};
  const updateExistingConfig = _ref => {
    let {
      name,
      id
    } = _ref;
    visibilityConfiguration[name].sameNameIds.push(id);
    visibilityConfiguration[name].parentNames[name] = true;
  };
  const setConfig = (_ref2, parentIds, parentNames) => {
    let {
      name,
      children,
      id
    } = _ref2;
    visibilityConfiguration[name] = {
      show: true,
      childNames: getChildNames(children),
      sameNameIds: [id],
      parentIds,
      parentNames
    };
  };
  const setNames = (arr, parentIds, parentNames) => forEach(arr, item => {
    const {
      name,
      children,
      id
    } = item;
    const hasConfig = isObject(visibilityConfiguration[name]);
    if (hasConfig) {
      updateExistingConfig(item);
    } else {
      setConfig(item, parentIds, parentNames);
    }
    setNames(children, [...parentIds, id], {
      ...parentNames,
      [name]: true
    });
  });
  setNames(data, [], {});
  return visibilityConfiguration;
};

const TYPES = {
  SEARCH: 'SEARCH',
  TOGGLE_EXPAND: 'TOGGLE_EXPAND'
};
const getInitialState = data => {
  return {
    term: '',
    expanded: [],
    visibilityConfiguration: getDefaultConfiguration(data)
  };
};
const REDUCER = (state, action) => {
  switch (action.type) {
    case TYPES.SEARCH:
      return produce(state, draft => {
        const {
          expanded,
          visibilityConfiguration
        } = getVisibilityConfiguration(state.visibilityConfiguration, action.term);
        draft.expanded = expanded;
        draft.visibilityConfiguration = visibilityConfiguration;
        draft.term = action.term;
      });
    case TYPES.TOGGLE_EXPAND:
      return produce(state, draft => {
        draft.expanded = action.nodeIds;
      });
  }
};

const useSearch = data => {
  const initialState = useMemo(() => getInitialState(data), [data]);
  const [{
    term,
    expanded,
    visibilityConfiguration
  }, dispatch] = useReducer(REDUCER, initialState);
  const onSearch = e => {
    dispatch({
      type: TYPES.SEARCH,
      term: e.target.value
    });
  };
  const onNodeToggle = (e, nodeIds) => {
    dispatch({
      type: TYPES.TOGGLE_EXPAND,
      nodeIds
    });
  };
  return {
    visibilityConfiguration,
    expanded,
    term,
    onSearch,
    onNodeToggle
  };
};

const useStyles$g = makeStyles({
  match: {
    backgroundColor: 'yellow'
  }
});
const SubstringHighlighter = _ref => {
  let {
    term,
    value
  } = _ref;
  const classes = useStyles$g();
  const regex = new RegExp(getSanitizedTerm(term), 'gi');
  const matches = value.match(regex);
  if (isEmpty(term) || isNull(matches)) return value;
  return /*#__PURE__*/React.createElement(React.Fragment, null, map(value.split(regex), (part, idx) => {
    const match = matches[idx];
    return isEmpty(match) ? part : /*#__PURE__*/React.createElement(React.Fragment, {
      key: idx
    }, part, /*#__PURE__*/React.createElement("strong", {
      className: classes.match
    }, match));
  }));
};
SubstringHighlighter.propTypes = {
  term: PropTypes.string,
  value: PropTypes.string
};

const SubTree = _ref => {
  let {
    id,
    name,
    nodeChildren,
    visibilityConfiguration,
    term
  } = _ref;
  const isHidden = get(visibilityConfiguration, `${name}.show`, true) === false;
  return isHidden ? null : /*#__PURE__*/React.createElement(Box, {
    p: 1,
    key: id
  }, /*#__PURE__*/React.createElement(TreeItem, {
    nodeId: id,
    label: /*#__PURE__*/React.createElement(SubstringHighlighter, {
      term: term,
      value: name
    })
  }, isEmpty(nodeChildren) ? null : nodeChildren.map(node => /*#__PURE__*/React.createElement(SubTree, {
    key: node.id,
    id: node.id,
    name: node.name,
    nodeChildren: node.children,
    visibilityConfiguration: visibilityConfiguration,
    term: term
  }))));
};
SubTree.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  nodeChildren: PropTypes.array,
  visibilityConfiguration: PropTypes.object,
  term: PropTypes.string
};

const useStyles$f = makeStyles({
  searchBar: {
    width: '100%'
  },
  outlined: {
    transform: 'translate(2rem, 1.15rem) scale(1)'
  },
  scrollable: {
    maxHeight: '50vh',
    overflowX: 'hidden',
    overflowY: 'scroll'
  }
});
const SearchableTree = _ref => {
  let {
    data
  } = _ref;
  const classes = useStyles$f();
  const {
    visibilityConfiguration,
    term,
    expanded,
    onSearch,
    onNodeToggle
  } = useSearch(data);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    mb: 2
  }, /*#__PURE__*/React.createElement(TextField, {
    placeholder: "Search",
    label: "Search",
    type: "search",
    variant: "outlined",
    className: classes.searchBar,
    onChange: onSearch,
    InputLabelProps: {
      classes: {
        outlined: classes.outlined
      }
    }
  })), /*#__PURE__*/React.createElement(TreeView, {
    className: classes.scrollable,
    expanded: expanded,
    onNodeToggle: onNodeToggle,
    defaultCollapseIcon: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faChevronDown
    }),
    defaultExpandIcon: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faChevronRight
    })
  }, map(data, node => /*#__PURE__*/React.createElement(SubTree, {
    key: node.id,
    id: node.id,
    name: node.name,
    nodeChildren: node.children,
    visibilityConfiguration: visibilityConfiguration,
    term: term
  }))));
};
SearchableTree.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    children: PropTypes.array
  })).isRequired
};

const useStyles$e = makeStyles(theme => ({
  icon: {
    transition: 'all 0.25s ease-out'
  },
  open: {
    transform: 'rotate(-180deg)'
  },
  fosCount: {
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  }
}));
const FieldsOfStudy = _ref => {
  let {
    college,
    isCollapsible,
    onReportHasContent
  } = _ref;
  const classes = useStyles$e();
  const {
    count,
    data
  } = useMemo(() => getData$8(college), [college]);
  const [collapsed, setCollapsed] = useState(false);
  const hasContent = count > 0;
  useCallbackOnMount(() => {
    onReportHasContent(hasContent);
  }, []);
  return !hasContent ? null : /*#__PURE__*/React.createElement(Paper, {
    elevation: 0
  }, /*#__PURE__*/React.createElement(Box, {
    p: 3,
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fosCount
  }, college.Name, " offers ", count, " Fields of Study"), isCollapsible && /*#__PURE__*/React.createElement(IconButton, {
    className: cn(classes.icon, {
      [classes.open]: !collapsed
    }),
    onClick: () => setCollapsed(!collapsed)
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faChevronDown
  }))), /*#__PURE__*/React.createElement(ToggleBox, {
    collapsed: collapsed
  }, /*#__PURE__*/React.createElement(Box, {
    p: 3
  }, /*#__PURE__*/React.createElement(SearchableTree, {
    data: data
  }))));
};
FieldsOfStudy.propTypes = {
  isCollapsible: PropTypes.bool,
  college: PropTypes.object.isRequired,
  onReportHasContent: PropTypes.func.isRequired
};
var FieldsOfStudy$1 = withContext(FieldsOfStudy, Context$2);

const contentType$3 = CONTENT_TYPES.ACADEMICS;
const FeaturedPosts$3 = _ref => {
  let {
    onReportHasContent
  } = _ref;
  return /*#__PURE__*/React.createElement(ContentSection$1, {
    contentType: contentType$3,
    onReportHasContent: onReportHasContent
  });
};
FeaturedPosts$3.propTypes = {
  onReportHasContent: PropTypes.func.isRequired
};

const getDisplayLogic = _ref => {
  let {
    hasFeaturedPosts,
    hasFieldsOfStudy,
    hasEnoughReports,
    isResponsive
  } = _ref;
  const hasFP = hasFeaturedPosts === true;
  const hasFOS = hasFieldsOfStudy === true;
  const doesNotHaveFP = hasFeaturedPosts === false;
  const doesNotHaveFOS = hasFieldsOfStudy === false;
  const showFeaturedPostsInMiddle = !hasEnoughReports || isResponsive || hasFP;
  const showFieldsOfStudyInMiddle = !hasEnoughReports || isResponsive || doesNotHaveFP && hasFieldsOfStudy;
  const showThreeSectionsInMiddle = !hasEnoughReports || isResponsive || doesNotHaveFP && doesNotHaveFOS;
  const showThreeSectionsInRail = !hasEnoughReports && !isResponsive || hasFP || hasFOS;
  const showFieldsOfStudyInRail = !hasEnoughReports && !isResponsive || hasFP && hasFOS;
  const showRail = !isResponsive && hasEnoughReports && (showThreeSectionsInRail || showFieldsOfStudyInRail);
  return {
    showRail,
    showFeaturedPostsInMiddle,
    showFieldsOfStudyInMiddle,
    showThreeSectionsInMiddle,
    showThreeSectionsInRail,
    showFieldsOfStudyInRail
  };
};

const spacing = 3;
const Academics = () => {
  const {
    academicsPage
  } = useEventTracking();
  const [hasFieldsOfStudy, setHasFieldsOfStudy] = useState();
  const [hasFeaturedPosts, setHasFeaturedPosts] = useState();
  const {
    hasContent,
    hasEnoughReports,
    reportHasContent
  } = useReportHasContent(5);
  const isResponsive = useBreakpoint(['xs', 'sm'], 'between');
  const {
    showRail,
    showFeaturedPostsInMiddle,
    showFieldsOfStudyInMiddle,
    showThreeSectionsInMiddle,
    showThreeSectionsInRail,
    showFieldsOfStudyInRail
  } = getDisplayLogic({
    hasFeaturedPosts,
    hasFieldsOfStudy,
    hasEnoughReports,
    isResponsive
  });
  const featuredPosts = /*#__PURE__*/React.createElement(FeaturedPosts$3, {
    onReportHasContent: value => {
      reportHasContent(value);
      setHasFeaturedPosts(value);
    }
  });
  const fieldsOfStudy = /*#__PURE__*/React.createElement(FieldsOfStudy$1, {
    onReportHasContent: value => {
      reportHasContent(value);
      setHasFieldsOfStudy(value);
    }
  });
  const degrees = /*#__PURE__*/React.createElement(Degrees$1, {
    onReportHasContent: reportHasContent
  });
  const details = /*#__PURE__*/React.createElement(Details$1, {
    onReportHasContent: reportHasContent
  });
  const majors = /*#__PURE__*/React.createElement(Majors$1, {
    onReportHasContent: reportHasContent
  });
  return /*#__PURE__*/React.createElement(Metadata, {
    value: academicsPage
  }, hasEnoughReports && /*#__PURE__*/React.createElement(EmptyState$1, {
    isEmpty: !hasContent
  }), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: spacing
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: showRail ? 8 : 12
  }, hasEnoughReports && hasContent && /*#__PURE__*/React.createElement(SectionTitle, {
    titleProps: {
      component: 'h3'
    },
    title: "Academic Program Highlights"
  }), showThreeSectionsInMiddle && /*#__PURE__*/React.createElement(TwoColumnGrid, null, degrees, details, majors), showFieldsOfStudyInMiddle && fieldsOfStudy, showFeaturedPostsInMiddle && /*#__PURE__*/React.createElement(React.Fragment, null, hasEnoughReports && showThreeSectionsInMiddle && /*#__PURE__*/React.createElement(SectionTitle, {
    titleProps: {
      component: 'h3'
    },
    title: "Learn More About Our Academic Programs"
  }), featuredPosts)), showRail && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    sm: 12,
    md: 4
  }, showThreeSectionsInRail && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    mt: spacing
  }, /*#__PURE__*/React.createElement(ErrorBoundary, null, degrees)), /*#__PURE__*/React.createElement(Box, {
    mt: spacing
  }, /*#__PURE__*/React.createElement(ErrorBoundary, null, details)), /*#__PURE__*/React.createElement(Box, {
    mt: spacing
  }, /*#__PURE__*/React.createElement(ErrorBoundary, null, majors))), showFieldsOfStudyInRail && /*#__PURE__*/React.createElement(Box, {
    mt: spacing
  }, /*#__PURE__*/React.createElement(ErrorBoundary, null, fieldsOfStudy)))));
};

const GUTTER = 3;
const BREAKPOINT = 'sm';
const BREAKPOINT_MD = 'md';
const useStyles$d = makeStyles(theme => {
  return {
    colWidth: {
      paddingBottom: theme.spacing(GUTTER),
      breakInside: 'avoid'
    },
    wrapper: {
      columnCount: 3,
      columnGap: theme.spacing(GUTTER)
    },
    [theme.breakpoints.down(BREAKPOINT)]: {
      wrapper: {
        columnCount: 1
      }
    },
    [theme.breakpoints.up(BREAKPOINT)]: {
      wrapper: {
        columnCount: 2
      }
    },
    [theme.breakpoints.up(BREAKPOINT_MD)]: {
      wrapper: {
        columnCount: 3
      }
    }
  };
});
const ThreeColumnGrid = _ref => {
  let {
    children
  } = _ref;
  const classes = useStyles$d();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper
  }, map(children, (child, idx) => {
    return /*#__PURE__*/React.createElement(HideIfEmpty, {
      component: Box,
      className: classes.colWidth,
      key: idx
    }, child);
  }));
};
ThreeColumnGrid.propTypes = {
  children: PropTypes.array
};

const Admissions$1 = _ref => {
  let {
    college,
    onReportHasContent
  } = _ref;
  const {
    hasData,
    data,
    hasAcceptanceRate,
    acceptanceRate
  } = getData$5(college);
  useCallbackOnMount(() => {
    onReportHasContent(hasData);
  }, [hasData]);
  return !hasData ? null : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DataPoint, {
    title: "Admission Rate",
    theme: DATA_POINT_BLUE,
    datum: hasAcceptanceRate ? acceptanceRate : undefined,
    disabled: hasAcceptanceRate ? false : true,
    squareBottomCorners: true
  }), /*#__PURE__*/React.createElement(TwoColumnTable, {
    head1: "Admissions",
    head2: "Statistic",
    data: data
  }));
};
Admissions$1.propTypes = {
  college: PropTypes.object.isRequired,
  onReportHasContent: PropTypes.func.isRequired
};
var Admissions$2 = withContext(Admissions$1, Context$2);

const Act = _ref => {
  let {
    college,
    onReportHasContent,
    onHasAtleastOneNotReportedScore
  } = _ref;
  const {
    hasData,
    hasAtleastOneNotReported,
    data,
    hasAverage,
    average
  } = getData$6(college);
  useCallbackOnMount(() => {
    onReportHasContent(hasData);
    onHasAtleastOneNotReportedScore(hasAtleastOneNotReported);
  }, [hasData, hasAtleastOneNotReported]);
  return !hasData ? null : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DataPoint, {
    title: "Average ACT",
    theme: DATA_POINT_BLUE,
    datum: hasAverage ? average : undefined,
    disabled: hasAverage ? false : true,
    squareBottomCorners: true
  }), /*#__PURE__*/React.createElement(TwoColumnTable, {
    head1: "ACT",
    head2: "Statistic",
    data: data
  }));
};
Act.propTypes = {
  college: PropTypes.object.isRequired,
  onReportHasContent: PropTypes.func.isRequired,
  onHasAtleastOneNotReportedScore: PropTypes.func.isRequired
};
var Act$1 = withContext(Act, Context$2);

const Sat = _ref => {
  let {
    college,
    onReportHasContent,
    onHasAtleastOneNotReportedScore
  } = _ref;
  const {
    hasData,
    hasAtleastOneNotReported,
    data,
    average,
    hasAverage
  } = getData$7(college);
  useCallbackOnMount(() => {
    onReportHasContent(hasData);
    onHasAtleastOneNotReportedScore(hasAtleastOneNotReported);
  }, [hasData, hasAtleastOneNotReported]);
  return !hasData ? null : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DataPoint, {
    title: "Average SAT",
    theme: DATA_POINT_BLUE,
    datum: hasAverage ? average : undefined,
    disabled: hasAverage ? false : true,
    squareBottomCorners: true
  }), /*#__PURE__*/React.createElement(TwoColumnTable, {
    head1: "SAT",
    head2: "Statistic",
    data: data
  }));
};
Sat.propTypes = {
  college: PropTypes.object.isRequired,
  onReportHasContent: PropTypes.func.isRequired,
  onHasAtleastOneNotReportedScore: PropTypes.func.isRequired
};
var Sat$1 = withContext(Sat, Context$2);

const SlideUpWrapper = (props, ref) => /*#__PURE__*/React.createElement(Slide, _extends({
  direction: "up",
  ref: ref
}, props));
const SlideUp = /*#__PURE__*/React.forwardRef(SlideUpWrapper);

const useStyles$c = makeStyles(theme => ({
  appBar: {
    position: 'relative',
    background: '#FFFFFF',
    borderBottom: '1px solid #E0E0E0'
  },
  title: {
    marginLeft: theme.spacing(2),
    color: '#000000',
    flex: 1
  }
}));
const DISABLED_REASONS = {
  HS: 'Connect to your High School to see relevant data',
  NO_DATA: 'There is not enough data to display an application scattergram for this college'
};
const ScattergramAction = _ref => {
  let {
    disabledScattergram,
    scatterplot,
    isInnerModalOpen
  } = _ref;
  const classes = useStyles$c();
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const disabledReason = disabledScattergram ? DISABLED_REASONS.HS : '';
  const btn = /*#__PURE__*/React.createElement(Button, {
    variant: "outlined",
    color: "primary",
    disabled: disabledScattergram,
    onClick: handleClickOpen
  }, "View Application Scattergram");
  return !scatterplot ? null : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    my: -2
  }, ' ', disabledReason ? /*#__PURE__*/React.createElement(Tooltip, {
    title: disabledReason,
    placement: "top"
  }, /*#__PURE__*/React.createElement("div", null, btn)) : btn), /*#__PURE__*/React.createElement(Dialog, {
    fullScreen: true,
    open: open,
    onClose: handleClose,
    TransitionComponent: SlideUp,
    ModalProps: {
      disableEnforceFocus: isInnerModalOpen
    }
  }, /*#__PURE__*/React.createElement(AppBar, {
    className: classes.appBar,
    elevation: 0
  }, /*#__PURE__*/React.createElement(Toolbar, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    className: classes.title
  }, "Application Analysis"), /*#__PURE__*/React.createElement(IconButton, {
    edge: "start",
    color: "inherit",
    onClick: handleClose,
    "aria-label": "close"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    fixedWidth: true,
    style: {
      color: '#333'
    },
    size: "xs",
    icon: faTimes$1
  })))), /*#__PURE__*/React.createElement(Box, null, scatterplot)));
};
ScattergramAction.propTypes = {
  scatterplot: PropTypes.node,
  disabledScattergram: PropTypes.bool,
  isInnerModalOpen: PropTypes.bool.isRequired
};
var Scattergram = withContext(ScattergramAction, Context$2);

const ATLEAST_ONE_NOT_REPORTED = 'This college is Test Optional and does not report on all SAT and ACT scores';
const NO_CONTENT_TO_DISPLAY = 'No SAT or ACT scores reported for this College';
const StudentStatistics = _ref => {
  let {
    college,
    onReportHasContent
  } = _ref;
  const {
    hasContent,
    hasEnoughReports,
    reportHasContent
  } = useReportHasContent(3);
  const [hasAtleastOneNotReportedScore, setHasAtleastOneNotReportedScore] = useState(false);
  const testOptional = get(college, 'TestOptional', false);
  const updateHasAtleastOneNotReportedScore = useCallback(hasNotReportedScore => {
    if (hasNotReportedScore) setHasAtleastOneNotReportedScore(true);
  }, []);
  useCallbackOnMount(() => {
    if (hasEnoughReports) {
      onReportHasContent(hasContent);
    }
  }, [hasEnoughReports, hasContent]);
  let subtitle = undefined;
  if (testOptional && hasAtleastOneNotReportedScore) {
    subtitle = ATLEAST_ONE_NOT_REPORTED;
  } else if (hasEnoughReports && !hasContent) {
    subtitle = NO_CONTENT_TO_DISPLAY;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SectionTitle, {
    title: "Admitted Student Statistics",
    subTitle: subtitle,
    titleProps: {
      component: 'h3'
    },
    actions: [/*#__PURE__*/React.createElement(Scattergram, {
      key: "scattergram"
    })]
  }), (!hasEnoughReports || hasContent) && /*#__PURE__*/React.createElement(Box, {
    mt: 2
  }, /*#__PURE__*/React.createElement(ThreeColumnGrid, null, /*#__PURE__*/React.createElement(Admissions$2, {
    onReportHasContent: reportHasContent
  }), /*#__PURE__*/React.createElement(Sat$1, {
    onReportHasContent: reportHasContent,
    onHasAtleastOneNotReportedScore: updateHasAtleastOneNotReportedScore
  }), /*#__PURE__*/React.createElement(Act$1, {
    onReportHasContent: reportHasContent,
    onHasAtleastOneNotReportedScore: updateHasAtleastOneNotReportedScore
  }))));
};
StudentStatistics.propTypes = {
  college: PropTypes.object.isRequired,
  onReportHasContent: PropTypes.func.isRequired
};
var StudentStatistics$1 = withContext(StudentStatistics, Context$2);

const useStyles$b = makeStyles({
  row: {
    '&:last-child td': {
      borderBottom: 0
    },
    '&:last-child th': {
      borderBottom: 0
    }
  }
});
const getDisplayableDate = date => {
  const monthNum = get(date, 'Month', 0);
  const dayNum = get(date, 'Day', 0);
  if (monthNum == 0 || dayNum == 0) {
    return '';
  }
  const year = new Date().getFullYear();
  const displayDate = new Date(year, monthNum - 1, dayNum);
  return format(displayDate, 'MMMM d');
};
const getAppRounds = college => {
  const appRounds = get(college, 'ApplicationRounds', []);
  const rounds = appRounds.map(round => ({
    Name: round.Name,
    Date: getDisplayableDate(round.DueDate)
  }));
  return rounds;
};
const AppRounds = _ref => {
  let {
    college,
    onReportHasContent
  } = _ref;
  const classes = useStyles$b();
  const rows = getAppRounds(college);
  const hasContent = !isEmpty(rows);
  useCallbackOnMount(() => {
    onReportHasContent(hasContent);
  }, [hasContent]);
  return !hasContent ? null : /*#__PURE__*/React.createElement(Paper, {
    elevation: 0
  }, /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, /*#__PURE__*/React.createElement("strong", null, "Application Type"))), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, /*#__PURE__*/React.createElement("strong", null, "Deadline"))))), /*#__PURE__*/React.createElement(TableBody, null, rows.map(row => /*#__PURE__*/React.createElement(TableRow, {
    key: row.Name,
    className: classes.row
  }, /*#__PURE__*/React.createElement(TableCell, {
    width: "50%",
    component: "th",
    scope: "row"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, row.Name)), /*#__PURE__*/React.createElement(TableCell, {
    width: "50%"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "textPrimary"
  }, row.Date)))))));
};
AppRounds.propTypes = {
  college: PropTypes.object.isRequired,
  onReportHasContent: PropTypes.func.isRequired
};
var AppRounds$1 = withContext(AppRounds, Context$2);

const useStyles$a = makeStyles(theme => ({
  icon: {
    marginRight: theme.spacing(2),
    minWidth: '1em'
  },
  acceptedIcon: {
    color: theme.palette.success.light
  },
  notAcceptedIcon: {
    color: theme.palette.text.disabled
  }
}));
const YesNo = _ref => {
  let {
    value
  } = _ref;
  const classes = useStyles$a();
  return /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: cn(classes.icon, value ? classes.acceptedIcon : classes.notAcceptedIcon),
    size: "sm",
    icon: value ? faCheck$1 : faTimes
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "textPrimary"
  }, value ? 'Yes' : 'No'));
};
YesNo.propTypes = {
  value: PropTypes.bool
};

var img$2 = "data:image/jpeg;base64,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";

var img$1 = "data:image/png;base64,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";

var img = "data:image/png;base64,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";

const useStyles$9 = makeStyles(theme => ({
  row: {
    '&:last-child td': {
      borderBottom: 0
    },
    '&:last-child th': {
      borderBottom: 0
    }
  },
  icon: {
    marginRight: theme.spacing(2),
    minWidth: '1em',
    fontSize: 40,
    backgroundColor: 'transparent'
  },
  groupIcon: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    spacing: 'small',
    backgroundColor: 'transparent'
  },
  avatarDescription: {
    marginLeft: theme.spacing(1)
  },
  freeText: {
    color: theme.palette.success.main
  },
  strikethrough: {
    textDecoration: 'line-through'
  },
  acceptedIcon: {
    color: theme.palette.success.light
  },
  notAcceptedIcon: {
    color: theme.palette.text.disabled
  }
}));
const AppFee = _ref => {
  let {
    college,
    appConfig,
    userAppProfile,
    isInStudentApp,
    onUnauthedFeeWaiverModal,
    onCheckFeeWaiverEligibility,
    onFindFreeSchools,
    classes
  } = _ref;
  const scoirApplyEnabled = get(college, 'DisplayAsScoirApply', false);
  const appFeeAmount = get(college, 'AdmissionFreshmen.ApplicFeeAmt', 0);
  let displayAsFree = false;
  let caption = undefined;
  const isUnauthed = useIsUnauthed();
  if (isInStudentApp && onFindFreeSchools && scoirApplyEnabled && appFeeAmount !== 0) {
    if (!get(userAppProfile, 'FeeWaiverComplete', false)) {
      caption = /*#__PURE__*/React.createElement(Typography, {
        className: get(classes, 'avatarDescription'),
        variant: "body2",
        color: "textPrimary"
      }, /*#__PURE__*/React.createElement(Link$1, {
        component: "button",
        variant: "body2",
        onClick: isUnauthed ? onUnauthedFeeWaiverModal : onCheckFeeWaiverEligibility //eslint-disable-line
      }, "See if you qualify"), "\xA0for the Coalition Fee Waiver when you apply with Scoir.");
    } else {
      displayAsFree = get(userAppProfile, 'FeeWaiverEligible', false);
      if (!displayAsFree) {
        const isMilitaryEligible = get(userAppProfile, 'MilitaryEligible', false);
        const acceptsMilitaryFW = get(appConfig, 'ArmedForcesFeeWaiverEligibility.FeeWaiver', false);
        const isActive = get(appConfig, 'FirstYearConfiguration.Enabled', false) || get(appConfig, 'TransferConfiguration.Enabled', false);
        displayAsFree = isActive && acceptsMilitaryFW && isMilitaryEligible;
      }
      if (displayAsFree) {
        caption = /*#__PURE__*/React.createElement(Typography, {
          className: classes.avatarDescription,
          variant: "body2",
          color: "textPrimary"
        }, "You're eligible for the Coalition Fee Waiver when you apply to this college\xA0", /*#__PURE__*/React.createElement(Link$1, {
          component: "button",
          variant: "body2",
          onClick: onFindFreeSchools
        }, "and others"), "\xA0with Scoir.");
      } else {
        caption = /*#__PURE__*/React.createElement(Typography, {
          className: classes.avatarDescription,
          variant: "body2",
          color: "textPrimary"
        }, "Your profile does not appear to be eligible for the Coalition Fee Waiver, but you can explore schools offering\xA0", /*#__PURE__*/React.createElement(Link$1, {
          component: "button",
          variant: "body2",
          onClick: onFindFreeSchools
        }, "free apps with Scoir"), ".");
      }
    }
  }
  return /*#__PURE__*/React.createElement(Box, {
    p: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "textSecondary"
  }, "Application Fee"), !displayAsFree && /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "textPrimary"
  }, '$' + appFeeAmount), displayAsFree && /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignContent: "flex-end",
    textAlign: "baseline"
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.freeText,
    variant: "h5"
  }, "Free\xA0"), /*#__PURE__*/React.createElement(Typography, {
    className: classes.strikethrough,
    variant: "h5",
    color: "textSecondary"
  }, '$' + appFeeAmount)), caption && /*#__PURE__*/React.createElement(Box, {
    mt: 1,
    display: "flex"
  }, /*#__PURE__*/React.createElement(AvatarGroup, null, /*#__PURE__*/React.createElement(Avatar, {
    className: classes.groupIcon
  }, /*#__PURE__*/React.createElement(ScoirApplyIcon, null)), /*#__PURE__*/React.createElement(Avatar, {
    className: classes.groupIcon,
    src: img
  })), caption));
};
AppFee.propTypes = {
  college: PropTypes.object.isRequired,
  appConfig: PropTypes.object,
  userAppProfile: PropTypes.object,
  isInStudentApp: PropTypes.bool,
  onCheckFeeWaiverEligibility: PropTypes.func,
  onFindFreeSchools: PropTypes.func,
  onUnauthedFeeWaiverModal: PropTypes.func,
  classes: PropTypes.object
};
const isInternational$5 = college => {
  const country = get(college, 'Country');
  return !isEqual(country, 'United States');
};
const getAppMethods = (college, hasStartedApplying, onStartApplying) => {
  const commonApp = get(college, 'Admissions.CommonForm');
  const admissions = get(college, 'Admissions');
  const scoirApplyEnabled = get(college, 'DisplayAsScoirApply', false);
  if (admissions == null) {
    return [];
  }
  let rounds = [{
    Name: 'Common App',
    IsAccepted: commonApp === 'yes' || commonApp === true,
    Image: img$2
  }];
  let scrApply = {
    Name: 'Scoir',
    IsAccepted: scoirApplyEnabled,
    Child: /*#__PURE__*/React.createElement(ScoirApplyIcon, null)
  };
  if (scoirApplyEnabled && !hasStartedApplying && !isUndefined(onStartApplying)) {
    scrApply.Cta = 'Get Started';
  }
  rounds.unshift(scrApply);
  if (isInternational$5(college)) {
    const ucasApp = get(college, 'InternationalSchool.UCASSForm');
    rounds.push({
      Name: 'Universities and Colleges Admissions Service',
      IsAccepted: ucasApp === 'yes' || ucasApp === true,
      Image: img$1
    });
  }
  return rounds;
};
const AppMethod = _ref2 => {
  let {
    college,
    appConfig,
    userAppProfile,
    onReportHasContent,
    hasStartedApplying,
    onStartApplying,
    onUnauthedFeeWaiverModal,
    onCheckFeeWaiverEligibility,
    onFindFreeSchools,
    isInStudentApp
  } = _ref2;
  const classes = useStyles$9();
  const rows = getAppMethods(college, hasStartedApplying, onStartApplying);
  const hasContent = !isEmpty(rows);
  useCallbackOnMount(() => {
    onReportHasContent(hasContent);
  }, [hasContent]);
  return !hasContent ? null : /*#__PURE__*/React.createElement(Paper, {
    elevation: 0
  }, /*#__PURE__*/React.createElement(AppFee, {
    college: college,
    appConfig: appConfig,
    userAppProfile: userAppProfile,
    isInStudentApp: isInStudentApp,
    onUnauthedFeeWaiverModal: onUnauthedFeeWaiverModal,
    onCheckFeeWaiverEligibility: onCheckFeeWaiverEligibility,
    onFindFreeSchools: onFindFreeSchools,
    classes: classes
  }), /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, /*#__PURE__*/React.createElement("strong", null, "Application Method"))), /*#__PURE__*/React.createElement(TableCell, null))), /*#__PURE__*/React.createElement(TableBody, null, rows.map(row => /*#__PURE__*/React.createElement(TableRow, {
    key: row.Name,
    className: classes.row
  }, /*#__PURE__*/React.createElement(TableCell, {
    width: "50%",
    component: "th",
    scope: "row"
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Avatar, {
    src: row.Image,
    className: classes.icon
  }, row.Child), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, row.Name))), isUndefined(row.Cta) && /*#__PURE__*/React.createElement(TableCell, {
    width: "50%"
  }, /*#__PURE__*/React.createElement(YesNo, {
    value: row.IsAccepted
  })), !isUndefined(row.Cta) && /*#__PURE__*/React.createElement(TableCell, {
    width: "50%"
  }, /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    variant: "contained",
    onClick: onStartApplying
  }, row.Cta)))))));
};
AppMethod.propTypes = {
  college: PropTypes.object.isRequired,
  appConfig: PropTypes.object,
  userAppProfile: PropTypes.object,
  onReportHasContent: PropTypes.func.isRequired,
  hasStartedApplying: PropTypes.bool.isRequired,
  onStartApplying: PropTypes.func,
  onCheckFeeWaiverEligibility: PropTypes.func,
  onFindFreeSchools: PropTypes.func,
  isInStudentApp: PropTypes.bool,
  onUnauthedFeeWaiverModal: PropTypes.func
};
var AppMethod$1 = withContext(AppMethod, Context$2);

const tabA11y = index => ({
  id: `test-policy-tab-${index}`,
  'aria-controls': `test-policy-tabpanel-${index}`
});
const tabPanelA11y = index => ({
  id: `test-policy-tabpanel-${index}`,
  'aria-labelledby': `test-policy-tab-${index}`
});
const TestPolicy = _ref => {
  let {
    firstYear,
    transfer,
    optionalMessage
  } = _ref;
  const needsTabs = !!transfer && firstYear !== transfer;
  const startingIdx = needsTabs && !firstYear ? 1 : 0;
  const [selectedIndex, setSelectedIndex] = useState(startingIdx);
  const handleChange = useCallback((evt, idx) => {
    setSelectedIndex(idx);
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, needsTabs && /*#__PURE__*/React.createElement(Tabs, {
    "aria-label": "test policy types",
    value: selectedIndex,
    indicatorColor: "primary",
    textColor: "primary",
    onChange: handleChange,
    variant: "fullWidth"
  }, /*#__PURE__*/React.createElement(Tab, _extends({}, tabA11y(0), {
    disabled: !firstYear,
    label: "First-Year"
  })), /*#__PURE__*/React.createElement(Tab, _extends({}, tabA11y(1), {
    label: "Transfer"
  }))), /*#__PURE__*/React.createElement(Box, {
    pt: needsTabs ? 1 : 2
  }, /*#__PURE__*/React.createElement(TabPanel, _extends({}, tabPanelA11y(0), {
    hidden: selectedIndex !== 0,
    policy: firstYear,
    optionalMessage: optionalMessage
  })), /*#__PURE__*/React.createElement(TabPanel, _extends({}, tabPanelA11y(1), {
    hidden: selectedIndex !== 1,
    policy: transfer,
    optionalMessage: optionalMessage
  }))));
};
const policyPropTypes = PropTypes.oneOf(['required', 'optional', 'blind']);
TestPolicy.propTypes = {
  firstYear: policyPropTypes,
  transfer: policyPropTypes,
  optionalMessage: PropTypes.string
};
const TabPanel = _ref2 => {
  let {
    policy,
    optionalMessage,
    ...rest
  } = _ref2;
  const [open, setOpen] = useState(false);
  let innerds = null;
  if (policy === 'required') {
    innerds = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "body1"
    }, "Requires Tests"), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      color: "textSecondary"
    }, "Test scores must be submitted as part of the application"));
  } else if (policy === 'optional') {
    innerds = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "body1"
    }, "Test-Optional"), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      color: "textSecondary"
    }, "Submitting test scores as part of the application is optional"), optionalMessage && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Button, {
      color: "primary",
      variant: "text",
      onClick: () => setOpen(true)
    }, "Learn more")), /*#__PURE__*/React.createElement(DismissibleDialog, {
      open: open,
      onClose: noop,
      headerText: "Test-Optional Policy"
    }, /*#__PURE__*/React.createElement(DismissibleDialog.Body, null, /*#__PURE__*/React.createElement("p", {
      dangerouslySetInnerHTML: {
        __html: optionalMessage
      }
    })), /*#__PURE__*/React.createElement(DismissibleDialog.Footer, null, /*#__PURE__*/React.createElement(DismissibleDialog.Footer.PrimaryActionButton, {
      onClick: () => setOpen(false)
    }, "Got it")))));
  } else if (policy === 'blind') {
    innerds = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "body1"
    }, "Test-Free"), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      color: "textSecondary"
    }, "Test scores will not be used as part of the application evaluation (even if submitted)"));
  }
  return /*#__PURE__*/React.createElement(Box, rest, innerds);
};
TabPanel.propTypes = {
  policy: policyPropTypes,
  optionalMessage: string
};

const useStyles$8 = makeStyles(theme => ({
  row: {
    '&:last-child td': {
      borderBottom: 0
    },
    '&:last-child th': {
      borderBottom: 0
    }
  },
  icon: {
    marginRight: theme.spacing(2),
    minWidth: '1em'
  },
  required: {
    visibility: 'visible',
    color: theme.palette.success.light
  },
  notrequired: {
    visibility: 'hidden'
  },
  noMaxWidth: {
    maxWidth: 'none'
  }
}));
const getRequirements = college => {
  const requirementFields = [{
    label: 'Essay/Statement',
    field: 'ApplicationDetails.SupplementalRequirements.EssayOrStatement.Value'
  }, {
    label: 'SAT/ACT',
    field: 'ApplicationDetails.StandardizedTests.SATorACT.Value'
  }, {
    label: 'With Writing',
    field: 'ApplicationDetails.StandardizedTests.WithWriting.Value'
  }, {
    label: 'Subject Tests',
    field: 'ApplicationDetails.StandardizedTests.SubjectTests.Value'
  }, {
    label: 'Resume',
    field: 'ApplicationDetails.SupplementalRequirements.Resume.Value'
  }, {
    label: 'Portfolio',
    field: 'ApplicationDetails.SupplementalRequirements.Portfolio.Value'
  }, {
    label: 'Interview',
    field: 'ApplicationDetails.SupplementalRequirements.Interview.Value'
  }, {
    label: 'Audition or Portfolio Review',
    field: 'ApplicationDetails.SupplementalRequirements.AuditionOrPortfolioReview.Value'
  }];
  const ignoredValues = ['NotSpecified', ''];
  const requirements = reject(requirementFields.map(field => ({
    label: field.label,
    value: replace(get(college, field.field, ''), 'NotRequired', 'Not Required')
  })), item => includes(ignoredValues, item.value));
  return {
    requirements,
    hasRequirements: !isEmpty(requirements),
    hasRequired: requirements.some(requirement => requirement.value === 'Required')
  };
};
const getScoirApplyTestPolicies = college => {
  if (!college.TestPolicy) {
    return [];
  }
  return [college.TestPolicy.FirstYearPolicy, college.TestPolicy.TransferPolicy, college.TestPolicy.OptionalMessage];
};
const AppRequirements = _ref => {
  let {
    college,
    onReportHasContent
  } = _ref;
  const classes = useStyles$8();
  const {
    requirements,
    hasRequirements,
    hasRequired
  } = getRequirements(college);
  const [firstYearPolicy, transferPolicy, optionalMessage] = getScoirApplyTestPolicies(college);
  const hasTestPolicies = !!firstYearPolicy || !!transferPolicy;
  const isTestOptional = get(college, 'TestOptional', false);
  const tooltipText = 'Some majors may have additional requirements that are not listed here.';
  useCallbackOnMount(() => {
    onReportHasContent(hasRequirements);
  }, [hasRequirements]);
  return !hasRequirements ? null : /*#__PURE__*/React.createElement(Paper, {
    elevation: 0
  }, isTestOptional && !hasTestPolicies && /*#__PURE__*/React.createElement(Box, {
    m: 2,
    pt: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "textPrimary"
  }, "Test-Optional"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "textSecondary"
  }, "Submitting test scores as part of the application is optional")), hasTestPolicies && /*#__PURE__*/React.createElement(Box, {
    m: 2
  }, /*#__PURE__*/React.createElement(TestPolicy, {
    firstYear: firstYearPolicy,
    transfer: transferPolicy,
    optionalMessage: optionalMessage
  })), /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, /*#__PURE__*/React.createElement("strong", null, "Application Item", ' ', isTestOptional && !get(college, 'ScoirApplyEnabled', false) && /*#__PURE__*/React.createElement(React.Fragment, null, "\xA0", /*#__PURE__*/React.createElement(Info, {
    "data-testid": "test-optional-info",
    className: classes.noMaxWidth,
    "aria-label": tooltipText
  }, tooltipText))))), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, /*#__PURE__*/React.createElement("strong", null, "Requirement"))))), /*#__PURE__*/React.createElement(TableBody, null, requirements.map(row => /*#__PURE__*/React.createElement(TableRow, {
    key: row.label,
    className: classes.row
  }, /*#__PURE__*/React.createElement(TableCell, {
    width: "50%",
    component: "th",
    scope: "row"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, row.label)), /*#__PURE__*/React.createElement(TableCell, {
    width: "50%"
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center"
  }, !hasRequired ? null : /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    size: "sm",
    icon: faAsterisk,
    className: cn(classes.icon, row.value == 'Required' ? classes.required : classes.notrequired)
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "textPrimary"
  }, row.value))))))));
};
AppRequirements.propTypes = {
  college: PropTypes.object.isRequired,
  onReportHasContent: PropTypes.func.isRequired
};
var AppRequirements$1 = withContext(AppRequirements, Context$2);

const DeadlinesAndDetails = _ref => {
  let {
    onReportHasContent
  } = _ref;
  const currentAppCycle = useCurrentAppCycle();
  const {
    hasContent,
    hasEnoughReports,
    reportHasContent
  } = useReportHasContent(3);
  useCallbackOnMount(() => {
    if (hasEnoughReports) {
      onReportHasContent(hasContent);
    }
  }, [hasEnoughReports, hasContent]);
  return hasEnoughReports && !hasContent ? null : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SectionTitle, {
    title: `${currentAppCycle ? `${currentAppCycle - 1}-${currentAppCycle} ` : ''}Application Deadlines and Details`,
    titleProps: {
      component: 'h3'
    }
  }), /*#__PURE__*/React.createElement(Box, {
    mt: 3
  }, /*#__PURE__*/React.createElement(TwoColumnGrid, null, /*#__PURE__*/React.createElement(AppRounds$1, {
    onReportHasContent: reportHasContent
  }), /*#__PURE__*/React.createElement(AppMethod$1, {
    onReportHasContent: reportHasContent
  }), /*#__PURE__*/React.createElement(AppRequirements$1, {
    onReportHasContent: reportHasContent
  }))));
};
DeadlinesAndDetails.propTypes = {
  onReportHasContent: PropTypes.func.isRequired
};

const contentType$2 = CONTENT_TYPES.ADMISSIONS;
const FeaturedPosts$2 = _ref => {
  let {
    onReportHasContent
  } = _ref;
  return /*#__PURE__*/React.createElement(ContentSection$1, {
    title: "Learn More About Our Admissions Process",
    contentType: contentType$2,
    onReportHasContent: onReportHasContent
  });
};
FeaturedPosts$2.propTypes = {
  onReportHasContent: PropTypes.func.isRequired
};

const Admissions = () => {
  const {
    admissionsPage
  } = useEventTracking();
  const {
    hasContent,
    hasEnoughReports,
    reportHasContent
  } = useReportHasContent(3);
  return /*#__PURE__*/React.createElement(Metadata, {
    value: admissionsPage
  }, hasEnoughReports && /*#__PURE__*/React.createElement(EmptyState$1, {
    isEmpty: !hasContent
  }), /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(Box, {
    mb: 3
  }, /*#__PURE__*/React.createElement(StudentStatistics$1, {
    onReportHasContent: reportHasContent
  }))), /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(Box, {
    mb: 3
  }, /*#__PURE__*/React.createElement(DeadlinesAndDetails, {
    onReportHasContent: reportHasContent
  }))), /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(FeaturedPosts$2, {
    onReportHasContent: reportHasContent
  })));
};

const useStyles$7 = makeStyles({
  row: {
    '&:last-child td': {
      borderBottom: 0
    },
    '&:last-child th': {
      borderBottom: 0
    }
  },
  noMaxWidth: {
    maxWidth: 'none'
  }
});
const TuitionAndFees = _ref => {
  let {
    college,
    costAidHeader,
    onReportHasContent
  } = _ref;
  const classes = useStyles$7();
  const {
    hasData,
    data
  } = getExpenses(college);
  useCallbackOnMount(() => {
    onReportHasContent(hasData);
  }, [hasData]);
  return /*#__PURE__*/React.createElement(TwoColumnTable, {
    headerContent: costAidHeader,
    head1: "Undergraduate Expenses",
    head2: /*#__PURE__*/React.createElement(React.Fragment, null, "Charge \xA0", /*#__PURE__*/React.createElement(Info, {
      tooltipProps: {
        classes: {
          tooltip: classes.noMaxWidth
        }
      }
    }, "Charges for full-time undergraduates before aid (if eligible).")),
    data: data
  });
};
TuitionAndFees.propTypes = {
  college: PropTypes.object.isRequired,
  costAidHeader: PropTypes.element,
  onReportHasContent: PropTypes.func.isRequired
};
var TuitionAndFees$1 = withContext(TuitionAndFees, Context$2);

const useStyles$6 = makeStyles({
  li: {
    paddingTop: '0px',
    paddingBottom: '0px'
  }
});
const DataPointList = _ref => {
  let {
    subheader,
    data
  } = _ref;
  const classes = useStyles$6();
  return isEmpty(data) ? null : /*#__PURE__*/React.createElement(Paper, {
    elevation: 0
  }, /*#__PURE__*/React.createElement(List, {
    subheader: subheader && /*#__PURE__*/React.createElement(ListSubheader, null, subheader)
  }, map(data, (item, idx) => {
    return /*#__PURE__*/React.createElement(ListItem, {
      className: classes.li,
      key: idx,
      disableGutters: true,
      dense: true
    }, /*#__PURE__*/React.createElement(DataPoint, {
      title: item.title,
      theme: DATA_POINT_WHITE,
      tooltipContents: item.tooltipContents,
      datum: item.datum,
      avatarProps: isUndefined(item.icon) ? undefined : {
        fallbackIcon: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
          icon: item.icon
        })
      }
    }));
  })));
};
DataPointList.propTypes = {
  subheader: PropTypes.string,
  data: PropTypes.array
};

const TITLES = {
  finAid: 'Students Receiving Financial Aid',
  fedLoans: 'Students Receiving Federal Loans',
  avgDebt: 'Average Student Debt Upon Graduation'
};
const TOOL_TIP_CONTENTS = {
  finAid: 'Percentage of students receiving any form of aid, including grants, scholarships, and federal student loans.'
};
const ICONS = {
  finAid: faHandHoldingUsd,
  fedLoans: faMoneyCheckAlt,
  avgDebt: faPiggyBank
};
const formatDollars$1 = value => {
  const rounded = Math.round(value);
  return !isUndefined(rounded) && rounded > 0 ? toDollars(rounded) : NOT_REPORTED;
};
const formatPct = value => {
  const rounded = Math.round(value);
  return !isUndefined(rounded) && rounded > 0 ? toPercentage(rounded) : NOT_REPORTED;
};
const getData$2 = function () {
  let college = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const finAid = get(college, 'FinancialAid.PcFinAidReceived', 0);
  const fedLoans = get(college, 'FinancialAid.PcFedLoansReceived', 0);
  const avgDebt = get(college, 'FinancialAid.DebtBalanceMedian', 0);
  const hasFinAid = finAid > 0;
  const hasFedLoans = fedLoans > 0;
  const hasAvgDebt = avgDebt > 0;
  const hasData = hasFinAid || hasFedLoans || hasAvgDebt;
  return {
    hasData,
    data: !hasData ? [] : reject([{
      datum: formatPct(finAid),
      title: TITLES.finAid,
      tooltipContents: TOOL_TIP_CONTENTS.finAid,
      icon: ICONS.finAid
    }, {
      datum: formatPct(fedLoans),
      title: TITLES.fedLoans,
      icon: ICONS.fedLoans
    }, {
      datum: formatDollars$1(avgDebt),
      title: TITLES.avgDebt,
      icon: ICONS.avgDebt
    }], item => !item)
  };
};

const ValueAndAffordability = _ref => {
  let {
    college,
    onReportHasContent
  } = _ref;
  const {
    hasData,
    data
  } = getData$2(college);
  useCallbackOnMount(() => {
    onReportHasContent(hasData);
  }, [hasData]);
  return /*#__PURE__*/React.createElement(DataPointList, {
    subheader: "Financial Aid Averages",
    data: data
  });
};
ValueAndAffordability.propTypes = {
  college: PropTypes.object.isRequired,
  onReportHasContent: PropTypes.func.isRequired
};
var ValueAndAffordability$1 = withContext(ValueAndAffordability, Context$2);

const contentType$1 = CONTENT_TYPES.COST_FINANCIAL_AID;
const FeaturedPosts$1 = _ref => {
  let {
    onReportHasContent
  } = _ref;
  return /*#__PURE__*/React.createElement(ContentSection$1, {
    title: "Learn More About Our Value and Affordability",
    contentType: contentType$1,
    onReportHasContent: onReportHasContent
  });
};
FeaturedPosts$1.propTypes = {
  onReportHasContent: PropTypes.func.isRequired
};

const INCOMES = ['$30,000 or below', '$30,000 to $48,000', '$48,000 to $75,000', '$75,000 to $110,000', '$110,000 and above'];
const AVG_NET_PRICE = 'Average Net Price';
const formatDollars = value => {
  const rounded = Math.round(value);
  return !isUndefined(rounded) && rounded > 0 ? toDollars(rounded) : NOT_REPORTED;
};
const isInternational$4 = college => {
  const country = get(college, 'Country');
  return !isEqual(country, 'United States');
};
const getData$1 = function () {
  let college = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const income1 = get(college, 'NetPrice.Income1', 0);
  const income2 = get(college, 'NetPrice.Income2', 0);
  const income3 = get(college, 'NetPrice.Income3', 0);
  const income4 = get(college, 'NetPrice.Income4', 0);
  const income5 = get(college, 'NetPrice.Income5', 0);
  const hasIncome1 = income1 > 0;
  const hasIncome2 = income2 > 0;
  const hasIncome3 = income3 > 0;
  const hasIncome4 = income4 > 0;
  const hasIncome5 = income5 > 0;
  const isDomestic = !isInternational$4(college);
  const netPrice = get(college, 'NetPrice.NetAverage', 0);
  const hasNetPrice = netPrice > 0;
  const hasHeader = hasNetPrice && isDomestic;
  const hasIncomeLevels = hasIncome1 || hasIncome2 || hasIncome3 || hasIncome4 || hasIncome5;
  const hasData = hasIncomeLevels || hasHeader;
  return {
    hasData,
    data: !hasIncomeLevels ? [] : [{
      value: formatDollars(income1),
      title: INCOMES[0]
    }, {
      value: formatDollars(income2),
      title: INCOMES[1]
    }, {
      value: formatDollars(income3),
      title: INCOMES[2]
    }, {
      value: formatDollars(income4),
      title: INCOMES[3]
    }, {
      value: formatDollars(income5),
      title: INCOMES[4]
    }],
    headerData: !hasHeader ? undefined : {
      title: AVG_NET_PRICE,
      value: formatDollars(netPrice)
    }
  };
};

const IncomeBands = _ref => {
  let {
    college,
    onReportHasContent
  } = _ref;
  const {
    hasData,
    data
  } = getData$1(college);
  useCallbackOnMount(() => {
    onReportHasContent(hasData);
  }, [hasData]);
  return /*#__PURE__*/React.createElement(TwoColumnTable, {
    head1: "Household Income",
    head2: "Average Net Price",
    data: data
  });
};
IncomeBands.propTypes = {
  college: PropTypes.object.isRequired,
  onReportHasContent: PropTypes.func.isRequired
};
var IncomeBands$1 = withContext(IncomeBands, Context$2);

const useStyles$5 = makeStyles(theme => ({
  root: {
    boxShadow: 'none',
    display: 'flex',
    flexDirection: 'column-reverse',
    '&.Mui-expanded': {
      marginTop: 0
    },
    '&::before': {
      backgroundColor: 'transparent'
    }
  },
  detailsRoot: {
    padding: 0,
    '& > div': {
      width: '100%'
    }
  },
  expandIcon: {
    color: theme.palette.primary.main
  },
  summaryContent: {
    flexGrow: 0,
    paddingLeft: '1.75rem'
  },
  summaryRoot: {
    color: theme.palette.primary.main,
    justifyContent: 'flex-start'
  }
}));
const IncomeBandAccordion = _ref => {
  let {
    onReportHasContent
  } = _ref;
  const [label, setLabel] = useState('Show Net Price by Income');
  const onChange = (event, expanded) => {
    const label = `${expanded ? 'Hide' : 'Show'} Net Price by Income`;
    setLabel(label);
  };
  const classes = useStyles$5();
  const expandIcon = /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faChevronDown,
    size: "xs"
  });
  return /*#__PURE__*/React.createElement(Accordion, {
    onChange: onChange,
    classes: {
      root: classes.root
    }
  }, /*#__PURE__*/React.createElement(AccordionSummary, {
    expandIcon: expandIcon,
    classes: {
      content: classes.summaryContent,
      expandIcon: classes.expandIcon,
      root: classes.summaryRoot
    }
  }, label), /*#__PURE__*/React.createElement(AccordionDetails, {
    classes: {
      root: classes.detailsRoot
    }
  }, /*#__PURE__*/React.createElement(IncomeBands$1, {
    onReportHasContent: onReportHasContent
  })));
};
IncomeBandAccordion.propTypes = {
  onReportHasContent: PropTypes.func
};

const CostAid = () => {
  const {
    costAidPage
  } = useEventTracking();
  const {
    hasContent,
    hasEnoughReports,
    reportHasContent
  } = useReportHasContent(4);
  return /*#__PURE__*/React.createElement(Metadata, {
    value: costAidPage
  }, hasEnoughReports && /*#__PURE__*/React.createElement(EmptyState$1, {
    isEmpty: !hasContent
  }), /*#__PURE__*/React.createElement(ErrorBoundary, null, hasEnoughReports && hasContent && /*#__PURE__*/React.createElement(SectionTitle, {
    title: "Cost Breakdown",
    titleProps: {
      component: 'h3'
    }
  }), /*#__PURE__*/React.createElement(Box, {
    mt: 3
  }, /*#__PURE__*/React.createElement(TwoColumnGrid, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TuitionAndFees$1, {
    onReportHasContent: reportHasContent
  }), /*#__PURE__*/React.createElement(IncomeBandAccordion, {
    onReportHasContent: reportHasContent
  })), /*#__PURE__*/React.createElement(ValueAndAffordability$1, {
    onReportHasContent: reportHasContent
  })))), /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(FeaturedPosts$1, {
    onReportHasContent: reportHasContent
  })));
};

const getIsTwoYear = college => {
  const degrees = get(college, 'Degrees', []);
  return degrees.length === 1 && degrees.includes('Associates');
};
const getFullTime = college => {
  const rawPercent = get(college, 'StudentBody.FullTimePct', 0);
  const hasPercent = rawPercent > 0;
  const percent = hasPercent ? `${toPercentage(rawPercent)} of students seek a degree with a full-time courseload` : NOT_REPORTED;
  return {
    fullTime: percent,
    hasFullTime: hasPercent
  };
};
const getReturned = college => {
  const rawReturned = get(college, 'AcademicExperience.PcReturned', 0);
  const hasReturned = rawReturned > 0;
  const returned = hasReturned ? `${toPercentage(rawReturned)} students return sophomore year` : NOT_REPORTED;
  return {
    returned,
    hasReturned
  };
};
const getTransferToFourYear = college => {
  const rawTransfer = get(college, 'AcademicExperience.Pc2to4', 0);
  const hasTransfer = rawTransfer > 0;
  const transfer = hasTransfer ? `${toPercentage(rawTransfer)} of students transfer to a 4-year college` : NOT_REPORTED;
  return {
    transfer,
    hasTransfer
  };
};
const getList$1 = function () {
  let college = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const isTwoYear = getIsTwoYear(college);
  const {
    fullTime,
    hasFullTime
  } = getFullTime(college);
  const {
    returned,
    hasReturned
  } = getReturned(college);
  const {
    transfer,
    hasTransfer
  } = getTransferToFourYear(college);
  return reject([hasFullTime && {
    icon: faUserClock,
    primaryText: 'Full-Time Undergrads',
    secondaryText: fullTime
  }, !isTwoYear && hasReturned && {
    icon: faRedo,
    primaryText: 'Retention',
    secondaryText: returned
  }, isTwoYear && hasTransfer && {
    icon: faRandom,
    primaryText: 'Transfer to 4-year',
    secondaryText: transfer
  }], item => !item);
};

const Facts = _ref => {
  let {
    college,
    onReportHasContent
  } = _ref;
  const list = getList$1(college);
  const hasList = !isEmpty(list);
  useCallbackOnMount(() => {
    onReportHasContent(hasList);
  }, [hasList]);
  return !hasList ? null : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Paper, {
    elevation: 0
  }, /*#__PURE__*/React.createElement(ColumnLists, {
    subheader: "Student Facts",
    lists: [list]
  })));
};
Facts.propTypes = {
  college: PropTypes.object.isRequired,
  onReportHasContent: PropTypes.func.isRequired
};
var Facts$1 = withContext(Facts, Context$2);

const EnrollmentAndFacts = _ref => {
  let {
    onReportHasContent
  } = _ref;
  const {
    hasContent,
    hasEnoughReports,
    reportHasContent
  } = useReportHasContent(2);
  useCallbackOnMount(() => {
    if (hasEnoughReports) {
      onReportHasContent(hasContent);
    }
  }, [hasEnoughReports, hasContent]);
  return (!hasEnoughReports || hasContent) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HideIfEmpty, {
    component: Box,
    mb: GUTTER$1
  }, /*#__PURE__*/React.createElement(Enrollment$1, {
    onReportHasContent: reportHasContent
  })), /*#__PURE__*/React.createElement(HideIfEmpty, {
    component: Box,
    mb: GUTTER$1
  }, /*#__PURE__*/React.createElement(Facts$1, {
    onReportHasContent: reportHasContent
  })));
};
EnrollmentAndFacts.propTypes = {
  onReportHasContent: PropTypes.func.isRequired
};

const getReligion = college => {
  const religion = get(college, 'GeneralInfo.OthRelig');
  const hasReligion = !isUndefined(religion) && !isEmpty(religion) && religion != 'Not applicable';
  return {
    religion,
    hasReligion
  };
};
const getCampusType = college => {
  const campusType = get(college, 'Setting');
  return {
    campusType,
    hasCampusType: !isUndefined(campusType) && campusType != 'Not available'
  };
};
const isInternational$3 = college => {
  const country = get(college, 'Country');
  return !isEqual(country, 'United States');
};
const getOnCampusHousing = college => {
  if (!isInternational$3(college)) {
    return false;
  }
  return get(college, 'GeneralInfo.HasOnCampusHousing', false);
};
const getList = function () {
  let college = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const isHbcu = get(college, 'GeneralInfo.HBCU', false);
  const {
    schoolType,
    schoolTypeDescription,
    hasSchoolType
  } = getSchoolType(college);
  const {
    religion,
    hasReligion
  } = getReligion(college);
  const {
    campusType,
    hasCampusType
  } = getCampusType(college);
  const hasOnCampusHousing = getOnCampusHousing(college);
  return reject([hasSchoolType && {
    icon: faUniversity,
    primaryText: schoolType,
    secondaryText: schoolTypeDescription
  }, isHbcu && {
    icon: faUniversity,
    primaryText: 'HBCU',
    secondaryText: 'Recognized as a Historically Black College & University'
  }, hasReligion && {
    icon: faUniversity,
    primaryText: 'Religious Affiliation',
    secondaryText: religion
  }, hasCampusType && {
    icon: faBuilding,
    primaryText: 'Campus Type',
    secondaryText: campusType
  }, hasOnCampusHousing && {
    icon: faHouse,
    primaryText: 'College-Provided Housing',
    secondaryText: 'Student residences are provided'
  }], item => !item);
};

const CampusLife = _ref => {
  let {
    college,
    onReportHasContent
  } = _ref;
  const list = getList(college);
  const hasList = !isEmpty(list);
  useCallbackOnMount(() => {
    onReportHasContent(hasList);
  }, [hasList]);
  return !hasList ? null : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Paper, {
    elevation: 0
  }, /*#__PURE__*/React.createElement(ColumnLists, {
    subheader: "Campus Life",
    lists: [list]
  })));
};
CampusLife.propTypes = {
  college: PropTypes.object.isRequired,
  onReportHasContent: PropTypes.func.isRequired
};
var CampusLife$1 = withContext(CampusLife, Context$2);

const StudentBody = _ref => {
  let {
    onReportHasContent
  } = _ref;
  const {
    hasContent,
    hasEnoughReports,
    reportHasContent
  } = useReportHasContent(2);
  useCallbackOnMount(() => {
    if (hasEnoughReports) {
      onReportHasContent(hasContent);
    }
  }, [hasEnoughReports, hasContent]);
  return (!hasEnoughReports || hasContent) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SectionTitle, {
    title: "Student Body Statistics",
    titleProps: {
      component: 'h3'
    }
  }), /*#__PURE__*/React.createElement(Box, {
    mt: 3
  }, /*#__PURE__*/React.createElement(TwoColumnGrid, null, /*#__PURE__*/React.createElement(EnrollmentAndFacts, {
    onReportHasContent: reportHasContent
  }), /*#__PURE__*/React.createElement(CampusLife$1, {
    onReportHasContent: reportHasContent
  }))));
};
StudentBody.propTypes = {
  onReportHasContent: PropTypes.func.isRequired
};

const getFieldPercentage$1 = (college, field) => {
  const num = Math.round(get(college, field, 0));
  return {
    num,
    percentage: toPercentage(num)
  };
};
const isInternational$2 = college => {
  const country = get(college, 'Country');
  return !isEqual(country, 'United States');
};
const getPercentages$1 = college => {
  if (isInternational$2(college)) {
    return [];
  }
  const list = reject([{
    ethnicity: 'White',
    ...getFieldPercentage$1(college, 'StudentBody.CaucasianPct')
  }, {
    ethnicity: 'Black/African American',
    ...getFieldPercentage$1(college, 'StudentBody.BlackPct')
  }, {
    ethnicity: 'Asian',
    ...getFieldPercentage$1(college, 'StudentBody.AsianPct')
  }, {
    ethnicity: 'Hispanic/Latino',
    ...getFieldPercentage$1(college, 'StudentBody.HispanicPct')
  }, {
    ethnicity: 'American Indian and Alaska Native',
    ...getFieldPercentage$1(college, 'StudentBody.AmIndianPct')
  }], item => item.num === 0);
  return orderBy(list, ['num', 'ethnicity'], ['desc', 'asc']);
};
const useStyles$4 = makeStyles({
  row: {
    '&:last-child td': {
      borderBottom: 0
    },
    '&:last-child th': {
      borderBottom: 0
    }
  }
});
const EthnicDiversity = _ref => {
  let {
    college,
    onReportHasContent
  } = _ref;
  const classes = useStyles$4();
  const list = getPercentages$1(college);
  const hasContent = !isEmpty(list);
  useCallbackOnMount(() => {
    onReportHasContent(hasContent);
  }, [hasContent]);
  return !hasContent ? null : /*#__PURE__*/React.createElement(Paper, {
    elevation: 0
  }, /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, /*#__PURE__*/React.createElement("strong", null, "Race and Ethnicity"))), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, /*#__PURE__*/React.createElement("strong", null, "% of Undergrads"))))), /*#__PURE__*/React.createElement(TableBody, null, list.map(row => /*#__PURE__*/React.createElement(TableRow, {
    key: row.ethnicity,
    className: classes.row
  }, /*#__PURE__*/React.createElement(TableCell, {
    width: "50%",
    component: "th",
    scope: "row"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, row.ethnicity)), /*#__PURE__*/React.createElement(TableCell, {
    width: "50%"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "textPrimary"
  }, row.percentage)))))));
};
EthnicDiversity.propTypes = {
  college: PropTypes.object.isRequired,
  onReportHasContent: PropTypes.func.isRequired
};
var EthnicDiversity$1 = withContext(EthnicDiversity, Context$2);

const isInternational$1 = college => {
  const country = get(college, 'Country');
  return !isEqual(country, 'United States');
};
const getPercentages = college => {
  if (isInternational$1(college)) {
    return [];
  }
  const stateInfo = take(get(college, 'GeographicDiversity', []), 5);
  const list = stateInfo.map(item => {
    const num = Math.round(item.Percent * 100);
    return {
      state: item.State,
      percentage: toPercentage(num),
      num
    };
  });
  const onlyFilledValues = reject(list, item => item.num === 0);
  const sorted = orderBy(onlyFilledValues, ['num', 'State'], ['desc', 'asc']);
  return sorted;
};
const useStyles$3 = makeStyles({
  row: {
    '&:last-child td': {
      borderBottom: 0
    },
    '&:last-child th': {
      borderBottom: 0
    }
  }
});
const GeographicDiversity = _ref => {
  let {
    college,
    onReportHasContent
  } = _ref;
  const classes = useStyles$3();
  const list = getPercentages(college);
  const hasContent = !isEmpty(list);
  useCallbackOnMount(() => {
    onReportHasContent(hasContent);
  }, [hasContent]);
  return !hasContent ? null : /*#__PURE__*/React.createElement(Paper, {
    elevation: 0
  }, /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, /*#__PURE__*/React.createElement("strong", null, "Geographic Location"))), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, /*#__PURE__*/React.createElement("strong", null, "% of Undergrads"))))), /*#__PURE__*/React.createElement(TableBody, null, list.map(row => /*#__PURE__*/React.createElement(TableRow, {
    key: row.state,
    className: classes.row
  }, /*#__PURE__*/React.createElement(TableCell, {
    width: "50%",
    component: "th",
    scope: "row"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, row.state)), /*#__PURE__*/React.createElement(TableCell, {
    width: "50%"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "textPrimary"
  }, row.percentage)))))));
};
GeographicDiversity.propTypes = {
  college: PropTypes.object.isRequired,
  onReportHasContent: PropTypes.func.isRequired
};
var GeographicDiversity$1 = withContext(GeographicDiversity, Context$2);

const getFieldPercentage = (college, field) => {
  const rawPercent = get(college, field, 0);
  const hasPercent = rawPercent > 0;
  const percent = hasPercent ? toPercentage(rawPercent) : NOT_REPORTED;
  return {
    percent,
    hasPercent
  };
};
const useStyles$2 = makeStyles({
  row: {
    '&:last-child td': {
      borderBottom: 0
    },
    '&:last-child th': {
      borderBottom: 0
    }
  }
});
const GenderDiversity = _ref => {
  let {
    college,
    onReportHasContent
  } = _ref;
  const classes = useStyles$2();
  const {
    percent: femalePercent,
    hasPercent: hasFemalePercent
  } = getFieldPercentage(college, 'StudentBody.FemalePct');
  const {
    percent: malePercent,
    hasPercent: hasMalePercent
  } = getFieldPercentage(college, 'StudentBody.MalePct');
  const hasContent = hasFemalePercent || hasMalePercent;
  useCallbackOnMount(() => {
    onReportHasContent(hasContent);
  }, [hasContent]);
  const rows = [{
    title: 'Female',
    value: femalePercent,
    isValid: hasFemalePercent
  }, {
    title: 'Male',
    value: malePercent,
    isValid: hasMalePercent
  }];
  return !hasContent ? null : /*#__PURE__*/React.createElement(Paper, {
    elevation: 0
  }, /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, /*#__PURE__*/React.createElement("strong", null, "Gender"))), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, /*#__PURE__*/React.createElement("strong", null, "% of Undergrads"))))), /*#__PURE__*/React.createElement(TableBody, null, rows.map(row => /*#__PURE__*/React.createElement(TableRow, {
    key: row.title,
    className: classes.row
  }, /*#__PURE__*/React.createElement(TableCell, {
    width: "50%",
    component: "th",
    scope: "row"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, row.title)), /*#__PURE__*/React.createElement(TableCell, {
    width: "50%"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: row.isValid ? 'textPrimary' : 'textSecondary'
  }, row.value)))))));
};
GenderDiversity.propTypes = {
  college: PropTypes.object.isRequired,
  onReportHasContent: PropTypes.func.isRequired
};
var GenderDiversity$1 = withContext(GenderDiversity, Context$2);

const getPercentage = college => {
  const percentage = Math.round(get(college, 'InternationalSchool.IntlPct', 0));
  return {
    hasValue: percentage > 0,
    value: toPercentage(percentage)
  };
};
const useStyles$1 = makeStyles({
  row: {
    '&:last-child td': {
      borderBottom: 0
    },
    '&:last-child th': {
      borderBottom: 0
    }
  }
});
const InternationalDiversity = _ref => {
  let {
    college,
    onReportHasContent
  } = _ref;
  const classes = useStyles$1();
  const {
    hasValue,
    value
  } = getPercentage(college);
  useCallbackOnMount(() => {
    onReportHasContent(hasValue);
  }, [hasValue]);
  return !hasValue ? null : /*#__PURE__*/React.createElement(Paper, {
    elevation: 0
  }, /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, /*#__PURE__*/React.createElement("strong", null, "International Students"))), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, /*#__PURE__*/React.createElement("strong", null, "% of Undergrads"))))), /*#__PURE__*/React.createElement(TableBody, null, /*#__PURE__*/React.createElement(TableRow, {
    className: classes.row
  }, /*#__PURE__*/React.createElement(TableCell, {
    width: "50%",
    component: "th",
    scope: "row"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, "International Students")), /*#__PURE__*/React.createElement(TableCell, {
    width: "50%"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "textPrimary"
  }, value))))));
};
InternationalDiversity.propTypes = {
  college: PropTypes.object.isRequired,
  onReportHasContent: PropTypes.func.isRequired
};
var InternationalDiversity$1 = withContext(InternationalDiversity, Context$2);

const isInternational = college => {
  const country = get(college, 'Country');
  return !isEqual(country, 'United States');
};
const Diversity = _ref => {
  let {
    college,
    onReportHasContent
  } = _ref;
  const international = isInternational(college);
  const {
    hasContent,
    hasEnoughReports,
    reportHasContent
  } = useReportHasContent(international ? 4 : 3);
  useCallbackOnMount(() => {
    if (hasEnoughReports) {
      onReportHasContent(hasContent);
    }
  }, [hasEnoughReports, hasContent]);
  return (!hasEnoughReports || hasContent) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SectionTitle, {
    titleProps: {
      component: 'h3'
    },
    title: "Diversity of Enrolled Students"
  }), /*#__PURE__*/React.createElement(Box, {
    mt: 3
  }, /*#__PURE__*/React.createElement(TwoColumnGrid, null, /*#__PURE__*/React.createElement(EthnicDiversity$1, {
    onReportHasContent: reportHasContent
  }), /*#__PURE__*/React.createElement(GenderDiversity$1, {
    onReportHasContent: reportHasContent
  }), /*#__PURE__*/React.createElement(GeographicDiversity$1, {
    onReportHasContent: reportHasContent
  }), international && /*#__PURE__*/React.createElement(InternationalDiversity$1, {
    onReportHasContent: reportHasContent
  }))));
};
Diversity.propTypes = {
  college: PropTypes.object.isRequired,
  onReportHasContent: PropTypes.func.isRequired
};
var Diversity$1 = withContext(Diversity, Context$2);

const AIR_FORCE = 'Air Force';
const ARMY = 'Army';
const NAVY = 'Navy';
const getData = function () {
  let college = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const rotc = get(college, 'Rotc', []);
  const fields = {};
  for (var i = 0; i < rotc.length; i++) {
    fields[rotc[i]] = true;
  }
  const hasData = !isEmpty(fields);
  return {
    hasData,
    data: !hasData ? [] : [{
      title: AIR_FORCE,
      value: /*#__PURE__*/React.createElement(YesNo, {
        value: get(fields, AIR_FORCE, false)
      })
    }, {
      title: ARMY,
      value: /*#__PURE__*/React.createElement(YesNo, {
        value: get(fields, ARMY, false)
      })
    }, {
      title: NAVY,
      value: /*#__PURE__*/React.createElement(YesNo, {
        value: get(fields, NAVY, false)
      })
    }]
  };
};

const RotcPrograms = _ref => {
  let {
    college,
    onReportHasContent
  } = _ref;
  const {
    hasData,
    data
  } = getData(college);
  useCallbackOnMount(() => {
    onReportHasContent(hasData);
  }, [hasData]);
  return /*#__PURE__*/React.createElement(TwoColumnTable, {
    head1: "ROTC Programs",
    head2: "Offered?",
    data: data
  });
};
RotcPrograms.propTypes = {
  college: PropTypes.object.isRequired,
  onReportHasContent: PropTypes.func.isRequired
};
var RotcPrograms$1 = withContext(RotcPrograms, Context$2);

const useStyles = makeStyles(() => ({
  gradientTop: {
    background: 'linear-gradient(to bottom, rgba(255,255,255,1) 2%,rgba(255,255,255,1) 60%,rgba(255,255,255,0) 100%)',
    pointerEvents: 'none',
    zIndex: 2
  },
  gradientBottom: {
    background: 'linear-gradient(rgba(255,255,255,0), rgba(255,255,255,0.75))',
    pointerEvents: 'none',
    zIndex: 2
  }
}));
const TopBottomGradients = _ref => {
  let {
    children,
    scrollBoxRef
  } = _ref;
  const classes = useStyles();
  const scrollBox = scrollBoxRef.current;
  const shouldShowGradients = scrollBox?.scrollHeight > scrollBox?.offsetHeight;
  const shouldHideGradients = useMemo(() => !shouldShowGradients, [shouldShowGradients]);
  return shouldHideGradients ? /*#__PURE__*/React.createElement("div", null, children) : /*#__PURE__*/React.createElement(Box, {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    height: "100%"
  }, /*#__PURE__*/React.createElement(Box, {
    position: "absolute",
    height: "60px",
    width: "100%",
    top: "0",
    className: classes.gradientTop
  }), children, /*#__PURE__*/React.createElement(Box, {
    position: "absolute",
    height: "40px",
    width: "100%",
    bottom: "0",
    className: classes.gradientBottom
  }));
};
TopBottomGradients.propTypes = {
  children: PropTypes.node,
  scrollBoxRef: PropTypes.object
};

//All sport values in our system need an icon
const icons = {
  "Acrobatics and Tumbling": faChild,
  "Gymnastics": faChild,
  "Baseball": faBaseball,
  "Softball": faBaseball,
  "Basketball": faBasketballHoop,
  "Beach Volleyball": faVolleyballBall,
  "Water Polo": faVolleyballBall,
  "Volleyball": faVolleyballBall,
  "Bowling": faBowlingPins,
  "Cheerleading": faMegaphone,
  "Cricket": faCricket,
  "Cross Country": faRunning,
  "Indoor Track": faRunning,
  "Track, Indoor": faRunning,
  "Outdoor Track": faRunning,
  "Track, Outdoor": faRunning,
  "Triathalon": faRunning,
  "Esports": faGamepadAlt,
  "Equestrian": faHorseSaddle,
  "Polo": faHorseSaddle,
  "Fencing": faSwords,
  "Field Hockey": faFieldHockey,
  "Football": faFootballBall,
  "Lightweight Football": faFootballBall,
  "Football, Lightweight": faFootballBall,
  "Rugby": faFootballBall,
  "Golf": faGolfClub,
  "Ice Hockey": faHockeySticks,
  "Lacrosse": faCircle,
  "Lightweight Crew": faWater,
  "Crew, Lightweight": faWater,
  "Lightweight Rowing": faWater,
  "Rowing, Lightweight": faWater,
  "Rowing": faWater,
  "Sailing": faWater,
  "Pistol": faBullseye,
  "Rifle": faBullseye,
  "Rodeo": faSkullCow,
  "Skiing": faSkiing,
  "Soccer": faFutbol,
  "Squash": faRacquet,
  "Tennis": faRacquet,
  "Wrestling": faHandsHelping,
  "Swimming and Diving": faSwimmer,
  "Synchronized Swimming": faSwimmer
};

const getConfigs = sports => {
  return sports.map(sport => {
    const name = sport.Name;
    const divisions = sport.Divisions;
    return {
      iconComponent: /*#__PURE__*/React.createElement(Box, {
        width: "32px",
        display: "flex",
        justifyContent: "center"
      }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: icons[name] || faMedal
      })),
      primaryText: name,
      secondaryText: /*#__PURE__*/React.createElement(React.Fragment, null, divisions.map(division => /*#__PURE__*/React.createElement(React.Fragment, {
        key: division
      }, division, /*#__PURE__*/React.createElement("br", null))))
    };
  });
};
const useList = function () {
  let Sports = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const alphabeticalSports = useMemo(() => {
    const sports = Sports.Sports || [];
    return produce(sports, draft => {
      draft.sort((a, b) => {
        const nameA = a.Name;
        const nameB = b.Name;
        return nameA < nameB ? -1 : 1;
      });
    });
  }, [Sports]);
  const hasSports = alphabeticalSports.length > 0;
  return !hasSports ? [] : getConfigs(alphabeticalSports);
};

const MIN_LIST_WRAP_LIMIT = 5;
const Athletics = _ref => {
  let {
    college,
    onReportHasContent
  } = _ref;
  const list = useList(college.Sports);
  const listLength = list.length;
  const hasData = listLength > 0;
  const isSmallScreen = useBreakpoint('sm', 'down');
  const shouldWrapList = useMemo(() => listLength > MIN_LIST_WRAP_LIMIT && !isSmallScreen, [listLength, isSmallScreen]);
  const scrollBoxRef = React.useRef(null);
  const {
    listA,
    listB
  } = useMemo(() => {
    const half = Math.ceil(listLength / 2);
    const listA = shouldWrapList ? list.slice(0, half) : list;
    const listB = shouldWrapList ? list.slice(half, listLength) : [];
    return {
      listA,
      listB
    };
  }, [list, listLength, shouldWrapList]);
  useCallbackOnMount(() => {
    onReportHasContent(hasData);
  }, [hasData]);
  return /*#__PURE__*/React.createElement(Paper, {
    elevation: 0
  }, /*#__PURE__*/React.createElement(TopBottomGradients, {
    scrollBoxRef: scrollBoxRef
  }, /*#__PURE__*/React.createElement(Box, {
    ref: scrollBoxRef,
    maxHeight: isSmallScreen ? 'auto' : '480px',
    overflow: 'hidden scroll'
  }, /*#__PURE__*/React.createElement(TwoColumnGrid, null, /*#__PURE__*/React.createElement(ColumnLists, {
    subheader: 'Varsity Athletics',
    subheaderProps: {
      disableSticky: false,
      style: {
        zIndex: 2
      }
    },
    lists: [listA]
  }), /*#__PURE__*/React.createElement(ColumnLists, {
    subheader: /*#__PURE__*/React.createElement("span", null, "\xA0"),
    subheaderProps: {
      disableSticky: true
    },
    lists: [listB]
  })))));
};
Athletics.propTypes = {
  college: PropTypes.object.isRequired,
  onReportHasContent: PropTypes.func.isRequired
};
var Athletics$1 = withContext(Athletics, Context$2);

const ProgramsAndAthletics = _ref => {
  let {
    onReportHasContent
  } = _ref;
  const {
    hasContent,
    hasEnoughReports,
    reportHasContent
  } = useReportHasContent(2);
  const [hasROTC, setHasROTC] = useState(false);
  const [hasAthletics, setHasAthletics] = useState(false);
  useCallbackOnMount(() => {
    if (hasEnoughReports) {
      onReportHasContent(hasContent);
    }
  }, [hasEnoughReports, hasContent]);
  const hideROTC = hasEnoughReports && !hasROTC;
  const hideAthletics = hasEnoughReports && !hasAthletics;
  return (!hasEnoughReports || hasContent) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SectionTitle, {
    title: "Programs and Athletics",
    titleProps: {
      component: 'h3'
    }
  }), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 3
  }, hideROTC ? null : /*#__PURE__*/React.createElement(Grid, {
    item: true,
    sm: 6,
    xs: 12
  }, /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(RotcPrograms$1, {
    onReportHasContent: value => {
      reportHasContent(value);
      setHasROTC(value);
    }
  }))), hideAthletics ? null : /*#__PURE__*/React.createElement(Grid, {
    item: true,
    sm: 6,
    xs: 12
  }, /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(Athletics$1, {
    onReportHasContent: value => {
      reportHasContent(value);
      setHasAthletics(value);
    }
  }))))));
};
ProgramsAndAthletics.propTypes = {
  onReportHasContent: PropTypes.func.isRequired
};

const contentType = CONTENT_TYPES.STUDENT_LIFE;
const FeaturedPosts = _ref => {
  let {
    onReportHasContent
  } = _ref;
  return /*#__PURE__*/React.createElement(ContentSection$1, {
    title: "Learn More About Student Life",
    contentType: contentType,
    onReportHasContent: onReportHasContent
  });
};
FeaturedPosts.propTypes = {
  onReportHasContent: PropTypes.func.isRequired
};

const StudentLife = () => {
  const {
    hasContent,
    hasEnoughReports,
    reportHasContent
  } = useReportHasContent(4);
  const eventTracking = useEventTracking();
  return /*#__PURE__*/React.createElement(React.Fragment, null, hasEnoughReports && /*#__PURE__*/React.createElement(EmptyState$1, {
    isEmpty: !hasContent
  }), /*#__PURE__*/React.createElement(StudentBody, {
    onReportHasContent: reportHasContent
  }), /*#__PURE__*/React.createElement(Diversity$1, {
    onReportHasContent: reportHasContent
  }), /*#__PURE__*/React.createElement(ProgramsAndAthletics, {
    onReportHasContent: reportHasContent
  }), /*#__PURE__*/React.createElement(Metadata, {
    value: get(eventTracking, 'studentLifePage')
  }, /*#__PURE__*/React.createElement(FeaturedPosts, {
    onReportHasContent: reportHasContent
  })));
};

const ProfileRoutes = _ref => {
  let {
    scid,
    section,
    hasCollege,
    isProspectOnly,
    sectionsConfiguration,
    children,
    getCollegesPath
  } = _ref;
  const {
    SECTIONS,
    INDEXES
  } = sectionsConfiguration;
  const sanitizedSection = section.replace(/\//g, '');
  const routeUrl = getCollegesPath(scid);
  const isMissingCollege = !hasCollege || isProspectOnly;
  const [initialScroll, setInitialScroll] = useState(false);
  const greaterThan = useHeightTrackerValue(PROFILE_HEADER_HEIGHT_TRACKER_ID);
  const scrollToNavPoint = greaterThan - HEIGHT_OF_STICKY + 5; // the five makes it so that the sticky header is visible

  useCallbackOnMount(() => {
    const shouldScrollToTop = !initialScroll;
    const shouldScrollToNav = window$1.scrollY > scrollToNavPoint;
    if (shouldScrollToTop || shouldScrollToNav) {
      window$1.scrollTo({
        top: shouldScrollToTop ? 0 : scrollToNavPoint,
        left: 0,
        behavior: 'smooth'
      });
    }
    if (shouldScrollToTop) {
      setInitialScroll(true);
    }
  }, [sanitizedSection]);
  return /*#__PURE__*/React.createElement(Container, {
    maxWidth: "lg"
  }, /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    py: 3,
    m: 0,
    minHeight: "80vh"
  }, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Redirect, {
    exact: true,
    from: `${routeUrl}//${sanitizedSection}`,
    to: `${routeUrl}/${sanitizedSection}`
  }), /*#__PURE__*/React.createElement(Redirect, {
    exact: true,
    from: `${routeUrl}/`,
    to: `${routeUrl}/${sanitizedSection}`
  }), /*#__PURE__*/React.createElement(Redirect, {
    exact: true,
    from: routeUrl,
    to: `${routeUrl}/${sanitizedSection}`
  }), isMissingCollege ? /*#__PURE__*/React.createElement(EmptyState$1, {
    isEmpty: true
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, map(INDEXES, idx => {
    const {
      endpoint,
      Component
    } = SECTIONS[idx];
    return /*#__PURE__*/React.createElement(Route, {
      path: `${routeUrl}/${endpoint}`,
      key: idx,
      render: props => /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(Component, _extends({}, props, {
        section: endpoint
      })))
    });
  }), children))));
};
ProfileRoutes.propTypes = {
  scid: PropTypes.number,
  getCollegesPath: PropTypes.func,
  section: PropTypes.string,
  hasCollege: PropTypes.bool,
  isProspectOnly: PropTypes.bool,
  sectionsConfiguration: PropTypes.object.isRequired,
  children: PropTypes.node
};
var index = withContext(ProfileRoutes, Context$2);

export { Academics, Admissions, Context$2 as CollegeProfileContext, CollegeProfileContextWrapper, ContentCarousel, CostAid, DisplayScoirApplyIcon, Footer, HeightTracker$1 as HeightTracker, Context$1 as HeightTrackerContext, HeightTrackerContextWrapper, LoadingState, index$1 as Overview, ProfileHeaderContainer as ProfileHeader, index as ProfileRoutes, StudentLife, getIsProspectOnly, getProfileSectionsConfiguration, preferenceMatchStateConstants, useEventTracking, useHasCollege, useHeightTrackerValue, useLoading, useOnContentPlayVideo, useScid, useTopNavigationHeightTrackerId };
//# sourceMappingURL=index.module.js.map
